/* ============================================================
   Oakley op sterkte — configurator
   Hoort bij de sectie oakley-op-sterkte.liquid
   Plaats dit bestand in de map Assets van je thema.
   ============================================================ */
// Basispad van de Shopify CDN — los gezet omdat het anders honderden keren
// herhaald wordt en het bestand daarmee boven Shopify's limiet van 256 kB komt.
const CDN = "https://cdn.shopify.com/s/files/1/0860/1000/3782/files/";

// ============================================================
// TAAL DETECTIE
// ============================================================
const TAAL = (() => {
  const pad = window.location.pathname;
  if (pad.startsWith('/en/')) return 'en';
  if (pad.startsWith('/de/')) return 'de';
  return 'nl';
})();

const TEKSTEN = {
  nl: {
    briltype: 'Kies je briltype',
    sportbril: 'Sportbril',
    zonnebril: 'Zonnebril',
    model: 'Kies je model',
    montuurkleur: 'Kies je montuurkleur',
    correctie: 'Kies type correctie',
    enkelvoudig: 'Enkelvoudig',
    enkelvoudigInfo: 'Één sterkte, ideaal voor sport',
    progressief: 'Progressief',
    progressiefInfo: 'Multifocaal, dichtbij én ver zien',
    glastype: 'Kies je glastype',
    authenticsInfo: "Oakley's eigen zonneglas",
    transitionsInfo: 'Automatisch verkleurend glas',
    lenskleur: 'Kies je lenskleur',
    nietGepol: 'Niet gepolariseerd',
    gepol: 'Gepolariseerd ✦',
    lenstype: 'Lenstype',
    sterkte: 'Vul je sterkte in',
    odSph: 'Rechts (OD) Sferisch',
    osSph: 'Links (OS) Sferisch',
    odCyl: 'Rechts (OD) Cilinder',
    osCyl: 'Links (OS) Cilinder',
    odAs: 'Rechts (OD) As',
    osAs: 'Links (OS) As',
    pdRechts: 'PD rechts (mm)',
    pdLinks: 'PD links (mm)',
    additie: 'Additie (leessterkte)',
    additieRechts: 'Additie rechts',
    additieLinks: 'Additie links',
    pdNietBekend: 'Ik weet mijn pupilafstand (PD) niet',
    pdInfo: 'Mocht je aangegeven hebben dat je de PD niet weet, dan zal onze klantenservice na je bestelling contact met je opnemen.',
    receptUpload: 'Of upload je brilrecept (optioneel)',
    uploadTekstA: 'Klik om te uploaden',
    uploadTekstB: 'of stuur later per e-mail',
    uploadTekst: '<strong>Klik om te uploaden</strong> of stuur later per e-mail',
    authenticsComplex: 'Authentics Complex',
    transitions: 'Transitions',
    receptInfo: 'PDF, JPG of PNG',
    geenRecept: 'ℹ️ Geen recept bij de hand?',
    geenReceptMsg: 'Je kunt je recept ook na bestelling per e-mail sturen naar info@sportbrillenshop.nl',
    montuurLabel: 'Montuur',
    glazenLabel: 'Glazen',
    glastypeLabel: 'Glastype',
    kortingLabel: '10% korting',
    totaalLabel: 'Totaal',
    retourCheck: 'Ik begrijp dat, vanwege een op maat gemaakt artikel, mijn standaard recht op retourneren vervalt.',
    bestelKnop: 'Toevoegen aan winkelwagen',
    chatKnop: '💬 Vragen? Chat met ons',
    chatMsg: 'Onze opticiëns helpt je graag: 0524-123456 of chat met ons',
    bekijkBril: 'Bekijk bril',
    vanaf: 'Vanaf',
    maakKeuzes: 'Maak je keuzes hieronder',
    lichtBinnen: '🏠 Licht (binnen)',
    donkerFelleZon: '☀️ Donker (felle zon)',
    bekijkVerkleurt: 'Bekijk hoe de lens verkleurt:',
    toegevoegd: '✓ Toegevoegd!',
    bezig: 'Bezig...',
    paginaTitel: 'Oakley op sterkte',
    breadcrumbHome: 'Home',
    uitstekend: 'Uitstekend',
    reviewsIntro: 'Meer dan 1.400 geverifieerde reviews',
    watOnzeKlanten: 'Wat onze klanten zeggen',
    reviewsAantal: '— meer dan 1.400 reviews op Trusted Shops',
    bekijkAllereview: 'Bekijk alle reviews op Trusted Shops →',
    bekijkBeoordelingen: 'Bekijk beoordelingen ›',
    reviewsModalSub: 'Meer dan 1.400 geverifieerde beoordelingen op Trusted Shops',
    reviewsModalIntro: 'Onze klanten beoordelen ons gemiddeld met een 4,92 van de 5. Alle reviews zijn geverifieerd en gecontroleerd door Trusted Shops. Hieronder zie je de actuele beoordelingen, live bijgewerkt.',
    vulAlleVelden: 'Vul alle velden in voordat je bestelt.',
    review1Titel: 'Snelle en persoonlijke verzending',
    review1Tekst: 'Snelle levering, persoonlijk e-mailtje vooraf en geleverd in stevige verpakking met handgeschreven kaartje en wat snoepjes. Mooie bril besteld met goede prijs t.o.v. andere webwinkels. Hier kan je zeker bestellen!',
    review1Meta: 'Geverifieerde klant · jun 2026',
    review2Titel: 'Uitstekende service',
    review2Tekst: 'Ik ben een fan en fervent gebruiker van Oakley sportbrillen. Supersnel geleverd en met persoonlijke noot. Ik kan Sportbrillenshop van harte aanbevelen!',
    review2Meta: 'Barry M. · Geverifieerde klant · mei 2026',

    // ---- Aanvullende vertalingen ----
    toegevoegdWinkelwagen: '✓ Toegevoegd aan winkelwagen!',
    nogInvullen: 'Nog invullen',
    keuzesHierboven: 'Maak eerst je keuzes hierboven af.',
    retourKort: 'akkoord met de retourvoorwaarden',
    highRxKort: 'de vraag over sterkte hoger dan +2.0',
    combinatieTeHoog: 'Deze combinatie van sferisch en cilinder valt buiten het bereik van dit glas.',
    transitieLicht: 'licht',
    transitieDonker: 'donker',
    populairsteModellen: 'Onze populairste modellen op sterkte - bel of mail ons voor nog meer mogelijkheden!',
    clearInfo: 'Transparant glas',
    glasdikteTitel: 'Kies glasdikte',
    dikte150: '1.50 Slim',
    dikte159: '1.59 - 1.60 Thin',
    dikte167: '1.67 Extra Thin',
    dikte150Info: 'Maximale sterkte: +1.50 tot -1.50',
    dikte159Info: 'Maximale sterkte: +4.00 tot -4.00',
    dikte167Info: 'Maximale sterkte: +7.00 tot -7.00',
    meestGekozen: 'Meest gekozen',
    coatingTitel: 'Kies coating',
    stealthInfo: 'Coating tegen schittering en reflecties - inbegrepen',
    stealthProInfo: 'Premium coating tegen schittering, water- en vuilafstotend',
    sterkteNietGevonden: 'Staat je sterkte er niet bij, neem contact met ons op voor de mogelijkheden.',
    kiesPlaceholder: '— Kies —',
    geen: 'Geen',
    receptVraag: 'Heeft u een brilrecept?',
    mailReceptKnop: 'Mail mijn brilrecept',
    knopWerktNiet: 'Werkt de knop niet? Stuur uw recept rechtstreeks naar <a href="#" id="btnWebmailKeuze" class="tekst-link" style="text-decoration:underline;">service@sportbrillenshop.nl</a> via uw eigen e-mailprogramma.',
    receptGemaild: 'Ik heb mijn brilrecept gemaild.',
    highRxVraag: 'Is uw sterkte hoger dan +2.0, of is sferisch + cilinder samen lager dan -3.0?',
    ja: 'Ja',
    nee: 'Nee',
    highRxToeslagMelding: 'Er wordt €20,- extra in rekening gebracht voor High RX glazen.',
    ctaMail: '📧 Mail ons',
    ctaAfspraak: '📅 Maak een afspraak',
    afspraakTitel: 'Maak een afspraak',
    webmailTitel: 'Kies uw e-mailprogramma',
    sluiten: 'Sluiten',
    chatGeslotenTitel: 'Chat is momenteel gesloten',
    chatOpeningstijden: 'Onze openingstijden zijn:',
    chatDiVr: 'Di t/m vr:',
    chatZa: 'Zaterdag:',
    chatMorgenOpen: 'We zijn morgen weer open van 9:00 tot 17:30.',
    chatDinsdagOpen: 'We zijn dinsdag weer open van 9:00 tot 17:30.',
    chatMailKnop: '📧 Stuur ons een e-mail',
    infoH1: 'Oakley zonnebrillen op sterkte',
    infoP1: 'Wanneer u sterkte in een bril nodig hebt, denkt u al snel dat een Oakley niet meer kan. Een Oakley op sterkte is voor ons echter geen enkel probleem. Doordat wij een onderdeel zijn van De Jong Optiek in Wolvega hebben we veel ervaring op dit gebied. Er zijn veel mogelijkheden en om de goede keus te maken geven wij u graag persoonlijk advies in de winkel, via de mail (<a href="mailto:service@sportbrillenshop.nl" class="tekst-link">service@sportbrillenshop.nl</a>) of telefonisch (<a href="tel:0561612631" class="tekst-link">0561-612631</a>). Het is natuurlijk maatwerk en wij willen graag dat u de goede keuze maakt. Voor veel mensen is de juiste keus maken lastig door de vele modellen en mogelijkheden. We hebben de meest populaire keuzes helemaal voor u uitgewerkt. Bovenstaand staan natuurlijk lang niet alle modellen en opties. Mocht u andere wensen hebben laat het ons dan weten! Er is nog veel meer mogelijk.',
    infoH2: 'Kom langs en laat u adviseren',
    infoP2: 'Het voordeel van langs komen in de winkel is dat we je kunnen laten zien hoe de combinatie is van de door jou gekozen glazen en het montuur. Daarnaast kunnen we een gratis oogmeting doen door onze optometrist om te kijken of je sterkte niet veranderd is.',
    infoH3: 'Hoe ziet een Oakley op sterkte eruit?',
    infoP3: 'Bij de meeste Oakley brillen wordt het hele glas op sterkte gemaakt. Het enige verschil is dat het glas mogelijk wat dikker is dan normaal. Dit is natuurlijk weer afhankelijk van uw sterkte. Bij de <a href="https://sportbrillenshop.nl/collections/oakley-radar-ev-path" class="tekst-link">Radar EV</a> en de <a href="https://sportbrillenshop.nl/collections/oakley-jawbreaker" class="tekst-link">Jawbreaker</a> ziet het er wel anders uit. Bij deze brillen worden er in het shield twee glaasjes gezet met de sterkte erin. Dit geeft hetzelfde effect als het glas op sterkte.',
    infoH4: 'Welke sterkte kan er in een Oakley en kan de Oakley ook multifocaal (progressief)?',
    infoP4: 'De maximale sterkte in een bril is per model verschillend. Wanneer je vragen hebt over een bril, is het handig dat je je sterkte en wensen er direct bij vermeldt. Wanneer Oakley de glazen niet kan maken hebben wij vaak nog andere alternatieven zodat de Oakley toch nog op sterkte kan. Multifocale glazen in een Oakley is ook geen enkel probleem. Als je laat weten wat je wensen zijn en wat je sterkte is dan kunnen wij je vertellen of dat ook daadwerkelijk mogelijk is.',
    infoH5: 'Hoeveel kost een Oakley op sterkte?',
    infoP5: 'De prijs van een Oakley op sterkte varieert tussen de 400 tot 1000 euro (inclusief montuur). Dit is weer afhankelijk van de kleur en het type glazen en/of de glazen bijvoorbeeld multifocaal moeten zijn.',
    infoH6: 'Neem contact op en wij geven u een vrijblijvend advies',
    infoP6: 'Bovenstaand kunt u de Oakley op sterkte direct bestellen. Wanneer u interesse heeft in een ander model Oakley op sterkte laat het ons dan per mail of telefonisch weten. Er is nog veel meer mogelijk. Als u uw sterkte al weet, vermeld dit dan direct bij het eerste contact. Zo kunnen we u nog beter adviseren. Als u liever telefonisch advies ontvangt, kan dat natuurlijk ook. Bel dan naar <a href="tel:0561612631" class="tekst-link">0561-612631</a>.',
  },
  en: {
    briltype: 'Choose your glasses type',
    sportbril: 'Sports glasses',
    zonnebril: 'Sunglasses',
    model: 'Choose your model',
    montuurkleur: 'Choose your frame colour',
    correctie: 'Choose correction type',
    enkelvoudig: 'Single vision',
    enkelvoudigInfo: 'One strength, ideal for sports',
    progressief: 'Progressive',
    progressiefInfo: 'Multifocal, near and far vision',
    glastype: 'Choose your lens type',
    authenticsInfo: "Oakley's own sun lens",
    transitionsInfo: 'Automatically darkening lens',
    lenskleur: 'Choose your lens colour',
    nietGepol: 'Non-polarised',
    gepol: 'Polarised ✦',
    lenstype: 'Lens type',
    sterkte: 'Enter your prescription',
    odSph: 'Right (OD) Sphere',
    osSph: 'Left (OS) Sphere',
    odCyl: 'Right (OD) Cylinder',
    osCyl: 'Left (OS) Cylinder',
    odAs: 'Right (OD) Axis',
    osAs: 'Left (OS) Axis',
    pdRechts: 'PD right (mm)',
    pdLinks: 'PD left (mm)',
    additie: 'Addition (reading strength)',
    additieRechts: 'Addition right',
    additieLinks: 'Addition left',
    pdNietBekend: 'I do not know my pupillary distance (PD)',
    pdInfo: 'If you have indicated that you do not know your PD, our customer service will contact you after your order.',
    receptUpload: 'Or upload your prescription (optional)',
    uploadTekstA: 'Click to upload',
    uploadTekstB: 'or send by email later',
    uploadTekst: '<strong>Click to upload</strong> or send by email later',
    authenticsComplex: 'Authentics Complex',
    transitions: 'Transitions',
    receptInfo: 'PDF, JPG or PNG',
    geenRecept: 'ℹ️ No prescription at hand?',
    geenReceptMsg: 'You can also send your prescription by email after ordering to info@sportbrillenshop.nl',
    montuurLabel: 'Frame',
    glazenLabel: 'Lenses',
    glastypeLabel: 'Lens type',
    kortingLabel: '10% discount',
    totaalLabel: 'Total',
    retourCheck: 'I understand that, as this is a custom-made item, my standard right of return does not apply.',
    bestelKnop: 'Add to cart',
    chatKnop: '💬 Questions? Chat with us',
    chatMsg: 'Our optician is happy to help: 0524-123456 or chat with us',
    bekijkBril: 'View glasses',
    vanaf: 'From',
    maakKeuzes: 'Make your choices below',
    lichtBinnen: '🏠 Light (indoors)',
    donkerFelleZon: '☀️ Dark (bright sun)',
    bekijkVerkleurt: 'See how the lens changes colour:',
    toegevoegd: '✓ Added!',
    bezig: 'Loading...',
    paginaTitel: 'Oakley Prescription Glasses',
    breadcrumbHome: 'Home',
    uitstekend: 'Excellent',
    reviewsIntro: 'More than 1,400 verified reviews',
    watOnzeKlanten: 'What our customers say',
    reviewsAantal: '— over 1,400 reviews on Trusted Shops',
    bekijkAllereview: 'View all reviews on Trusted Shops →',
    bekijkBeoordelingen: 'View reviews ›',
    reviewsModalSub: 'More than 1,400 verified reviews on Trusted Shops',
    reviewsModalIntro: 'Our customers rate us an average of 4.92 out of 5. All reviews are verified and checked by Trusted Shops. Below you can see the latest ratings, updated live.',
    vulAlleVelden: 'Please fill in all fields before ordering.',
    review1Titel: 'Fast and personal delivery',
    review1Tekst: 'Fast delivery, a personal email in advance, and delivered in sturdy packaging with a handwritten card and some sweets. Great glasses at a good price compared to other webshops. Highly recommend ordering here!',
    review1Meta: 'Verified customer · Jun 2026',
    review2Titel: 'Excellent service',
    review2Tekst: 'I am a big fan and frequent user of Oakley sports glasses. Delivered super fast with a personal note. I wholeheartedly recommend Sportbrillenshop!',
    review2Meta: 'Barry M. · Verified customer · May 2026',

    // ---- Aanvullende vertalingen ----
    toegevoegdWinkelwagen: '✓ Added to your cart!',
    nogInvullen: 'Still to complete',
    keuzesHierboven: 'Please complete your choices above first.',
    retourKort: 'agreement to the return conditions',
    highRxKort: 'the question about a prescription above +2.0',
    combinatieTeHoog: 'This combination of sphere and cylinder falls outside the range of this lens.',
    transitieLicht: 'light',
    transitieDonker: 'dark',
    populairsteModellen: 'Our most popular prescription models - call or email us for even more options!',
    clearInfo: 'Clear lens',
    glasdikteTitel: 'Choose lens thickness',
    dikte150: '1.50 Slim',
    dikte159: '1.59 - 1.60 Thin',
    dikte167: '1.67 Extra Thin',
    dikte150Info: 'Maximum prescription: +1.50 to -1.50',
    dikte159Info: 'Maximum prescription: +4.00 to -4.00',
    dikte167Info: 'Maximum prescription: +7.00 to -7.00',
    meestGekozen: 'Most chosen',
    coatingTitel: 'Choose coating',
    stealthInfo: 'Coating against glare and reflections - included',
    stealthProInfo: 'Premium coating against glare, water- and dirt-repellent',
    sterkteNietGevonden: 'Is your prescription not listed? Please contact us to discuss the options.',
    kiesPlaceholder: '— Choose —',
    geen: 'None',
    receptVraag: 'Do you have a prescription?',
    mailReceptKnop: 'Email my prescription',
    knopWerktNiet: 'Button not working? Send your prescription directly to <a href="#" id="btnWebmailKeuze" class="tekst-link" style="text-decoration:underline;">service@sportbrillenshop.nl</a> using your own email program.',
    receptGemaild: 'I have emailed my prescription.',
    highRxVraag: 'Is your prescription higher than +2.0, or is sphere + cylinder together lower than -3.0?',
    ja: 'Yes',
    nee: 'No',
    highRxToeslagMelding: 'An additional €20 will be charged for High RX lenses.',
    ctaMail: '📧 Email us',
    ctaAfspraak: '📅 Book an appointment',
    afspraakTitel: 'Book an appointment',
    webmailTitel: 'Choose your email program',
    sluiten: 'Close',
    chatGeslotenTitel: 'Chat is currently closed',
    chatOpeningstijden: 'Our opening hours are:',
    chatDiVr: 'Tue to Fri:',
    chatZa: 'Saturday:',
    chatMorgenOpen: 'We are open again tomorrow from 9:00 to 17:30.',
    chatDinsdagOpen: 'We are open again on Tuesday from 9:00 to 17:30.',
    chatMailKnop: '📧 Send us an email',
    infoH1: 'Oakley prescription sunglasses',
    infoP1: 'When you need prescription lenses, you might assume an Oakley is no longer an option. For us, a prescription Oakley is no problem at all. As part of De Jong Optiek in Wolvega, we have a great deal of experience in this field. There are many possibilities, and to help you make the right choice we are happy to advise you personally in our store, by email (<a href="mailto:service@sportbrillenshop.nl" class="tekst-link">service@sportbrillenshop.nl</a>) or by phone (<a href="tel:0561612631" class="tekst-link">+31 561 612631</a>). This is of course made to measure, and we want you to make the right choice. For many people that choice is difficult because of the many models and options, so we have worked out the most popular combinations for you. The selection above is far from all models and options. If you have other wishes, please let us know — much more is possible.',
    infoH2: 'Visit us for personal advice',
    infoP2: 'The advantage of visiting our store is that we can show you how your chosen lenses look in combination with the frame. We can also carry out a free eye test with our optometrist to check whether your prescription has changed.',
    infoH3: 'What does a prescription Oakley look like?',
    infoP3: 'With most Oakley glasses the entire lens is made to your prescription. The only difference is that the lens may be slightly thicker than usual, depending on your prescription. With the <a href="https://sportbrillenshop.nl/collections/oakley-radar-ev-path" class="tekst-link">Radar EV</a> and the <a href="https://sportbrillenshop.nl/collections/oakley-jawbreaker" class="tekst-link">Jawbreaker</a> it looks different: in these models two small prescription lenses are fitted inside the shield. This gives the same effect as a full prescription lens.',
    infoH4: 'Which prescriptions fit an Oakley, and can it be multifocal (progressive)?',
    infoP4: 'The maximum prescription differs per model. If you have questions about a specific pair, it helps to mention your prescription and your wishes right away. If Oakley cannot produce the lenses, we often have alternatives so the Oakley can still be made to your prescription. Multifocal lenses in an Oakley are no problem either. Let us know your wishes and your prescription and we will tell you whether it is possible.',
    infoH5: 'How much does a prescription Oakley cost?',
    infoP5: 'The price of a prescription Oakley varies between roughly 400 and 1,000 euros (including the frame). This depends on the colour and type of lenses and on whether the lenses need to be multifocal.',
    infoH6: 'Get in touch for free, no-obligation advice',
    infoP6: 'You can order your prescription Oakley directly above. If you are interested in a different Oakley model, let us know by email or phone — much more is possible. If you already know your prescription, please mention it in your first message so we can advise you even better. If you prefer advice by phone, that is of course also possible. Call <a href="tel:0561612631" class="tekst-link">+31 561 612631</a>.',
  },
  de: {
    briltype: 'Wähle deine Brillenart',
    sportbril: 'Sportbrille',
    zonnebril: 'Sonnenbrille',
    model: 'Wähle dein Modell',
    montuurkleur: 'Wähle deine Rahmenfarbe',
    correctie: 'Korrektionsart wählen',
    enkelvoudig: 'Einstärke',
    enkelvoudigInfo: 'Eine Stärke, ideal für Sport',
    progressief: 'Gleitsicht',
    progressiefInfo: 'Multifokale Gläser, nah und fern',
    glastype: 'Glastyp wählen',
    authenticsInfo: "Oakleys eigenes Sonnenglas",
    transitionsInfo: 'Automatisch abdunkelndes Glas',
    lenskleur: 'Wähle deine Glasfarbe',
    nietGepol: 'Nicht polarisiert',
    gepol: 'Polarisiert ✦',
    lenstype: 'Glastyp',
    sterkte: 'Gib deine Sehstärke ein',
    odSph: 'Rechts (OD) Sphäre',
    osSph: 'Links (OS) Sphäre',
    odCyl: 'Rechts (OD) Zylinder',
    osCyl: 'Links (OS) Zylinder',
    odAs: 'Rechts (OD) Achse',
    osAs: 'Links (OS) Achse',
    pdRechts: 'PD rechts (mm)',
    pdLinks: 'PD links (mm)',
    additie: 'Addition (Lesestärke)',
    additieRechts: 'Addition rechts',
    additieLinks: 'Addition links',
    pdNietBekend: 'Ich kenne meinen Pupillenabstand (PD) nicht',
    pdInfo: 'Falls Sie angegeben haben, dass Sie Ihren PD nicht kennen, wird unser Kundenservice Sie nach Ihrer Bestellung kontaktieren.',
    uploadTekstA: 'Zum Hochladen klicken',
    uploadTekstB: 'oder später per E-Mail senden',
    receptUpload: 'Oder laden Sie Ihr Rezept hoch (optional)',
    authenticsComplex: 'Authentics Complex',
    transitions: 'Transitions',
    uploadTekst: '<strong>Zum Hochladen klicken</strong> oder später per E-Mail senden',
    receptInfo: 'PDF, JPG oder PNG',
    geenRecept: 'ℹ️ Kein Rezept zur Hand?',
    geenReceptMsg: 'Sie können Ihr Rezept auch nach der Bestellung per E-Mail an info@sportbrillenshop.nl senden',
    montuurLabel: 'Rahmen',
    glazenLabel: 'Gläser',
    glastypeLabel: 'Glastyp',
    kortingLabel: '10% Rabatt',
    totaalLabel: 'Gesamt',
    retourCheck: 'Ich verstehe, dass bei einem maßgefertigten Artikel mein standardmäßiges Rückgaberecht entfällt.',
    bestelKnop: 'In den Warenkorb',
    chatKnop: '💬 Fragen? Chat mit uns',
    chatMsg: 'Unser Optiker hilft Ihnen gerne: 0524-123456 oder chatten Sie mit uns',
    bekijkBril: 'Brille ansehen',
    vanaf: 'Ab',
    maakKeuzes: 'Treffe deine Auswahl unten',
    lichtBinnen: '🏠 Hell (drinnen)',
    donkerFelleZon: '🌤️ Dunkel (helle Sonne)',
    bekijkVerkleurt: 'Sieh wie das Glas sich verfärbt:',
    toegevoegd: '✓ Hinzugefügt!',
    bezig: 'Wird geladen...',
    paginaTitel: 'Oakley Brillen auf Stärke',
    breadcrumbHome: 'Startseite',
    uitstekend: 'Ausgezeichnet',
    reviewsIntro: 'Mehr als 1.400 verifizierte Bewertungen',
    watOnzeKlanten: 'Was unsere Kunden sagen',
    reviewsAantal: '— über 1.400 Bewertungen auf Trusted Shops',
    bekijkAllereview: 'Alle Bewertungen auf Trusted Shops ansehen →',
    bekijkBeoordelingen: 'Bewertungen ansehen ›',
    reviewsModalSub: 'Mehr als 1.400 verifizierte Bewertungen auf Trusted Shops',
    reviewsModalIntro: 'Unsere Kunden bewerten uns im Durchschnitt mit 4,92 von 5. Alle Bewertungen sind von Trusted Shops geprüft. Unten sehen Sie die aktuellen Bewertungen, live aktualisiert.',
    vulAlleVelden: 'Bitte alle Felder ausfüllen bevor Sie bestellen.',
    review1Titel: 'Schneller und persönlicher Versand',
    review1Tekst: 'Schnelle Lieferung, persönliche E-Mail im Voraus und in stabiler Verpackung mit handgeschriebenem Kärtchen und Süßigkeiten geliefert. Tolle Brille zu einem guten Preis im Vergleich zu anderen Webshops. Hier kann man bedenkenlos bestellen!',
    review1Meta: 'Verifizierter Kunde · Jun 2026',
    review2Titel: 'Ausgezeichneter Service',
    review2Tekst: 'Ich bin ein großer Fan und regelmäßiger Nutzer von Oakley Sportbrillen. Superschnell geliefert und mit persönlicher Note. Ich kann Sportbrillenshop wärmstens empfehlen!',
    review2Meta: 'Barry M. · Verifizierter Kunde · Mai 2026',

    // ---- Aanvullende vertalingen ----
    toegevoegdWinkelwagen: '✓ Zum Warenkorb hinzugefügt!',
    nogInvullen: 'Noch auszufüllen',
    keuzesHierboven: 'Bitte vervollständigen Sie zuerst Ihre Auswahl oben.',
    retourKort: 'Zustimmung zu den Rückgabebedingungen',
    highRxKort: 'die Frage zur Stärke über +2.0',
    combinatieTeHoog: 'Diese Kombination aus Sphäre und Zylinder liegt außerhalb des Bereichs dieses Glases.',
    transitieLicht: 'hell',
    transitieDonker: 'dunkel',
    populairsteModellen: 'Unsere beliebtesten Modelle in Sehstärke - rufen Sie uns an oder schreiben Sie uns für noch mehr Möglichkeiten!',
    clearInfo: 'Klares Glas',
    glasdikteTitel: 'Glasdicke wählen',
    dikte150: '1.50 Slim',
    dikte159: '1.59 - 1.60 Thin',
    dikte167: '1.67 Extra Thin',
    dikte150Info: 'Maximale Stärke: +1.50 bis -1.50',
    dikte159Info: 'Maximale Stärke: +4.00 bis -4.00',
    dikte167Info: 'Maximale Stärke: +7.00 bis -7.00',
    meestGekozen: 'Am häufigsten gewählt',
    coatingTitel: 'Beschichtung wählen',
    stealthInfo: 'Beschichtung gegen Blendung und Reflexionen - inbegriffen',
    stealthProInfo: 'Premium-Beschichtung gegen Blendung, wasser- und schmutzabweisend',
    sterkteNietGevonden: 'Ist Ihre Stärke nicht dabei? Kontaktieren Sie uns für die Möglichkeiten.',
    kiesPlaceholder: '— Wählen —',
    geen: 'Keine',
    receptVraag: 'Haben Sie ein Brillenrezept?',
    mailReceptKnop: 'Mein Brillenrezept mailen',
    knopWerktNiet: 'Funktioniert der Button nicht? Senden Sie Ihr Rezept direkt an <a href="#" id="btnWebmailKeuze" class="tekst-link" style="text-decoration:underline;">service@sportbrillenshop.nl</a> über Ihr eigenes E-Mail-Programm.',
    receptGemaild: 'Ich habe mein Brillenrezept gemailt.',
    highRxVraag: 'Ist Ihre Stärke höher als +2.0 oder ist Sphäre + Zylinder zusammen niedriger als -3.0?',
    ja: 'Ja',
    nee: 'Nein',
    highRxToeslagMelding: 'Für High-RX-Gläser werden zusätzlich 20,- € berechnet.',
    ctaMail: '📧 Schreiben Sie uns',
    ctaAfspraak: '📅 Termin vereinbaren',
    afspraakTitel: 'Termin vereinbaren',
    webmailTitel: 'Wählen Sie Ihr E-Mail-Programm',
    sluiten: 'Schließen',
    chatGeslotenTitel: 'Der Chat ist derzeit geschlossen',
    chatOpeningstijden: 'Unsere Öffnungszeiten sind:',
    chatDiVr: 'Di bis Fr:',
    chatZa: 'Samstag:',
    chatMorgenOpen: 'Morgen sind wir wieder von 9:00 bis 17:30 Uhr für Sie da.',
    chatDinsdagOpen: 'Am Dienstag sind wir wieder von 9:00 bis 17:30 Uhr für Sie da.',
    chatMailKnop: '📧 Schreiben Sie uns eine E-Mail',
    infoH1: 'Oakley Sonnenbrillen in Sehstärke',
    infoP1: 'Wenn Sie eine Brille mit Sehstärke benötigen, denken Sie vielleicht, dass eine Oakley nicht mehr möglich ist. Für uns ist eine Oakley in Sehstärke jedoch überhaupt kein Problem. Da wir Teil von De Jong Optiek in Wolvega sind, haben wir auf diesem Gebiet viel Erfahrung. Es gibt viele Möglichkeiten, und um die richtige Wahl zu treffen, beraten wir Sie gerne persönlich in unserem Geschäft, per E-Mail (<a href="mailto:service@sportbrillenshop.nl" class="tekst-link">service@sportbrillenshop.nl</a>) oder telefonisch (<a href="tel:0561612631" class="tekst-link">+31 561 612631</a>). Es handelt sich natürlich um Maßarbeit, und wir möchten, dass Sie die richtige Wahl treffen. Für viele Menschen ist diese Wahl aufgrund der vielen Modelle und Optionen schwierig. Deshalb haben wir die beliebtesten Kombinationen für Sie ausgearbeitet. Oben finden Sie längst nicht alle Modelle und Optionen. Wenn Sie andere Wünsche haben, lassen Sie es uns wissen — es ist noch viel mehr möglich.',
    infoH2: 'Kommen Sie vorbei und lassen Sie sich beraten',
    infoP2: 'Der Vorteil eines Besuchs in unserem Geschäft ist, dass wir Ihnen zeigen können, wie die von Ihnen gewählten Gläser in Kombination mit der Fassung aussehen. Außerdem können wir eine kostenlose Augenmessung durch unseren Optometristen durchführen, um zu prüfen, ob sich Ihre Stärke verändert hat.',
    infoH3: 'Wie sieht eine Oakley in Sehstärke aus?',
    infoP3: 'Bei den meisten Oakley-Brillen wird das gesamte Glas in Ihrer Sehstärke gefertigt. Der einzige Unterschied ist, dass das Glas je nach Stärke etwas dicker sein kann. Bei der <a href="https://sportbrillenshop.nl/collections/oakley-radar-ev-path" class="tekst-link">Radar EV</a> und der <a href="https://sportbrillenshop.nl/collections/oakley-jawbreaker" class="tekst-link">Jawbreaker</a> sieht es anders aus: Bei diesen Modellen werden zwei kleine Gläser mit Ihrer Stärke in das Shield eingesetzt. Das ergibt denselben Effekt wie ein komplettes Glas in Sehstärke.',
    infoH4: 'Welche Stärke passt in eine Oakley und ist auch Gleitsicht möglich?',
    infoP4: 'Die maximale Stärke ist je nach Modell unterschiedlich. Wenn Sie Fragen zu einer bestimmten Brille haben, geben Sie Ihre Stärke und Ihre Wünsche am besten direkt mit an. Falls Oakley die Gläser nicht anfertigen kann, haben wir oft Alternativen, sodass die Oakley trotzdem in Sehstärke möglich ist. Gleitsichtgläser in einer Oakley sind ebenfalls kein Problem. Teilen Sie uns Ihre Wünsche und Ihre Stärke mit, und wir sagen Ihnen, ob es machbar ist.',
    infoH5: 'Was kostet eine Oakley in Sehstärke?',
    infoP5: 'Der Preis einer Oakley in Sehstärke liegt zwischen etwa 400 und 1.000 Euro (inklusive Fassung). Das hängt von der Farbe und der Art der Gläser ab und davon, ob die Gläser zum Beispiel Gleitsichtgläser sein sollen.',
    infoH6: 'Kontaktieren Sie uns für eine unverbindliche Beratung',
    infoP6: 'Oben können Sie Ihre Oakley in Sehstärke direkt bestellen. Wenn Sie sich für ein anderes Oakley-Modell interessieren, lassen Sie es uns per E-Mail oder telefonisch wissen — es ist noch viel mehr möglich. Wenn Sie Ihre Stärke bereits kennen, geben Sie diese bitte gleich beim ersten Kontakt an. So können wir Sie noch besser beraten. Wenn Sie lieber telefonisch beraten werden möchten, ist das natürlich auch möglich. Rufen Sie an unter <a href="tel:0561612631" class="tekst-link">+31 561 612631</a>.',
  }
};

const T = TEKSTEN[TAAL];

// ============================================================
// CONFIG — vul hier de prijzen in zodra je ze hebt
// Stel alles in op 0 als placeholder
// ============================================================
// ============================================================
// EYEJACKET REDUX — foto's
// Matte Black met Prizm Grey lens. Wordt gebruikt als modelminiatuur,
// montuurfoto Matte Black, lensfoto Prizm Grey en Prizm Grey Polarized.
// ============================================================
const EYEJACKET_MATTE_BLACK_PRIZM_GREY = CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Grey.jpg?v=1784655688";
const EYEJACKET_SILVER_PRIZM_GREY = CDN+"Oakley-Eyejacket-Redux-Op-Sterkte-Silver-Prizm-Grey.jpg?v=1784916536";

// ============================================================
// BISPHAERA — foto's
// Vul hier de bestandsnaam in van de foto die als modelminiatuur dient,
// bijvoorbeeld: CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Ruby.jpg?v=..."
// ============================================================
const BISPHAERA_MINIATUUR = CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Road.jpg?v=1784748441";

// ============================================================
// SPLIT SHOT — foto's
// ============================================================
const SPLITSHOT_MINIATUUR = CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Deep-Water.jpg?v=1784794359";

// ============================================================
// LATCH — foto's
// Miniatuur en startfoto = Prizm Dark Golf
// ============================================================
const LATCH_MINIATUUR = CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Dark-Golf.jpg?v=1784812173";

// ============================================================
// GIBSTON — foto's
// ============================================================
const GIBSTON_MINIATUUR = CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Jade.jpg?v=1784882213";
const GIBSTONXL_MINIATUUR = CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-24K.jpg?v=1784967380";

// ============================================================
// SUTRO LITE — teaser (binnenkort leverbaar), shield-lens
// ============================================================
// Miniatuur uit Shopify Files: de op-sterkte-foto (Matte Black Prizm Road).
const SUTRO_LITE_MINIATUUR = CDN+"Oakley-Sutro-Lite-Op-Sterkte-Matte-Black-Prizm-Road.jpg?v=1784901484";

// 13 vaste frame+lens-combinaties (shield). Foto's uit de bestaande producten.
const SUTRO_LITE_UITVOERINGEN = [
  { naam: "Matte Black / Prizm Road", montuur: "Matte Black", lens: "Prizm Road", variantId: 57563842314566, fotos: [CDN+"Oakley-Sutro-Lite-Matte-Black-Prizm-Road.jpg?v=1744883910", CDN+"Oakley-Sutro-Lite-Matte-Black-Prizm-Road-voorkant.jpg?v=1744883922", CDN+"Oakley-Sutro-Lite-Matte-Black-Prizm-Road-zijkant.jpg?v=1744883935"] },
  { naam: "Matte White / Prizm Road", montuur: "Matte White", lens: "Prizm Road", variantId: 57563842347334, fotos: [CDN+"Oakley-Sutro-Lite-Matte-White-Prizm-Road-Nieuw.jpg?v=1791625604", CDN+"Oakley-Sutro-Lite-Matte-White-Prizm-Road-Nieuw1.jpg?v=1791625646", CDN+"Oakley-Sutro-Lite-Matte-White-Prizm-Road-Nieuw3.jpg?v=1791625705"] },
  { naam: "Matte Black / Prizm Road Jade", montuur: "Matte Black", lens: "Prizm Road Jade", variantId: 57563842380102, fotos: [CDN+"Oakley-Sutro-Lite-Matte-Black-Prizm-Road-Jade-Nieuw1.jpg?v=1791625780", CDN+"Oakley-Sutro-Lite-Matte-Black-Prizm-Road-Jade-zijkant.png?v=1746702795", CDN+"Oakley-Sutro-Lite-Matte-Black-Prizm-Road-Jade-voorkant.png?v=1746702821"] },
  { naam: "Matte Carbon / Prizm Trail Torch", montuur: "Matte Carbon", lens: "Prizm Trail Torch", variantId: 57563842412870, fotos: [CDN+"Oakley-Matte-Carbon-Prizm-Trail-Torch-Nieuw1.jpg?v=1791625989", CDN+"Oakley-Matte-Carbon-Prizm-Trail-Torch-Nieuw2.jpg?v=1791626109", CDN+"Oakley-Matte-Carbon-Prizm-Trail-Torch-Nieuw3.jpg?v=1791626139"] },
  { naam: "Matte Black / Prizm Black", montuur: "Matte Black", lens: "Prizm Black", variantId: 57563842445638, fotos: [CDN+"Oakley-Sutro-Lite-Matte-Black-Prizm-Black.jpg?v=1744884791", CDN+"Oakley-Sutro-Lite-Matte-Black-Prizm-Black-voorkant.jpg?v=1744884807", CDN+"Oakley-Sutro-Lite-Matte-Black-Prizm-Black-zijkant.jpg?v=1744884819"] },
  { naam: "Matte Navy / Prizm Sapphire", montuur: "Matte Navy", lens: "Prizm Sapphire", variantId: 57563842478406, fotos: [CDN+"Oakley-Sutro-Lite-Matte-Navy-Prizm-Sapphire1.jpg?v=1748865718", CDN+"Oakley-Sutro-Lite-Matte-Navy-Prizm-Sapphire1-voorkant.jpg?v=1748865728", CDN+"Oakley-Sutro-Lite-Matte-Navy-Prizm-Sapphire1-zijkant.jpg?v=1748865737"] },
  { naam: "Matte Carbon / Prizm 24K", montuur: "Matte Carbon", lens: "Prizm 24K", variantId: 57563842511174, fotos: [CDN+"Oakley-Sutro-Lite-Matte-Carbon-Prizm-24K1.jpg?v=1748698867", CDN+"Oakley-Sutro-Lite-Matte-Carbon-Prizm-24K1-voorkant.jpg?v=1748698879", CDN+"Oakley-Sutro-Lite-Matte-Carbon-Prizm-24K1-zijkant.jpg?v=1748698890"] },
  { naam: "Matte Black / Prizm Sapphire", montuur: "Matte Black", lens: "Prizm Sapphire", variantId: 57563842543942, fotos: [CDN+"Oakley-Sutro-Lite-Matte-Black-Prizm-Sapphire1.jpg?v=1748698025", CDN+"Oakley-Sutro-Lite-Matte-Black-Prizm-Sapphire1-voorkant.jpg?v=1748698025", CDN+"Oakley-Sutro-Lite-Matte-Black-Prizm-Sapphire1-zijkant.jpg?v=1748698025"] },
  { naam: "Matte Carbon / Prizm Snow Sapphire", montuur: "Matte Carbon", lens: "Prizm Snow Sapphire", variantId: 57563842576710, fotos: [CDN+"Oakley-Sutro-Lite-Matte-Carbon-Prizm-Snow-Sapphire1.jpg?v=1748865936", CDN+"Oakley-Sutro-Lite-Matte-Carbon-Prizm-Snow-Sapphire1-voorkant.jpg?v=1748865945", CDN+"Oakley-Sutro-Lite-Matte-Carbon-Prizm-Snow-Sapphire1-zijkant.jpg?v=1748865954"] },
  { naam: "Matte White / Prizm Ruby", montuur: "Matte White", lens: "Prizm Ruby", variantId: 57563842609478, fotos: [CDN+"Oakley-Sutro-Lite-Matte-White-Prizm-Ruby1.jpg?v=1748698212", CDN+"Oakley-Sutro-Lite-Matte-White-Prizm-Ruby1-voorkant.jpg?v=1748698224", CDN+"Oakley-Sutro-Lite-Matte-White-Prizm-Ruby1-zijkant.jpg?v=1748698234"] },
  { naam: "Matte White / Prizm Sapphire", montuur: "Matte White", lens: "Prizm Sapphire", variantId: 57563842642246, fotos: [CDN+"Oakley-Sutro-Lite-Matte-White-Prizm-Sapphire1.jpg?v=1748700163", CDN+"Oakley-Sutro-Lite-Matte-White-Prizm-Sapphire1-voorkant.jpg?v=1748700172", CDN+"Oakley-Sutro-Lite-Matte-White-Prizm-Sapphire1-zijkant.jpg?v=1748700181"] },
  { naam: "Matte Sand / Prizm Road Black", montuur: "Matte Sand", lens: "Prizm Road Black", variantId: 57563842675014, fotos: [CDN+"Oakley-Matte-Sand-Prizm-Road-Black-Nieuw1.jpg?v=1791626207", CDN+"Oakley-Matte-Sand-Prizm-Road-Black-Nieuw2.jpg?v=1791626239", CDN+"Oakley-Matte-Sand-Prizm-Road-Black-Nieuw3.jpg?v=1791626271"] },
  { naam: "Matte Yellow / Prizm 24K", montuur: "Matte Yellow", lens: "Prizm 24K", variantId: 57563842707782, fotos: [CDN+"Oakley-Sutro-Lite-Matte-Yellow-Prizm-24K.jpg?v=1784300503", CDN+"Oakley-Sutro-Lite-Matte-Yellow-Prizm-24K-2.jpg?v=1784300576", CDN+"Oakley-Sutro-Lite-Matte-Yellow-Prizm-24K-3.jpg?v=1784300578"] },
];

const SUTRO_LITE_SWEEP_MINIATUUR = CDN+"Oakley-Sutro-Lite-Sweep-Matte-Black-Prizm-Road-Nieuw1.jpg?v=1791632205";

// 5 vaste frame+lens-combinaties (shield). Foto's uit de bestaande Sweep-producten.
const SUTRO_LITE_SWEEP_UITVOERINGEN = [
  { naam: "Matte Black / Prizm Road", montuur: "Matte Black", lens: "Prizm Road", variantId: 57564161769798, fotos: [CDN+"Oakley-Sutro-Lite-Sweep-Matte-Black-Prizm-Road-Nieuw1.jpg?v=1791632205", CDN+"Oakley-Sutro-Lite-Sweep-Matte-Black-Prizm-Road-Nieuw2.jpg?v=1791632234", CDN+"Oakley-Sutro-Lite-Sweep-Matte-Black-Prizm-Road-Nieuw3.jpg?v=1791632268"] },
  { naam: "Matte White / Prizm Road", montuur: "Matte White", lens: "Prizm Road", variantId: 57564161704262, fotos: [CDN+"Oakley-Sutro-Lite-Sweep-Matte-White-Prizm-Road-Nieuw1.jpg?v=1791632402", CDN+"Oakley-Sutro-Lite-Sweep-Matte-White-Prizm-Road-Nieuw2.jpg?v=1791632440", CDN+"Oakley-Sutro-Lite-Sweep-Matte-White-Prizm-Road-Nieuw3.jpg?v=1791632470"] },
  { naam: "Brass Tax / Prizm 24K", montuur: "Brass Tax", lens: "Prizm 24K", variantId: 57564161737030, fotos: [CDN+"Oakley-Sutro-Lite-Sweep-Brass-Tax-Prizm-24K-Nieuw1.jpg?v=1791633189", CDN+"Oakley-Sutro-Lite-Sweep-Brass-Tax-Prizm-24K-Nieuw2.jpg?v=1791633225", CDN+"Oakley-Sutro-Lite-Sweep-Brass-Tax-Prizm-24K-Nieuw3.jpg?v=1791633255"] },
  { naam: "Matte White / Prizm Road Jade", montuur: "Matte White", lens: "Prizm Road Jade", variantId: 57564161802566, fotos: [CDN+"Oakley-Sutro-Lite-Sweep-Matte-White-Prizm-Road-Jade-Nieuw1.jpg?v=1791632593", CDN+"Oakley-Sutro-Lite-Sweep-Matte-White-Prizm-Road-Jade-Nieuw2.jpg?v=1791632627", CDN+"Oakley-Sutro-Lite-Sweep-Matte-White-Prizm-Road-Jade-Nieuw3.jpg?v=1791632653"] },
  { naam: "Matte Navy / Prizm Sapphire", montuur: "Matte Navy", lens: "Prizm Sapphire", variantId: 57564161835334, fotos: [CDN+"Oakley-Sutro-Lite-Sweep-Matte-Navy-Prizm-Sapphire-Nieuw1.jpg?v=1791632698", CDN+"Oakley-Sutro-Lite-Sweep-Matte-Navy-Prizm-Sapphire-Nieuw2.jpg?v=1791632731", CDN+"Oakley-Sutro-Lite-Sweep-Matte-Navy-Prizm-Sapphire-Nieuw3.jpg?v=1791632760"] },
];

const CONFIG = {
  montuurPrijs: 170,
  kortingsPercentage: 10,

  // Shopify variant IDs
  // Holbrook prijzen
  holbrookMontuurPrijs: 150,
  // Bisphaera prijzen
  bisphaeraMontuurPrijs: 170,
  bisphaeraCorrectie: {
    "enkelvoudig": {
      "niet-gepolariseerd": 360,
      "gepolariseerd": 410
    },
    "progressief": {
      "niet-gepolariseerd": 560,
      "gepolariseerd": 610
    }
  },
  bisphaeraTransitions: {
    "enkelvoudig": 530,
    "progressief": 750
  },

  // Bisphaera — Shopify product 15653240045894 ("Oakley Op Sterkte")
  bisphaeraVariantIds: {
    "enkelvoudig-niet-gepolariseerd":         "57001252094278",
    "enkelvoudig-gepolariseerd":              "57001252127046",
    "progressief-niet-gepolariseerd":         "57001252192582",
    "progressief-gepolariseerd":              "57001252225350",
    "transitions-enkelvoudig":                "57001252159814",
    "transitions-progressief":                "57001252258118",
    "highrx-enkelvoudig-niet-gepolariseerd":  "57001252290886",
    "highrx-enkelvoudig-gepolariseerd":       "57001252323654",
    "highrx-transitions-enkelvoudig":         "57001252356422",
    "highrx-progressief-niet-gepolariseerd":  "57001252389190",
    "highrx-progressief-gepolariseerd":       "57001252421958",
    "highrx-transitions-progressief":         "57001252454726",
    "enkelvoudig-niet-gepolariseerd-grey":  "57010743247174",
    "enkelvoudig-gepolariseerd-grey":  "57010743279942",
    "progressief-niet-gepolariseerd-grey":  "57010743312710",
    "progressief-gepolariseerd-grey":  "57010743345478",
    "highrx-enkelvoudig-niet-gepolariseerd-grey":  "57010743378246",
    "highrx-enkelvoudig-gepolariseerd-grey":  "57010743411014",
    "highrx-progressief-niet-gepolariseerd-grey":  "57010743443782",
    "highrx-progressief-gepolariseerd-grey":  "57010743476550",
  },

  // Split Shot prijzen
  splitshotMontuurPrijs: 185,
  splitshotCorrectie: {
    "enkelvoudig": { "niet-gepolariseerd": 360, "gepolariseerd": 410 },
    "progressief": { "niet-gepolariseerd": 560, "gepolariseerd": 610 }
  },
  splitshotTransitions: { "enkelvoudig": 530, "progressief": 750 },

  // Split Shot — TODO: variant-IDs invullen zodra het Shopify-product bestaat
  splitshotVariantIds: {
    "enkelvoudig-niet-gepolariseerd":         "57009136206150",
    "enkelvoudig-gepolariseerd":              "57009136238918",
    "progressief-niet-gepolariseerd":         "57009136304454",
    "progressief-gepolariseerd":              "57009136337222",
    "transitions-enkelvoudig":                "57009136271686",
    "transitions-progressief":                "57009136369990",
    "highrx-enkelvoudig-niet-gepolariseerd":  "57009136402758",
    "highrx-enkelvoudig-gepolariseerd":       "57009136435526",
    "highrx-transitions-enkelvoudig":         "57009136468294",
    "highrx-progressief-niet-gepolariseerd":  "57009136501062",
    "highrx-progressief-gepolariseerd":       "57009136533830",
    "highrx-transitions-progressief":         "57009136566598",
    "enkelvoudig-niet-gepolariseerd-grey":  "57010743509318",
    "enkelvoudig-gepolariseerd-grey":  "57010743542086",
    "progressief-niet-gepolariseerd-grey":  "57010743574854",
    "progressief-gepolariseerd-grey":  "57010743607622",
    "highrx-enkelvoudig-niet-gepolariseerd-grey":  "57010743640390",
    "highrx-enkelvoudig-gepolariseerd-grey":  "57010743673158",
    "highrx-progressief-niet-gepolariseerd-grey":  "57010743705926",
    "highrx-progressief-gepolariseerd-grey":  "57010743738694",
  },

  // Holbrook XXL prijzen
  holbrookXxlMontuurPrijs: 150,
  holbrookXxlCorrectie: {
    "enkelvoudig": {
      "niet-gepolariseerd": 360,
      "gepolariseerd": 410
    },
    "progressief": {
      "niet-gepolariseerd": 560,
      "gepolariseerd": 610
    }
  },
  holbrookXxlTransitions: {
    "enkelvoudig": 530,
    "progressief": 750
  },

  // Gibston prijzen — enkelvoudig bevestigd; progressief + transitions nog TODO
  gibstonMontuurPrijs: 125,
  gibstonCorrectie: {
    "enkelvoudig": { "niet-gepolariseerd": 360, "gepolariseerd": 410 },
    "progressief": { "niet-gepolariseerd": 560, "gepolariseerd": 610 }
  },
  gibstonTransitions: { "enkelvoudig": 530, "progressief": 750 },

  // Gibston — TODO: variant-IDs invullen zodra de Shopify-varianten bestaan
  gibstonVariantIds: {
    "enkelvoudig-niet-gepolariseerd":         "57010618728774",
    "enkelvoudig-gepolariseerd":              "57010618761542",
    "transitions-enkelvoudig":                "57010618794310",
    "progressief-niet-gepolariseerd":         "57010618827078",
    "progressief-gepolariseerd":              "57010618859846",
    "transitions-progressief":                "57010618892614",
    "highrx-enkelvoudig-niet-gepolariseerd":  "57010618925382",
    "highrx-enkelvoudig-gepolariseerd":       "57010618958150",
    "highrx-transitions-enkelvoudig":         "57010618990918",
    "highrx-progressief-niet-gepolariseerd":  "57010619023686",
    "highrx-progressief-gepolariseerd":       "57010619056454",
    "highrx-transitions-progressief":         "57010619089222",
    "enkelvoudig-niet-gepolariseerd-grey":  "57010619121990",
    "enkelvoudig-gepolariseerd-grey":  "57010619154758",
    "progressief-niet-gepolariseerd-grey":  "57010619187526",
    "progressief-gepolariseerd-grey":  "57010619220294",
    "highrx-enkelvoudig-niet-gepolariseerd-grey":  "57010619253062",
    "highrx-enkelvoudig-gepolariseerd-grey":  "57010619285830",
    "highrx-progressief-niet-gepolariseerd-grey":  "57010619318598",
    "highrx-progressief-gepolariseerd-grey":  "57010619351366",
  
  },

  // Gibston XL - eigen varianten onder product "Oakley Op Sterkte" (15653240045894)
  gibstonXlVariantIds: {
    "enkelvoudig-niet-gepolariseerd":         "57013728772422",
    "enkelvoudig-gepolariseerd":              "57013728805190",
    "transitions-enkelvoudig":                "57013728837958",
    "progressief-niet-gepolariseerd":         "57013728870726",
    "progressief-gepolariseerd":              "57013728903494",
    "transitions-progressief":                "57013728936262",
    "highrx-enkelvoudig-niet-gepolariseerd":  "57013728969030",
    "highrx-enkelvoudig-gepolariseerd":       "57013729001798",
    "highrx-transitions-enkelvoudig":         "57013729034566",
    "highrx-progressief-niet-gepolariseerd":  "57013729067334",
    "highrx-progressief-gepolariseerd":       "57013729100102",
    "highrx-transitions-progressief":         "57013729132870",
    "enkelvoudig-niet-gepolariseerd-grey":  "57013729165638",
    "enkelvoudig-gepolariseerd-grey":  "57013729198406",
    "progressief-niet-gepolariseerd-grey":  "57013729231174",
    "progressief-gepolariseerd-grey":  "57013729263942",
    "highrx-enkelvoudig-niet-gepolariseerd-grey":  "57013729296710",
    "highrx-enkelvoudig-gepolariseerd-grey":  "57013729329478",
    "highrx-progressief-niet-gepolariseerd-grey":  "57013729362246",
    "highrx-progressief-gepolariseerd-grey":  "57013729395014",
  },

  // Flak 2.0 XXL — eigen varianten onder product "Oakley Op Sterkte" (15653240045894)
  flakXxlVariantIds: {
    "enkelvoudig-niet-gepolariseerd":         "57010665357638",
    "enkelvoudig-gepolariseerd":              "57010665390406",
    "transitions-enkelvoudig":                "57010665423174",
    "progressief-niet-gepolariseerd":         "57010665455942",
    "progressief-gepolariseerd":              "57010665488710",
    "transitions-progressief":                "57010665521478",
    "highrx-enkelvoudig-niet-gepolariseerd":  "57010665554246",
    "highrx-enkelvoudig-gepolariseerd":       "57010665587014",
    "highrx-transitions-enkelvoudig":         "57010665619782",
    "highrx-progressief-niet-gepolariseerd":  "57010665652550",
    "highrx-progressief-gepolariseerd":       "57010665685318",
    "highrx-transitions-progressief":         "57010665718086",
    "enkelvoudig-niet-gepolariseerd-grey":         "57010665750854",
    "enkelvoudig-gepolariseerd-grey":              "57010665783622",
    "progressief-niet-gepolariseerd-grey":         "57010665816390",
    "progressief-gepolariseerd-grey":              "57010665849158",
    "highrx-enkelvoudig-niet-gepolariseerd-grey":  "57010665881926",
    "highrx-enkelvoudig-gepolariseerd-grey":       "57010665914694",
    "highrx-progressief-niet-gepolariseerd-grey":  "57010665947462",
    "highrx-progressief-gepolariseerd-grey":       "57010665980230",
  },

  // Latch prijzen
  latchMontuurPrijs: 160,
  latchCorrectie: {
    "enkelvoudig": { "niet-gepolariseerd": 310, "gepolariseerd": 360 },
    "progressief": { "niet-gepolariseerd": 510, "gepolariseerd": 560 }
  },
  latchTransitions: { "enkelvoudig": 480, "progressief": 700 },

  // Latch — TODO: variant-IDs invullen zodra de Shopify-varianten bestaan
  latchVariantIds: {
    "enkelvoudig-niet-gepolariseerd":         "57006387691846",
    "enkelvoudig-gepolariseerd":              "57006387724614",
    "transitions-enkelvoudig":                "57006387757382",
    "progressief-niet-gepolariseerd":         "57006387790150",
    "progressief-gepolariseerd":              "57006387822918",
    "transitions-progressief":                "57006387855686",
    "highrx-enkelvoudig-niet-gepolariseerd":  "57006387888454",
    "highrx-enkelvoudig-gepolariseerd":       "57006387921222",
    "highrx-transitions-enkelvoudig":         "57006387953990",
    "highrx-progressief-niet-gepolariseerd":  "57006387986758",
    "highrx-progressief-gepolariseerd":       "57006388019526",
    "highrx-transitions-progressief":         "57006388052294",
    "enkelvoudig-niet-gepolariseerd-grey":         "57010588909894",
    "enkelvoudig-gepolariseerd-grey":              "57010588942662",
    "progressief-niet-gepolariseerd-grey":         "57010588975430",
    "progressief-gepolariseerd-grey":              "57010589008198",
    "highrx-enkelvoudig-niet-gepolariseerd-grey":  "57010589040966",
    "highrx-enkelvoudig-gepolariseerd-grey":       "57010589073734",
    "highrx-progressief-niet-gepolariseerd-grey":  "57010589106502",
    "highrx-progressief-gepolariseerd-grey":       "57010589139270",
  },

  // Holbrook XL — onder product "Oakley Op Sterkte" (15653240045894)
  holbrookXlVariantIds: {
    "enkelvoudig-niet-gepolariseerd":         "57005420183878",
    "enkelvoudig-gepolariseerd":              "57005420216646",
    "transitions-enkelvoudig":                "57005420249414",
    "progressief-niet-gepolariseerd":         "57005420282182",
    "progressief-gepolariseerd":              "57005420314950",
    "transitions-progressief":                "57005420347718",
    "highrx-enkelvoudig-niet-gepolariseerd":  "57005420380486",
    "highrx-enkelvoudig-gepolariseerd":       "57005420413254",
    "highrx-transitions-enkelvoudig":         "57005420446022",
    "highrx-progressief-niet-gepolariseerd":  "57005420478790",
    "highrx-progressief-gepolariseerd":       "57005420511558",
    "highrx-transitions-progressief":         "57005420544326",
    "enkelvoudig-niet-gepolariseerd-grey":  "57010743771462",
    "enkelvoudig-gepolariseerd-grey":  "57010743804230",
    "progressief-niet-gepolariseerd-grey":  "57010743836998",
    "progressief-gepolariseerd-grey":  "57010743869766",
    "highrx-enkelvoudig-niet-gepolariseerd-grey":  "57010743902534",
    "highrx-enkelvoudig-gepolariseerd-grey":  "57010743935302",
    "highrx-progressief-niet-gepolariseerd-grey":  "57010743968070",
    "highrx-progressief-gepolariseerd-grey":  "57010744000838",
  },

  // Holbrook XXL — Shopify product 15653158912326
  holbrookXxlVariantIds: {
    "enkelvoudig-niet-gepolariseerd":         "56998829588806",
    "enkelvoudig-gepolariseerd":              "56998829621574",
    "progressief-niet-gepolariseerd":         "56998829654342",
    "progressief-gepolariseerd":              "56998829687110",
    "transitions-enkelvoudig":                "56998829719878",
    "transitions-progressief":                "56998829752646",
    "highrx-enkelvoudig-niet-gepolariseerd":  "56998829785414",
    "highrx-enkelvoudig-gepolariseerd":       "56998829818182",
    "highrx-transitions-enkelvoudig":         "56998829850950",
    "highrx-progressief-niet-gepolariseerd":  "56998829883718",
    "highrx-progressief-gepolariseerd":       "56998829916486",
    "highrx-transitions-progressief":         "56998829949254",
    "enkelvoudig-niet-gepolariseerd-grey":  "57010745737542",
    "enkelvoudig-gepolariseerd-grey":  "57010745770310",
    "progressief-niet-gepolariseerd-grey":  "57010745803078",
    "progressief-gepolariseerd-grey":  "57010745835846",
    "highrx-enkelvoudig-niet-gepolariseerd-grey":  "57010745868614",
    "highrx-enkelvoudig-gepolariseerd-grey":  "57010745901382",
    "highrx-progressief-niet-gepolariseerd-grey":  "57010745934150",
    "highrx-progressief-gepolariseerd-grey":  "57010745966918",
  },

  // Eyejacket Redux prijzen
  eyejacketMontuurPrijs: 160,
  eyejacketCorrectie: {
    "enkelvoudig": {
      "niet-gepolariseerd": 360,
      "gepolariseerd": 410
    },
    "progressief": {
      "niet-gepolariseerd": 560,
      "gepolariseerd": 610
    }
  },
  eyejacketTransitions: {
    "enkelvoudig": 530,
    "progressief": 750
  },

  // Eyejacket Redux — Shopify product 15652414390598
  eyejacketVariantIds: {
    "enkelvoudig-niet-gepolariseerd":         "56991079039302",
    "enkelvoudig-gepolariseerd":              "56991079072070",
    "progressief-niet-gepolariseerd":         "56991079104838",
    "progressief-gepolariseerd":              "56991079137606",
    "transitions-enkelvoudig":                "56991079170374",
    "transitions-progressief":                "56991079203142",
    "highrx-enkelvoudig-niet-gepolariseerd":  "56991079235910",
    "highrx-enkelvoudig-gepolariseerd":       "56991079268678",
    "highrx-transitions-enkelvoudig":         "56991079301446",
    "highrx-progressief-niet-gepolariseerd":  "56991079334214",
    "highrx-progressief-gepolariseerd":       "56991079366982",
    "highrx-transitions-progressief":         "56991079399750",
    "enkelvoudig-niet-gepolariseerd-grey":  "57010746556742",
    "enkelvoudig-gepolariseerd-grey":  "57010746589510",
    "progressief-niet-gepolariseerd-grey":  "57010746622278",
    "progressief-gepolariseerd-grey":  "57010746655046",
    "highrx-enkelvoudig-niet-gepolariseerd-grey":  "57010746687814",
    "highrx-enkelvoudig-gepolariseerd-grey":  "57010746720582",
    "highrx-progressief-niet-gepolariseerd-grey":  "57010746753350",
    "highrx-progressief-gepolariseerd-grey":  "57010746786118",
  },
  holbrookCorrectie: {
    "enkelvoudig": {
      "niet-gepolariseerd": 310,
      "gepolariseerd": 360
    },
    "progressief": {
      "niet-gepolariseerd": 510,
      "gepolariseerd": 560
    }
  },
  holbrookTransitions: {
    "enkelvoudig": 480,
    "progressief": 700
  },

  variantIds: {
    "enkelvoudig-niet-gepolariseerd":       "56922923336006",
    "enkelvoudig-gepolariseerd":            "56922923368774",
    "progressief-niet-gepolariseerd":       "56922923401542",
    "progressief-gepolariseerd":            "56922923434310",
    "transitions-enkelvoudig":              "56922923467078",
    "transitions-progressief":             "56922923499846",
    "highrx-enkelvoudig-niet-gepolariseerd":  "56959030296902",
    "highrx-enkelvoudig-gepolariseerd":       "56959030329670",
    "highrx-transitions-enkelvoudig":         "56959030362438",
    "highrx-progressief-niet-gepolariseerd":  "56959096652102",
    "highrx-progressief-gepolariseerd":       "56959096684870",
    "highrx-transitions-progressief":         "56959096717638",
    "enkelvoudig-niet-gepolariseerd-grey":  "57010742755654",
    "enkelvoudig-gepolariseerd-grey":  "57010742788422",
    "progressief-niet-gepolariseerd-grey":  "57010742821190",
    "progressief-gepolariseerd-grey":  "57010742853958",
    "highrx-enkelvoudig-niet-gepolariseerd-grey":  "57010742886726",
    "highrx-enkelvoudig-gepolariseerd-grey":  "57010742919494",
    "highrx-progressief-niet-gepolariseerd-grey":  "57010742952262",
    "highrx-progressief-gepolariseerd-grey":  "57010742985030",
  },

  holbrookVariantIds: {
    "enkelvoudig-niet-gepolariseerd":       "56953961677126",
    "enkelvoudig-gepolariseerd":            "56953961709894",
    "progressief-niet-gepolariseerd":       "56953961742662",
    "progressief-gepolariseerd":            "56953961775430",
    "transitions-enkelvoudig":              "56953961808198",
    "transitions-progressief":             "56953961840966",
    "highrx-enkelvoudig-niet-gepolariseerd":  "56959033803078",
    "highrx-enkelvoudig-gepolariseerd":       "56959033835846",
    "highrx-transitions-enkelvoudig":         "56959033868614",
    "highrx-progressief-niet-gepolariseerd":  "56959057756486",
    "highrx-progressief-gepolariseerd":       "56959057789254",
    "highrx-transitions-progressief":         "56959057822022",
    "enkelvoudig-niet-gepolariseerd-grey":  "57010744820038",
    "enkelvoudig-gepolariseerd-grey":  "57010744852806",
    "progressief-niet-gepolariseerd-grey":  "57010744885574",
    "progressief-gepolariseerd-grey":  "57010744918342",
    "highrx-enkelvoudig-niet-gepolariseerd-grey":  "57010744951110",
    "highrx-enkelvoudig-gepolariseerd-grey":  "57010744983878",
    "highrx-progressief-niet-gepolariseerd-grey":  "57010745016646",
    "highrx-progressief-gepolariseerd-grey":  "57010745049414",
  },

  // Prijzen per correctietype en gepolariseerd ja/nee
  correctiePrijzen: {
    "enkelvoudig": {
      "niet-gepolariseerd": 360,
      "gepolariseerd": 410
    },
    "progressief": {
      "niet-gepolariseerd": 560,
      "gepolariseerd": 610
    }
  },

  glastypePrijzen: {
    "authentics-complex": 0,
    "transitions": 0
  },

  transitionsPrijs: {
    "enkelvoudig": 530,
    "progressief": 750
  },

  lensPrijzen: {
    // Niet gepolariseerd — TODO: prijzen invullen
    "Prizm Grey": 0,
    "Prizm Low Light": 0,
    "Prizm Snow Sapphire": 0,
    "Prizm Snow Torch": 0,
    "Prizm Trail": 0,
    "Prizm Trail Torch": 0,
    "Prizm Tungsten": 0,
    "Prizm Violet": 0,
    "Prizm Snow Black": 0,
    "Prizm Sapphire": 0,
    "Prizm Ruby": 0,
    "Prizm Rose Gold": 0,
    "Prizm Road Jade": 0,
    "Prizm Road Black": 0,
    "Prizm Road": 0,
    "Prizm Golf": 0,
    "Prizm Field": 0,
    "Prizm Deep Water": 0,
    "Prizm Dark Golf": 0,
    "Prizm Black": 0,
    "Prizm 24K": 0,
    // Gepolariseerd — TODO: prijzen invullen
    "Prizm 24K Polarized": 0,
    "Prizm Black Polarized": 0,
    "Prizm Deep Water Polarized": 0,
    "Prizm Jade Polarized": 0,
    "Prizm Rose Gold Polarized": 0,
    "Prizm Ruby Polarized": 0,
    "Prizm Sapphire Polarized": 0,
    "Prizm Tungsten Polarized": 0,
    "Prizm Violet Polarized": 0, // gebruikt niet-gepol foto per montuur
  }
};

// ============================================================
// MONTUURKLEUREN met foto's uit Shopify
// ============================================================
// MODELLEN PER BRILTYPE
const MODELLEN = {
  sportbril: [
    {
      naam: "Bisphaera",
      foto: BISPHAERA_MINIATUUR,
      actief: true
    },
    {
      naam: "Flak 2.0 XL",
      foto: CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Ruby1.jpg?v=1784121114",
      actief: true
    },
    {
      naam: "Flak 2.0 XXL",
      foto: CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-24K.jpg?v=1784123408",
      actief: true
    },
    {
      naam: "Split Shot",
      foto: SPLITSHOT_MINIATUUR,
      actief: true
    },
    {
      naam: "Sutro Lite",
      foto: SUTRO_LITE_MINIATUUR,
      actief: true,
      nieuw: true,
      shield: true,              // shield-lens: 1 doorlopende lens voor beide ogen
      alleenEnkelvoudig: true,   // shield: altijd enkelvoudig
      vasteVarianten: true,      // vaste frame+lens-combinaties i.p.v. kleur/lens kiezen
      combiMin: -3,              // sferisch + cilinder mag niet onder -3
      sferischBereik: { min: -3.00, max: 3.00 },
      uitvoeringen: SUTRO_LITE_UITVOERINGEN
    },
    {
      naam: "Sutro Lite Sweep",
      foto: SUTRO_LITE_SWEEP_MINIATUUR,
      actief: true,
      nieuw: true,
      miniZoom: 1.22,
      shield: true,
      alleenEnkelvoudig: true,
      vasteVarianten: true,
      combiMin: -3,
      sferischBereik: { min: -3.00, max: 3.00 },
      uitvoeringen: SUTRO_LITE_SWEEP_UITVOERINGEN
    },
    // TODO: andere sportbril modellen toevoegen
  ],
  zonnebril: [
    {
      naam: "Eyejacket Redux",
      foto: EYEJACKET_MATTE_BLACK_PRIZM_GREY,
      actief: true
    },
    {
      naam: "Gibston",
      foto: GIBSTON_MINIATUUR,
      actief: true
    },
    {
      naam: "Gibston XL",
      foto: GIBSTONXL_MINIATUUR,
      actief: true
    },
    {
      naam: "Holbrook",
      foto: CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Black_e77778b0-40dc-43f1-90ce-34fdf58edde7.jpg?v=1784219809",
      actief: true
    },
    {
      naam: "Holbrook XL",
      foto: CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Sapphire_9ce7f49b-a912-4805-9932-d6d9efa07f34.jpg?v=1784219663",
      actief: true
    },
    {
      naam: "Holbrook XXL",
      foto: CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Ruby_636416b6-218d-49f8-ad47-66dfe2dac4f4.jpg?v=1784220098",
      actief: true
    },
    {
      naam: "Latch",
      foto: LATCH_MINIATUUR,
      actief: true
    },
    // TODO: andere zonnebril modellen toevoegen
    // Brown Tortoise miniatuur gebruikt Prizm Tungsten foto
  ],
  meta: [
    {
      naam: "HSTN Meta",
      foto: CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Clear.jpg?v=1784494962",
      actief: true
    },
  ]
};

// MONTUURKLEUREN — momenteel alleen Polished White actief
// Andere kleuren worden later toegevoegd
const MONTUURKLEUREN = [
  {
    naam: "Matte Black",
    kleur: "#2a2a2a",
    foto: CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Ruby1.jpg?v=1784121114",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Photochromic2.jpg?v=1784124634",
      CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Photochromic-Felle-zon2.jpg?v=1784124753",
    ],
    lensFotos: {
      // Niet gepolariseerd
      "Prizm 24K":          CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-24K.jpg?v=1784123408",
      "Prizm Black": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Black2.jpg?v=1784120853",
      "Prizm Dark Golf": CDN+"Oakley-Flak-20-XL-Op-Sterkte-Matte-Black-Prizm-Dark-Golf.jpg?v=1784750893",
      "Prizm Low Light":    CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Low-Light1.jpg?v=1784123612",
      "Prizm Grey":         CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Grey1.jpg?v=1784114185",
      "Prizm Field": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Field1.jpg?v=1784122894",
      "Prizm Golf":         CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Golf1.jpg?v=1784113504",
      "Prizm Jade": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Jade1.jpg?v=1784122959",
      "Prizm Road": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Road1.jpg?v=1784123066",
      "Prizm Road Jade": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Road-Jade1.jpg?v=1784123112",
      "Prizm Rose Gold":    CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Rose-Gold.jpg?v=1784274514",
      "Prizm Rose Gold Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Rose-Gold.jpg?v=1784274514",
      "Prizm Ruby": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Ruby1.jpg?v=1784121114",
      "Prizm Sapphire": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Sapphire1.jpg?v=1784123178",
      "Prizm Snow Sapphire": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Snow-Sapphire1.jpg?v=1784122703",
      "Prizm Trail":        CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Trail_ea07844f-5e22-46dc-a60e-d971abc87030.jpg?v=1784123830",
      "Prizm Trail Torch": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Trail-Torch1.jpg?v=1784123237",
      "Prizm Tungsten": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Tungsten1.jpg?v=1784122809",
      "Prizm Violet": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Violet1.jpg?v=1784123322",
      // Gepolariseerd
      "Prizm 24K Polarized":        CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-24K.jpg?v=1784123408",
      "Prizm Black Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Black2.jpg?v=1784120853",
      "Prizm Jade Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Jade1.jpg?v=1784122959",
      "Prizm Deep Water Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Deep-Water-Polarized1.jpg?v=1784123901",
      "Prizm Ruby Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Ruby1.jpg?v=1784121114",
      "Prizm Sapphire Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Sapphire1.jpg?v=1784123178",
      "Prizm Tungsten Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Tungsten1.jpg?v=1784122809",
      "Prizm Grey Polarized":       CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Grey1.jpg?v=1784114185",
      "Prizm Violet Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Violet1.jpg?v=1784123322",
    }
  },
  {
    naam: "Polished White",
    kleur: "#f0f0f0",
    foto: CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-Deep-Water-polarized.jpg?v=1784128324",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Photochromic-binnen.jpg?v=1784127935",
      CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Photochromic-felle-zon.jpg?v=1784127974",
    ],
    lensFotos: {
      // Niet gepolariseerd
      "Prizm Golf": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-Golf.jpg?v=1784127477",
      "Prizm Grey": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-Grey.jpg?v=1784127528",
      "Prizm 24K": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-24K.jpg?v=1784126604",
      "Prizm Black": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-Black.jpg?v=1784127419",
      "Prizm Dark Golf": CDN+"Oakley-Flak-20-XL-Op-Sterkte-Polished-White-Prizm-Dark-Golf.jpg?v=1784751100",
      "Prizm Field": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-Field.jpg?v=1784126808",
      "Prizm Violet": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-Violet.jpg?v=1784127851",
      "Prizm Road": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-Road.jpg?v=1784127593",
      "Prizm Snow Sapphire": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-Snow-Sapphire.jpg?v=1784127715",
      "Prizm Low Light": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-low-light1.jpg?v=1784127012",
      "Prizm Road Jade": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-Road-Jade.jpg?v=1784127155",
      "Prizm Trail": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-Trail.jpg?v=1784127306",
      "Prizm Trail Torch": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-Trail-Torch.jpg?v=1784127759",
      "Prizm Jade": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-Jade.jpg?v=1784127078",
      "Prizm Tungsten": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-Tunsten.jpg?v=1784127384",
      "Prizm Rose Gold":    CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-white-Prizm-Rose-Gold.jpg?v=1784274508",
      "Prizm Rose Gold Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-white-Prizm-Rose-Gold.jpg?v=1784274508",
      "Prizm Ruby": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-Ruby.jpg?v=1784127629",
      "Photochromic": CDN+"Oakley-Flak-20-XL-opsterkte-white-photochromic.jpg?v=1783426026",
      // Gepolariseerd
      "Prizm 24K Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-24K.jpg?v=1784126604",
      "Prizm Tungsten Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-Tunsten.jpg?v=1784127384",
      "Prizm Sapphire Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-Sapphire.jpg?v=1784127221",
      "Prizm Ruby Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-Ruby.jpg?v=1784127629",
      "Prizm Jade Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-Jade.jpg?v=1784127078",
      "Prizm Deep Water Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-Deep-Water-polarized.jpg?v=1784128324",
      "Prizm Black Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-Black.jpg?v=1784127419",
      "Prizm Grey Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-Grey.jpg?v=1784127528",
      "Prizm Violet Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-Violet.jpg?v=1784127851",
      "Prizm Sapphire": CDN+"Oakley-Flak-20-XL-op-sterkte-Polished-White-Prizm-Sapphire.jpg?v=1784127221",
      // TODO: Prizm 24K, Prizm Dark Golf, Prizm Deep Water, Prizm Golf, Prizm Snow Black, Prizm Snow Torch
    }
  },
  {
    naam: "Steel",
    kleur: "#8a8e91",
    foto: CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Black_15ba0508-a08f-4a3b-82c3-bdbcbcb02379.jpg?v=1784201944",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Photochromic-binnen.jpg?v=1784221577",
      CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Photochromic-felle-zon_fd134ef1-0ae5-4cac-9b47-6e823a098ab1.jpg?v=1784221637",
    ],
    lensFotos: {
      "Prizm 24K": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-24K.jpg?v=1784201399",
      "Prizm Grey": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Grey_fad6e99d-7ba8-476f-b74e-53d1321ea1bc.jpg?v=1784201983",
      "Prizm Low Light":    CDN+"Oakley-flak-20-XL-op-sterkte-steel-prizm-low-light.jpg?v=1783758136",
      "Prizm Black": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Black_15ba0508-a08f-4a3b-82c3-bdbcbcb02379.jpg?v=1784201944",
      "Prizm Dark Golf": CDN+"Oakley-Flak-20-XL-Op-Sterkte-Steel-Prizm-Dark-Golf.jpg?v=1784751184",
      "Prizm Field": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Field_05e953cb-aa14-4f47-940f-9d99beb389a7.jpg?v=1784201473",
      "Prizm Golf":         CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Golf1.jpg?v=1784206454",
      "Prizm Jade": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Jade_11fdf3cf-c24d-485c-bc33-ba9dcd1ed0b8.jpg?v=1784201658",
      "Prizm Road": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Road_58a47f35-d98f-4100-af46-41a46fc6a807.jpg?v=1784202086",
      "Prizm Road Jade": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Road-Jade_7f261ad2-f8a6-45b0-bda0-5785a3b14569.jpg?v=1784201721",
      "Prizm Rose Gold":    CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Rose-Gold.jpg?v=1784274611",
      "Prizm Rose Gold Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Rose-Gold.jpg?v=1784274611",
      "Prizm Ruby": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Ruby_90629d27-78c7-478c-85e4-9cf4fc960197.jpg?v=1784202131",
      "Prizm Sapphire": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Sapphire_bf093a5d-ec34-4518-ab92-e88bad5d3f98.jpg?v=1784201777",
      "Prizm Snow Sapphire":CDN+"Oakley-flak-20-XL-op-sterkte-steel-prizm-snow-sapphire.jpg?v=1783758894",
      "Prizm Trail": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Trail_7c88555a-18cc-4069-96a6-38a22f718a0e.jpg?v=1784201843",
      "Prizm Trail Torch": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Trail-Torch_9ea55df5-b919-4126-9b2b-c2ed55ae6c1d.jpg?v=1784202242",
      "Prizm Tungsten": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Tungsten_274174fd-afd8-4cba-b0f5-db0c9553a78e.jpg?v=1784201887",
      "Prizm Violet": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Violet_bb3e9d6c-0c00-42a4-98cf-843c24e23b56.jpg?v=1784202295",
      // Gepolariseerd
      "Prizm 24K Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-24K.jpg?v=1784201399",
      "Prizm Grey Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Grey_fad6e99d-7ba8-476f-b74e-53d1321ea1bc.jpg?v=1784201983",
      "Prizm Black Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Black_15ba0508-a08f-4a3b-82c3-bdbcbcb02379.jpg?v=1784201944",
      "Prizm Deep Water Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Deep-Water.jpg?v=1784202347",
      "Prizm Jade Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Jade_11fdf3cf-c24d-485c-bc33-ba9dcd1ed0b8.jpg?v=1784201658",
      "Prizm Ruby Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Ruby_90629d27-78c7-478c-85e4-9cf4fc960197.jpg?v=1784202131",
      "Prizm Sapphire Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Sapphire_bf093a5d-ec34-4518-ab92-e88bad5d3f98.jpg?v=1784201777",
      "Prizm Tungsten Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Tungsten_274174fd-afd8-4cba-b0f5-db0c9553a78e.jpg?v=1784201887",
      "Prizm Violet Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Violet_bb3e9d6c-0c00-42a4-98cf-843c24e23b56.jpg?v=1784202295",
    }
  },
  {
    naam: "Matte Grey Ink",
    kleur: "#5a5a6a",
    foto: CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-24K.jpg?v=1784298295",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Photochromic-binnen.jpg?v=1784300821",
      CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Photochromic-felle-zon.jpg?v=1784300892",
    ],
    lensFotos: {
      // Niet gepolariseerd
      "Prizm 24K":          CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-24K.jpg?v=1784298295",
      "Prizm Black": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-Black.jpg?v=1784299987",
      "Prizm Dark Golf": CDN+"Oakley-Flak-20-XL-Op-Sterkte-Matte-Grey-Ink-Prizm-Dark-Golf.jpg?v=1784751280",
      "Prizm Field": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-Field.jpg?v=1784300076",
      "Prizm Golf": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-Golf.jpg?v=1784300113",
      "Prizm Grey": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-Grey.jpg?v=1784300155",
      "Prizm Jade": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-Jade.jpg?v=1784300247",
      "Prizm Low Light":    "",
      "Prizm Road": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-Road.jpg?v=1784300308",
      "Prizm Road Jade": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-Road-Jade.jpg?v=1784300349",
      "Prizm Rose Gold": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-Rose-Gold.jpg?v=1784300420",
      "Prizm Ruby": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-Ruby.jpg?v=1784300470",
      "Prizm Sapphire": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-Sapphire.jpg?v=1784300507",
      "Prizm Snow Sapphire":"",
      "Prizm Trail": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-Trail.jpg?v=1784300569",
      "Prizm Trail Torch": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-Trail-Torch.jpg?v=1784300636",
      "Prizm Tungsten": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-Tungsten.jpg?v=1784300682",
      "Prizm Violet": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-Violet.jpg?v=1784300725",
      // Gepolariseerd
      "Prizm 24K Polarized":        CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-24K.jpg?v=1784298295",
      "Prizm Black Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-Black.jpg?v=1784299987",
      "Prizm Deep Water Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-Deep-water-polarized.jpg?v=1784301043",
      "Prizm Grey Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-Grey.jpg?v=1784300155",
      "Prizm Jade Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-Jade.jpg?v=1784300247",
      "Prizm Rose Gold Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-Rose-Gold.jpg?v=1784300420",
      "Prizm Ruby Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-Ruby.jpg?v=1784300470",
      "Prizm Sapphire Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-Sapphire.jpg?v=1784300507",
      "Prizm Tungsten Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-Tungsten.jpg?v=1784300682",
      "Prizm Violet Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Grey-Ink-Prizm-Violet.jpg?v=1784300725",
    }
  },
  // TODO: Polished Black, Black Camo, Matte Black Camo, Matte Grey Ink
];

// ============================================================

// FLAK 2.0 XXL MONTUURKLEUREN (kopie van XL Matte Black + Steel)
const FLAK_XXL_MONTUURKLEUREN = [
  {
    naam: "Matte Black",
    kleur: "#2a2a2a",
    foto: CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-24K.jpg?v=1784123408",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Photochromic2.jpg?v=1784124634",
      CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Photochromic-Felle-zon2.jpg?v=1784124753",
    ],
    lensFotos: {
      // Niet gepolariseerd
      "Prizm 24K":          CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-24K.jpg?v=1784123408",
      "Prizm Black": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Black2.jpg?v=1784120853",
      "Prizm Dark Golf": CDN+"Oakley-Flak-20-XL-Op-Sterkte-Matte-Black-Prizm-Dark-Golf.jpg?v=1784750893",
      "Prizm Low Light":    CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Low-Light1.jpg?v=1784123612",
      "Prizm Grey":         CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Grey1.jpg?v=1784114185",
      "Prizm Field": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Field1.jpg?v=1784122894",
      "Prizm Golf":         CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Golf1.jpg?v=1784113504",
      "Prizm Jade": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Jade1.jpg?v=1784122959",
      "Prizm Road": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Road1.jpg?v=1784123066",
      "Prizm Road Jade": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Road-Jade1.jpg?v=1784123112",
      "Prizm Rose Gold":    CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Rose-Gold.jpg?v=1784274514",
      "Prizm Rose Gold Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Rose-Gold.jpg?v=1784274514",
      "Prizm Ruby": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Ruby1.jpg?v=1784121114",
      "Prizm Sapphire": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Sapphire1.jpg?v=1784123178",
      "Prizm Snow Sapphire": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Snow-Sapphire1.jpg?v=1784122703",
      "Prizm Trail":        CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Trail_ea07844f-5e22-46dc-a60e-d971abc87030.jpg?v=1784123830",
      "Prizm Trail Torch": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Trail-Torch1.jpg?v=1784123237",
      "Prizm Tungsten": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Tungsten1.jpg?v=1784122809",
      "Prizm Violet": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Violet1.jpg?v=1784123322",
      // Gepolariseerd
      "Prizm 24K Polarized":        CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-24K.jpg?v=1784123408",
      "Prizm Black Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Black2.jpg?v=1784120853",
      "Prizm Jade Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Jade1.jpg?v=1784122959",
      "Prizm Deep Water Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Deep-Water-Polarized1.jpg?v=1784123901",
      "Prizm Ruby Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Ruby1.jpg?v=1784121114",
      "Prizm Sapphire Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Sapphire1.jpg?v=1784123178",
      "Prizm Tungsten Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Tungsten1.jpg?v=1784122809",
      "Prizm Grey Polarized":       CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Grey1.jpg?v=1784114185",
      "Prizm Violet Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Matte-Black-Prizm-Violet1.jpg?v=1784123322",
    }
  },
  {
    naam: "Steel",
    kleur: "#8a8e91",
    foto: CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Jade_11fdf3cf-c24d-485c-bc33-ba9dcd1ed0b8.jpg?v=1784201658",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Photochromic-binnen.jpg?v=1784221577",
      CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Photochromic-felle-zon_fd134ef1-0ae5-4cac-9b47-6e823a098ab1.jpg?v=1784221637",
    ],
    lensFotos: {
      "Prizm 24K": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-24K.jpg?v=1784201399",
      "Prizm Grey": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Grey_fad6e99d-7ba8-476f-b74e-53d1321ea1bc.jpg?v=1784201983",
      "Prizm Low Light":    CDN+"Oakley-flak-20-XL-op-sterkte-steel-prizm-low-light.jpg?v=1783758136",
      "Prizm Black": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Black_15ba0508-a08f-4a3b-82c3-bdbcbcb02379.jpg?v=1784201944",
      "Prizm Dark Golf": CDN+"Oakley-Flak-20-XL-Op-Sterkte-Steel-Prizm-Dark-Golf.jpg?v=1784751184",
      "Prizm Field": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Field_05e953cb-aa14-4f47-940f-9d99beb389a7.jpg?v=1784201473",
      "Prizm Golf":         CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Golf1.jpg?v=1784206454",
      "Prizm Jade": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Jade_11fdf3cf-c24d-485c-bc33-ba9dcd1ed0b8.jpg?v=1784201658",
      "Prizm Road": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Road_58a47f35-d98f-4100-af46-41a46fc6a807.jpg?v=1784202086",
      "Prizm Road Jade": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Road-Jade_7f261ad2-f8a6-45b0-bda0-5785a3b14569.jpg?v=1784201721",
      "Prizm Rose Gold":    CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Rose-Gold.jpg?v=1784274611",
      "Prizm Rose Gold Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Rose-Gold.jpg?v=1784274611",
      "Prizm Ruby": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Ruby_90629d27-78c7-478c-85e4-9cf4fc960197.jpg?v=1784202131",
      "Prizm Sapphire": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Sapphire_bf093a5d-ec34-4518-ab92-e88bad5d3f98.jpg?v=1784201777",
      "Prizm Snow Sapphire":CDN+"Oakley-flak-20-XL-op-sterkte-steel-prizm-snow-sapphire.jpg?v=1783758894",
      "Prizm Trail": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Trail_7c88555a-18cc-4069-96a6-38a22f718a0e.jpg?v=1784201843",
      "Prizm Trail Torch": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Trail-Torch_9ea55df5-b919-4126-9b2b-c2ed55ae6c1d.jpg?v=1784202242",
      "Prizm Tungsten": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Tungsten_274174fd-afd8-4cba-b0f5-db0c9553a78e.jpg?v=1784201887",
      "Prizm Violet": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Violet_bb3e9d6c-0c00-42a4-98cf-843c24e23b56.jpg?v=1784202295",
      // Gepolariseerd
      "Prizm 24K Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-24K.jpg?v=1784201399",
      "Prizm Grey Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Grey_fad6e99d-7ba8-476f-b74e-53d1321ea1bc.jpg?v=1784201983",
      "Prizm Black Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Black_15ba0508-a08f-4a3b-82c3-bdbcbcb02379.jpg?v=1784201944",
      "Prizm Deep Water Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Deep-Water.jpg?v=1784202347",
      "Prizm Jade Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Jade_11fdf3cf-c24d-485c-bc33-ba9dcd1ed0b8.jpg?v=1784201658",
      "Prizm Ruby Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Ruby_90629d27-78c7-478c-85e4-9cf4fc960197.jpg?v=1784202131",
      "Prizm Sapphire Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Sapphire_bf093a5d-ec34-4518-ab92-e88bad5d3f98.jpg?v=1784201777",
      "Prizm Tungsten Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Tungsten_274174fd-afd8-4cba-b0f5-db0c9553a78e.jpg?v=1784201887",
      "Prizm Violet Polarized": CDN+"Oakley-Flak-20-XL-op-sterkte-Steel-Prizm-Violet_bb3e9d6c-0c00-42a4-98cf-843c24e23b56.jpg?v=1784202295",
    }
  },
];

// HOLBROOK MONTUURKLEUREN
// ============================================================
const HOLBROOK_MONTUURKLEUREN = [
  {
    naam: "Matte Black",
    kleur: "#2a2a2a",
    foto: CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Black_e77778b0-40dc-43f1-90ce-34fdf58edde7.jpg?v=1784219809",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Photochromic-binnen.jpg?v=1784221370",
      CDN+"Oakley-Holbrook-Opsterkte-Matte-Black-Photochromic2-felle-zon.jpg?v=1784488187",
    ],
    lensFotos: {
      "Prizm 24K":        CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-24K.jpg?v=1784209055",
      "Prizm Black": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Black_e77778b0-40dc-43f1-90ce-34fdf58edde7.jpg?v=1784219809",
      "Prizm Grey": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Grey_457501ed-39f8-432a-ab59-c6df902d8ee8.jpg?v=1784219906",
      "Prizm Dark Golf": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Dark-Golf_11da66ee-2ef0-4460-8f37-e40d343c785d.jpg?v=1784209150",
      "Prizm Field":      CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Field.jpg?v=1784219862",
      "Prizm Golf": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Golf_6cbacd59-4d8e-4ac6-8818-5d1686d802ef.jpg?v=1784209212",
      "Prizm Jade":       CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Jade_2580e18f-cd8a-40fd-a37f-b15797923f61.jpg?v=1784216077",
      "Prizm Road": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Road_16ca0b84-a060-4ce3-8128-355f3dffb298.jpg?v=1784219966",
      "Prizm Road Black": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Road-Black_e8ba07d2-306b-40a1-94ef-266cdb7315fb.jpg?v=1784216151",
      "Prizm Rose Gold":  CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Rose-Gold.jpg?v=1784219607",
      "Prizm Road Jade":  CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Road-Jade.jpg?v=1784220015",
      "Prizm Ruby": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Ruby_636416b6-218d-49f8-ad47-66dfe2dac4f4.jpg?v=1784220098",
      "Prizm Sapphire": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Sapphire_9ce7f49b-a912-4805-9932-d6d9efa07f34.jpg?v=1784219663",
      "Prizm Trail": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Trail_9d1a905c-3372-4c24-9153-2d4af9ffe892.jpg?v=1784220216",
      "Prizm Tungsten": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Tungsten_de4c9af0-9872-48d7-99d8-c3f90630c724.jpg?v=1784219768",
      "Prizm Violet": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Violet_a5c2404b-4be5-4592-b885-dbe2237f1235.jpg?v=1784220285",
      // Gepolariseerd
      "Prizm Grey Polarized": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Grey_457501ed-39f8-432a-ab59-c6df902d8ee8.jpg?v=1784219906",
      "Prizm 24K Polarized":        CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-24K.jpg?v=1784209055",
      "Prizm Black Polarized": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Black_e77778b0-40dc-43f1-90ce-34fdf58edde7.jpg?v=1784219809",
      "Prizm Deep Water Polarized": CDN+"Oakley-Holbrook-op-sterkte-matte-black-prizm-deep-water-polarized.jpg?v=1783771847",
      "Prizm Jade Polarized":       CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Jade_2580e18f-cd8a-40fd-a37f-b15797923f61.jpg?v=1784216077",
      "Prizm Ruby Polarized": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Ruby_636416b6-218d-49f8-ad47-66dfe2dac4f4.jpg?v=1784220098",
      "Prizm Rose Gold Polarized":  CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Rose-Gold.jpg?v=1784219607",
      "Prizm Sapphire Polarized": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Sapphire_9ce7f49b-a912-4805-9932-d6d9efa07f34.jpg?v=1784219663",
      "Prizm Tungsten Polarized": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Tungsten_de4c9af0-9872-48d7-99d8-c3f90630c724.jpg?v=1784219768",
      "Prizm Violet Polarized": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Violet_a5c2404b-4be5-4592-b885-dbe2237f1235.jpg?v=1784220285",
    }
  },
  {
    naam: "Matte Brown Tortoise",
    kleur: "#5a3a1a",
    foto: CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Tungsten.jpg?v=1784223644",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Photochromic-binnen.jpg?v=1784271179",
      CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Photochromic-felle-zon.jpg?v=1784271227",
    ],
    lensFotos: {
      "Prizm 24K": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-24K.jpg?v=1784222009",
      "Prizm Black": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Black.jpg?v=1784223709",
      "Prizm Grey": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Grey.jpg?v=1784270603",
      "Prizm Dark Golf": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Dark-Golf.jpg?v=1784222091",
      "Prizm Field": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Field.jpg?v=1784270481",
      "Prizm Golf": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Golf.jpg?v=1784222927",
      "Prizm Jade": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Jade.jpg?v=1784223028",
      "Prizm Road": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Road.jpg?v=1784270695",
      "Prizm Road Jade": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Road-Jade.jpg?v=1784270761",
      "Prizm Road Black": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Road-Black.jpg?v=1784223099",
      "Prizm Rose Gold": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Rose-Gold.jpg?v=1784223551",
      "Prizm Ruby": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Ruby.jpg?v=1784270809",
      "Prizm Sapphire": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Sapphire.jpg?v=1784223606",
      "Prizm Trail": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Trail.jpg?v=1784270876",
      "Prizm Tungsten": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Tungsten.jpg?v=1784223644",
      "Prizm Violet": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Violet.jpg?v=1784270930",
      // Gepolariseerd
      "Prizm Grey Polarized": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Grey.jpg?v=1784270603",
      "Prizm 24K Polarized":        CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-24K.jpg?v=1784222009",
      "Prizm Black Polarized": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Black.jpg?v=1784223709",
      "Prizm Deep Water Polarized": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Deep-Water-Polarized.jpg?v=1784271005",
      "Prizm Sapphire Polarized": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Sapphire.jpg?v=1784223606",
      "Prizm Jade Polarized": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Jade.jpg?v=1784223028",
      "Prizm Tungsten Polarized": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Tungsten.jpg?v=1784223644",
      "Prizm Rose Gold Polarized":  CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Rose-Gold.jpg?v=1784223551",
      "Prizm Ruby Polarized": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Ruby.jpg?v=1784270809",
      "Prizm Violet Polarized": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Violet.jpg?v=1784270930",
    }
  },
  {
    naam: "Polished Black",
    kleur: "#111111",
    foto: CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Sapphire.jpg?v=1784272244",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Photochromic-binnen.jpg?v=1784272759",
      CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Photochromic-felle-zon.jpg?v=1784272800",
    ],
    lensFotos: {
      // Niet gepolariseerd
      "Prizm 24K": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-24K.jpg?v=1784271821",
      "Prizm Black": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Black.jpg?v=1784272347",
      "Prizm Dark Golf": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Dark-Golf.jpg?v=1784271893",
      "Prizm Field":      CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Field.jpg?v=1784272390",
      "Prizm Golf": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Golf.jpg?v=1784271930",
      "Prizm Grey": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Grey.jpg?v=1784272425",
      "Prizm Jade": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Jade.jpg?v=1784271980",
      "Prizm Road": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Road.jpg?v=1784272508",
      "Prizm Road Jade":  CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Road-Jade.jpg?v=1784272564",
      "Prizm Road Black": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Road-Black.jpg?v=1784272087",
      "Prizm Rose Gold": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Rose-Gold.jpg?v=1784272139",
      "Prizm Ruby": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Ruby.jpg?v=1784272602",
      "Prizm Sapphire": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Sapphire.jpg?v=1784272244",
      "Prizm Trail": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Trail.jpg?v=1784272659",
      "Prizm Tungsten": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Tungsten.jpg?v=1784272282",
      "Prizm Violet": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Violet.jpg?v=1784272707",
      // Gepolariseerd
      "Prizm Grey Polarized": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Grey.jpg?v=1784272425",
      "Prizm 24K Polarized": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-24K.jpg?v=1784271821",
      "Prizm Black Polarized": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Black.jpg?v=1784272347",
      "Prizm Deep Water Polarized": CDN+"Oakley-Holbrook-opsterkte-Polished-Black-Prizm-Deep-Water-Polarized.jpg?v=1784028252",
      "Prizm Sapphire Polarized": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Sapphire.jpg?v=1784272244",
      "Prizm Jade Polarized": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Jade.jpg?v=1784271980",
      "Prizm Tungsten Polarized": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Tungsten.jpg?v=1784272282",
      "Prizm Rose Gold Polarized": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Rose-Gold.jpg?v=1784272139",
      "Prizm Ruby Polarized": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Ruby.jpg?v=1784272602",
      "Prizm Violet Polarized": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Violet.jpg?v=1784272707",
      // TODO: transitions nog toe te voegen
    }
  },
  // TODO: meer montuurkleuren toevoegen
  {
    naam: "Woodgrain",
    kleur: "#8a7a6a",
    foto: CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-golf.jpg?v=1784280248",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-Photochromic-binnen.jpg?v=1784282041",
      CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-Photochromic-felle-zon.jpg?v=1784282167",
    ],
    lensFotos: {
      // Niet gepolariseerd
      "Prizm 24K":        CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-24k.jpg?v=1784280239",
      "Prizm Black":      CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Black.jpg?v=1784281354",
      "Prizm Dark Golf":  CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-dark-golf.jpg?v=1784280148",
      "Prizm Field":      CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Field.jpg?v=1784281401",
      "Prizm Golf":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-golf.jpg?v=1784280248",
      "Prizm Grey":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Grey.jpg?v=1784281459",
      "Prizm Jade":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Jade.jpg?v=1784280779",
      "Prizm Road":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Road.jpg?v=1784281511",
      "Prizm Road Jade":  CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-road-jade.jpg?v=1784281559",
      "Prizm Rose Gold":  CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Rose-Gold.jpg?v=1784281160",
      "Prizm Ruby":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-ruby.jpg?v=1784281600",
      "Prizm Sapphire":   CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Sapphire.jpg?v=1784281210",
      "Prizm Trail":      CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-trail.jpg?v=1784281660",
      "Prizm Tungsten":   CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Tunsgsten.jpg?v=1784281290",
      "Prizm Violet":     CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-violet.jpg?v=1784281710",
      // Gepolariseerd
      "Prizm 24K Polarized":        CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-24k.jpg?v=1784280239",
      "Prizm Black Polarized":      CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Black.jpg?v=1784281354",
      "Prizm Deep Water Polarized": CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-deep-water.jpg?v=1784282576",
      "Prizm Grey Polarized":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Grey.jpg?v=1784281459",
      "Prizm Jade Polarized":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Jade.jpg?v=1784280779",
      "Prizm Rose Gold Polarized":  CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Rose-Gold.jpg?v=1784281160",
      "Prizm Ruby Polarized":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-ruby.jpg?v=1784281600",
      "Prizm Sapphire Polarized":   CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Sapphire.jpg?v=1784281210",
      "Prizm Tungsten Polarized":   CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Tunsgsten.jpg?v=1784281290",
      "Prizm Violet Polarized":     CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-violet.jpg?v=1784281710",
    }
  },
];


const HOLBROOK_XL_MONTUURKLEUREN = [
  {
    naam: "Matte Black",
    kleur: "#2a2a2a",
    foto: CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Sapphire_9ce7f49b-a912-4805-9932-d6d9efa07f34.jpg?v=1784219663",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Photochromic-binnen.jpg?v=1784221370",
      CDN+"Oakley-Holbrook-Opsterkte-Matte-Black-Photochromic2-felle-zon.jpg?v=1784488187",
    ],
    lensFotos: {
      "Prizm 24K":        CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-24K.jpg?v=1784209055",
      "Prizm Black": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Black_e77778b0-40dc-43f1-90ce-34fdf58edde7.jpg?v=1784219809",
      "Prizm Grey": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Grey_457501ed-39f8-432a-ab59-c6df902d8ee8.jpg?v=1784219906",
      "Prizm Dark Golf": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Dark-Golf_11da66ee-2ef0-4460-8f37-e40d343c785d.jpg?v=1784209150",
      "Prizm Field":      CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Field.jpg?v=1784219862",
      "Prizm Golf": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Golf_6cbacd59-4d8e-4ac6-8818-5d1686d802ef.jpg?v=1784209212",
      "Prizm Jade":       CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Jade_2580e18f-cd8a-40fd-a37f-b15797923f61.jpg?v=1784216077",
      "Prizm Road": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Road_16ca0b84-a060-4ce3-8128-355f3dffb298.jpg?v=1784219966",
      "Prizm Road Black": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Road-Black_e8ba07d2-306b-40a1-94ef-266cdb7315fb.jpg?v=1784216151",
      "Prizm Rose Gold":  CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Rose-Gold.jpg?v=1784219607",
      "Prizm Road Jade":  CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Road-Jade.jpg?v=1784220015",
      "Prizm Ruby": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Ruby_636416b6-218d-49f8-ad47-66dfe2dac4f4.jpg?v=1784220098",
      "Prizm Sapphire": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Sapphire_9ce7f49b-a912-4805-9932-d6d9efa07f34.jpg?v=1784219663",
      "Prizm Trail": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Trail_9d1a905c-3372-4c24-9153-2d4af9ffe892.jpg?v=1784220216",
      "Prizm Tungsten": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Tungsten_de4c9af0-9872-48d7-99d8-c3f90630c724.jpg?v=1784219768",
      "Prizm Violet": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Violet_a5c2404b-4be5-4592-b885-dbe2237f1235.jpg?v=1784220285",
      // Gepolariseerd
      "Prizm Grey Polarized": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Grey_457501ed-39f8-432a-ab59-c6df902d8ee8.jpg?v=1784219906",
      "Prizm 24K Polarized":        CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-24K.jpg?v=1784209055",
      "Prizm Black Polarized": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Black_e77778b0-40dc-43f1-90ce-34fdf58edde7.jpg?v=1784219809",
      "Prizm Deep Water Polarized": CDN+"Oakley-Holbrook-op-sterkte-matte-black-prizm-deep-water-polarized.jpg?v=1783771847",
      "Prizm Jade Polarized":       CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Jade_2580e18f-cd8a-40fd-a37f-b15797923f61.jpg?v=1784216077",
      "Prizm Ruby Polarized": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Ruby_636416b6-218d-49f8-ad47-66dfe2dac4f4.jpg?v=1784220098",
      "Prizm Rose Gold Polarized":  CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Rose-Gold.jpg?v=1784219607",
      "Prizm Sapphire Polarized": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Sapphire_9ce7f49b-a912-4805-9932-d6d9efa07f34.jpg?v=1784219663",
      "Prizm Tungsten Polarized": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Tungsten_de4c9af0-9872-48d7-99d8-c3f90630c724.jpg?v=1784219768",
      "Prizm Violet Polarized": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Violet_a5c2404b-4be5-4592-b885-dbe2237f1235.jpg?v=1784220285",
    }
  },
  {
    naam: "Matte Brown Tortoise",
    kleur: "#5a3a1a",
    foto: CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Jade.jpg?v=1784223028",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Photochromic-binnen.jpg?v=1784271179",
      CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Photochromic-felle-zon.jpg?v=1784271227",
    ],
    lensFotos: {
      "Prizm 24K": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-24K.jpg?v=1784222009",
      "Prizm Black": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Black.jpg?v=1784223709",
      "Prizm Grey": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Grey.jpg?v=1784270603",
      "Prizm Dark Golf": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Dark-Golf.jpg?v=1784222091",
      "Prizm Field": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Field.jpg?v=1784270481",
      "Prizm Golf": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Golf.jpg?v=1784222927",
      "Prizm Jade": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Jade.jpg?v=1784223028",
      "Prizm Road": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Road.jpg?v=1784270695",
      "Prizm Road Jade": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Road-Jade.jpg?v=1784270761",
      "Prizm Road Black": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Road-Black.jpg?v=1784223099",
      "Prizm Rose Gold": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Rose-Gold.jpg?v=1784223551",
      "Prizm Ruby": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Ruby.jpg?v=1784270809",
      "Prizm Sapphire": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Sapphire.jpg?v=1784223606",
      "Prizm Trail": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Trail.jpg?v=1784270876",
      "Prizm Tungsten": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Tungsten.jpg?v=1784223644",
      "Prizm Violet": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Violet.jpg?v=1784270930",
      // Gepolariseerd
      "Prizm Grey Polarized": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Grey.jpg?v=1784270603",
      "Prizm 24K Polarized":        CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-24K.jpg?v=1784222009",
      "Prizm Black Polarized": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Black.jpg?v=1784223709",
      "Prizm Deep Water Polarized": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Deep-Water-Polarized.jpg?v=1784271005",
      "Prizm Sapphire Polarized": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Sapphire.jpg?v=1784223606",
      "Prizm Jade Polarized": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Jade.jpg?v=1784223028",
      "Prizm Tungsten Polarized": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Tungsten.jpg?v=1784223644",
      "Prizm Rose Gold Polarized":  CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Rose-Gold.jpg?v=1784223551",
      "Prizm Ruby Polarized": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Ruby.jpg?v=1784270809",
      "Prizm Violet Polarized": CDN+"Oakley-Holbrook-op-sterkte-Brown-Tortoise-Prizm-Violet.jpg?v=1784270930",
    }
  },
  {
    naam: "Polished Black",
    kleur: "#111111",
    foto: CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Ruby.jpg?v=1784272602",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Photochromic-binnen.jpg?v=1784272759",
      CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Photochromic-felle-zon.jpg?v=1784272800",
    ],
    lensFotos: {
      // Niet gepolariseerd
      "Prizm 24K": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-24K.jpg?v=1784271821",
      "Prizm Black": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Black.jpg?v=1784272347",
      "Prizm Dark Golf": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Dark-Golf.jpg?v=1784271893",
      "Prizm Field":      CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Field.jpg?v=1784272390",
      "Prizm Golf": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Golf.jpg?v=1784271930",
      "Prizm Grey": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Grey.jpg?v=1784272425",
      "Prizm Jade": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Jade.jpg?v=1784271980",
      "Prizm Road": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Road.jpg?v=1784272508",
      "Prizm Road Jade":  CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Road-Jade.jpg?v=1784272564",
      "Prizm Road Black": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Road-Black.jpg?v=1784272087",
      "Prizm Rose Gold": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Rose-Gold.jpg?v=1784272139",
      "Prizm Ruby": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Ruby.jpg?v=1784272602",
      "Prizm Sapphire": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Sapphire.jpg?v=1784272244",
      "Prizm Trail": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Trail.jpg?v=1784272659",
      "Prizm Tungsten": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Tungsten.jpg?v=1784272282",
      "Prizm Violet": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Violet.jpg?v=1784272707",
      // Gepolariseerd
      "Prizm Grey Polarized": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Grey.jpg?v=1784272425",
      "Prizm 24K Polarized": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-24K.jpg?v=1784271821",
      "Prizm Black Polarized": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Black.jpg?v=1784272347",
      "Prizm Deep Water Polarized": CDN+"Oakley-Holbrook-opsterkte-Polished-Black-Prizm-Deep-Water-Polarized.jpg?v=1784028252",
      "Prizm Sapphire Polarized": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Sapphire.jpg?v=1784272244",
      "Prizm Jade Polarized": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Jade.jpg?v=1784271980",
      "Prizm Tungsten Polarized": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Tungsten.jpg?v=1784272282",
      "Prizm Rose Gold Polarized": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Rose-Gold.jpg?v=1784272139",
      "Prizm Ruby Polarized": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Ruby.jpg?v=1784272602",
      "Prizm Violet Polarized": CDN+"Oakley-Holbrook-op-sterkte-Polished-Black-Prizm-Violet.jpg?v=1784272707",
      // TODO: transitions nog toe te voegen
    }
  },
  // TODO: meer montuurkleuren toevoegen
  {
    naam: "Woodgrain",
    kleur: "#8a7a6a",
    foto: CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-24k.jpg?v=1784280239",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-Photochromic-binnen.jpg?v=1784282041",
      CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-Photochromic-felle-zon.jpg?v=1784282167",
    ],
    lensFotos: {
      // Niet gepolariseerd
      "Prizm 24K":        CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-24k.jpg?v=1784280239",
      "Prizm Black":      CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Black.jpg?v=1784281354",
      "Prizm Dark Golf":  CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-dark-golf.jpg?v=1784280148",
      "Prizm Field":      CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Field.jpg?v=1784281401",
      "Prizm Golf":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-golf.jpg?v=1784280248",
      "Prizm Grey":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Grey.jpg?v=1784281459",
      "Prizm Jade":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Jade.jpg?v=1784280779",
      "Prizm Road":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Road.jpg?v=1784281511",
      "Prizm Road Jade":  CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-road-jade.jpg?v=1784281559",
      "Prizm Rose Gold":  CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Rose-Gold.jpg?v=1784281160",
      "Prizm Ruby":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-ruby.jpg?v=1784281600",
      "Prizm Sapphire":   CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Sapphire.jpg?v=1784281210",
      "Prizm Trail":      CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-trail.jpg?v=1784281660",
      "Prizm Tungsten":   CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Tunsgsten.jpg?v=1784281290",
      "Prizm Violet":     CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-violet.jpg?v=1784281710",
      // Gepolariseerd
      "Prizm 24K Polarized":        CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-24k.jpg?v=1784280239",
      "Prizm Black Polarized":      CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Black.jpg?v=1784281354",
      "Prizm Deep Water Polarized": CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-deep-water.jpg?v=1784282576",
      "Prizm Grey Polarized":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Grey.jpg?v=1784281459",
      "Prizm Jade Polarized":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Jade.jpg?v=1784280779",
      "Prizm Rose Gold Polarized":  CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Rose-Gold.jpg?v=1784281160",
      "Prizm Ruby Polarized":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-ruby.jpg?v=1784281600",
      "Prizm Sapphire Polarized":   CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Sapphire.jpg?v=1784281210",
      "Prizm Tungsten Polarized":   CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Tunsgsten.jpg?v=1784281290",
      "Prizm Violet Polarized":     CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-violet.jpg?v=1784281710",
    }
  },
];

// ============================================================
// EYEJACKET REDUX MONTUURKLEUREN
// Alleen Matte Black. Overige montuurkleuren volgen later.
// ============================================================
const EYEJACKET_MONTUURKLEUREN = [
  {
    naam: "Matte Black",
    kleur: "#2a2a2a",
    foto: EYEJACKET_MATTE_BLACK_PRIZM_GREY,
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Photochromic-binnen.jpg?v=1784702885",
      CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Photochromic-felle-zon.jpg?v=1784702938",
    ],
    lensFotos: {
      // Niet gepolariseerd
      "Prizm 24K": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Prizm-24K.jpg?v=1784664989",
      "Prizm Black": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Prizm-Black.jpg?v=1784665135",
      "Prizm Dark Golf": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Dark-Golf.jpg?v=1784665198",
      "Prizm Field": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Prizm-Field.jpg?v=1784665248",
      "Prizm Golf": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Prizm-Golf.jpg?v=1784665306",
      "Prizm Grey": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Grey.jpg?v=1784655688",
      "Prizm Jade": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Prizm-Jade.jpg?v=1784665365",
      "Prizm Road": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Prizm-Road.jpg?v=1784665449",
      "Prizm Road Black": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Prizm-Road-Black1.jpg?v=1784703164",
      "Prizm Road Jade": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Prizm-Road-Jade.jpg?v=1784665565",
      "Prizm Rose Gold": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Prizm-Rose-Gold.jpg?v=1784665627",
      "Prizm Ruby": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Prizm-Ruby.jpg?v=1784665669",
      "Prizm Sapphire": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Prizm-Sapphire.jpg?v=1784665716",
      "Prizm Trail": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Prizm-Trail.jpg?v=1784665769",
      "Prizm Tungsten": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Prizm-Tungsten.jpg?v=1784665870",
      "Prizm Violet": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Prizm-Violet.jpg?v=1784665953",
      // Gepolariseerd — zelfde lenskleur, zelfde foto
      "Prizm 24K Polarized": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Prizm-24K.jpg?v=1784664989",
      "Prizm Black Polarized": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Prizm-Black.jpg?v=1784665135",
      "Prizm Grey Polarized": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Grey.jpg?v=1784655688",
      "Prizm Jade Polarized": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Prizm-Jade.jpg?v=1784665365",
      "Prizm Rose Gold Polarized": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Prizm-Rose-Gold.jpg?v=1784665627",
      "Prizm Ruby Polarized": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Prizm-Ruby.jpg?v=1784665669",
      "Prizm Sapphire Polarized": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Prizm-Sapphire.jpg?v=1784665716",
      "Prizm Tungsten Polarized": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Prizm-Tungsten.jpg?v=1784665870",
      "Prizm Violet Polarized": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Prizm-Violet.jpg?v=1784665953",
      "Prizm Deep Water Polarized": CDN+"Oakley-Eyejacket-Op-Sterkte-Matte-Black-Prizm-Deep-Water.jpg?v=1784665811",
    }
  },
  {
    naam: "Silver",
    kleur: "#c4c7ca",
    foto: CDN+"Oakley-Eyejacket-Op-Sterkte-SIlver-Prizm-Ruby.jpg?v=1784916471",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Eyejacket-Redux-Op-Sterkte-Silver-Photochromic.jpg?v=1784917577",
      CDN+"Oakley-Eyejacket-Redux-Op-Sterkte-Silver-Photochromic-felle-zon.jpg?v=1784918298",
    ],
    lensFotos: {
      // Niet gepolariseerd
      "Prizm 24K": CDN+"Oakley-Eyejacket-Redux-Op-Sterkte-Silver-Prizm-24K.jpg?v=1784916676",
      "Prizm Black": CDN+"Oakley-Eyejacket-Op-Sterkte-SIlver-Prizm-Black.jpg?v=1784916433",
      "Prizm Dark Golf": CDN+"Oakley-Eyejacket-Redux-Op-Sterkte-Silver-Prizm-Dark-Golf.jpg?v=1784916893",
      "Prizm Field": CDN+"Oakley-Eyejacket-Redux-Op-Sterkte-Silver-Prizm-Field.jpg?v=1784917048",
      "Prizm Golf": CDN+"Oakley-Eyejacket-Redux-Op-Sterkte-Silver-Prizm-Golf.jpg?v=1784916852",
      "Prizm Grey": EYEJACKET_SILVER_PRIZM_GREY,
      "Prizm Jade": CDN+"Oakley-Eyejacket-Redux-Op-Sterkte-Silver-Prizm-Jade.jpg?v=1784916721",
      "Prizm Road": CDN+"Oakley-Eyejacket-Redux-Op-Sterkte-Silver-Prizm-Road.jpg?v=1784916953",
      // "Prizm Road Black": niet beschikbaar in Silver -> verborgen via bouwLenzenGrid
      "Prizm Road Jade": CDN+"Oakley-Eyejacket-Redux-Op-Sterkte-Silver-Prizm-Road-Jade.jpg?v=1784917004",
      "Prizm Rose Gold": CDN+"Oakley-Eyejacket-Redux-Op-Sterkte-Silver-Prizm-Rose-Gold.jpg?v=1784916639",
      "Prizm Ruby": CDN+"Oakley-Eyejacket-Op-Sterkte-SIlver-Prizm-Ruby.jpg?v=1784916471",
      "Prizm Sapphire": CDN+"Oakley-Eyejacket-Op-Sterkte-Silver-Prizm-Sapphire.jpg?v=1784916559",
      "Prizm Trail": CDN+"Oakley-Eyejacket-Redux-Op-Sterkte-Silver-Prizm-Trail.jpg?v=1784917109",
      "Prizm Tungsten": CDN+"Oakley-Eyejacket-Redux-Op-Sterkte-Silver-Prizm-Tungsten.jpg?v=1784916602",
      "Prizm Violet": CDN+"Oakley-Eyejacket-Op-Sterkte-Silver-Prizm-Violet.jpg?v=1784919063",
      // Gepolariseerd — zelfde lenskleur, zelfde foto
      "Prizm 24K Polarized": CDN+"Oakley-Eyejacket-Redux-Op-Sterkte-Silver-Prizm-24K.jpg?v=1784916676",
      "Prizm Black Polarized": CDN+"Oakley-Eyejacket-Op-Sterkte-SIlver-Prizm-Black.jpg?v=1784916433",
      "Prizm Grey Polarized": EYEJACKET_SILVER_PRIZM_GREY,
      "Prizm Jade Polarized": CDN+"Oakley-Eyejacket-Redux-Op-Sterkte-Silver-Prizm-Jade.jpg?v=1784916721",
      "Prizm Rose Gold Polarized": CDN+"Oakley-Eyejacket-Redux-Op-Sterkte-Silver-Prizm-Rose-Gold.jpg?v=1784916639",
      "Prizm Ruby Polarized": CDN+"Oakley-Eyejacket-Op-Sterkte-SIlver-Prizm-Ruby.jpg?v=1784916471",
      "Prizm Sapphire Polarized": CDN+"Oakley-Eyejacket-Op-Sterkte-Silver-Prizm-Sapphire.jpg?v=1784916559",
      "Prizm Tungsten Polarized": CDN+"Oakley-Eyejacket-Redux-Op-Sterkte-Silver-Prizm-Tungsten.jpg?v=1784916602",
      "Prizm Violet Polarized": CDN+"Oakley-Eyejacket-Op-Sterkte-Silver-Prizm-Violet.jpg?v=1784919063",
      "Prizm Deep Water Polarized": CDN+"Oakley-Eyejacket-Redux-Op-Sterkte-Silver-Prizm-Deep-Water.jpg?v=1784916796",
    }
  },
  // TODO: meer montuurkleuren toevoegen
];


// ============================================================
// HOLBROOK XXL MONTUURKLEUREN
// Foto's identiek aan de Holbrook XL; alleen Matte Black en Woodgrain.
// ============================================================
const HOLBROOK_XXL_MONTUURKLEUREN = [
  {
    naam: "Matte Black",
    kleur: "#2a2a2a",
    foto: CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Ruby_636416b6-218d-49f8-ad47-66dfe2dac4f4.jpg?v=1784220098",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Photochromic-binnen.jpg?v=1784221370",
      CDN+"Oakley-Holbrook-Opsterkte-Matte-Black-Photochromic2-felle-zon.jpg?v=1784488187",
    ],
    lensFotos: {
      "Prizm 24K":        CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-24K.jpg?v=1784209055",
      "Prizm Black": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Black_e77778b0-40dc-43f1-90ce-34fdf58edde7.jpg?v=1784219809",
      "Prizm Grey": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Grey_457501ed-39f8-432a-ab59-c6df902d8ee8.jpg?v=1784219906",
      "Prizm Dark Golf": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Dark-Golf_11da66ee-2ef0-4460-8f37-e40d343c785d.jpg?v=1784209150",
      "Prizm Field":      CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Field.jpg?v=1784219862",
      "Prizm Golf": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Golf_6cbacd59-4d8e-4ac6-8818-5d1686d802ef.jpg?v=1784209212",
      "Prizm Jade":       CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Jade_2580e18f-cd8a-40fd-a37f-b15797923f61.jpg?v=1784216077",
      "Prizm Road": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Road_16ca0b84-a060-4ce3-8128-355f3dffb298.jpg?v=1784219966",
      "Prizm Road Black": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Road-Black_e8ba07d2-306b-40a1-94ef-266cdb7315fb.jpg?v=1784216151",
      "Prizm Rose Gold":  CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Rose-Gold.jpg?v=1784219607",
      "Prizm Road Jade":  CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Road-Jade.jpg?v=1784220015",
      "Prizm Ruby": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Ruby_636416b6-218d-49f8-ad47-66dfe2dac4f4.jpg?v=1784220098",
      "Prizm Sapphire": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Sapphire_9ce7f49b-a912-4805-9932-d6d9efa07f34.jpg?v=1784219663",
      "Prizm Trail": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Trail_9d1a905c-3372-4c24-9153-2d4af9ffe892.jpg?v=1784220216",
      "Prizm Tungsten": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Tungsten_de4c9af0-9872-48d7-99d8-c3f90630c724.jpg?v=1784219768",
      "Prizm Violet": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Violet_a5c2404b-4be5-4592-b885-dbe2237f1235.jpg?v=1784220285",
      // Gepolariseerd
      "Prizm Grey Polarized": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Grey_457501ed-39f8-432a-ab59-c6df902d8ee8.jpg?v=1784219906",
      "Prizm 24K Polarized":        CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-24K.jpg?v=1784209055",
      "Prizm Black Polarized": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Black_e77778b0-40dc-43f1-90ce-34fdf58edde7.jpg?v=1784219809",
      "Prizm Deep Water Polarized": CDN+"Oakley-Holbrook-op-sterkte-matte-black-prizm-deep-water-polarized.jpg?v=1783771847",
      "Prizm Jade Polarized":       CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Jade_2580e18f-cd8a-40fd-a37f-b15797923f61.jpg?v=1784216077",
      "Prizm Ruby Polarized": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Ruby_636416b6-218d-49f8-ad47-66dfe2dac4f4.jpg?v=1784220098",
      "Prizm Rose Gold Polarized":  CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Rose-Gold.jpg?v=1784219607",
      "Prizm Sapphire Polarized": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Sapphire_9ce7f49b-a912-4805-9932-d6d9efa07f34.jpg?v=1784219663",
      "Prizm Tungsten Polarized": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Tungsten_de4c9af0-9872-48d7-99d8-c3f90630c724.jpg?v=1784219768",
      "Prizm Violet Polarized": CDN+"Oakley-Holbrook-op-sterkte-Matte-Black-Prizm-Violet_a5c2404b-4be5-4592-b885-dbe2237f1235.jpg?v=1784220285",
    }
  },
  {
    naam: "Woodgrain",
    kleur: "#8a7a6a",
    foto: CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Tunsgsten.jpg?v=1784281290",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-Photochromic-binnen.jpg?v=1784282041",
      CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-Photochromic-felle-zon.jpg?v=1784282167",
    ],
    lensFotos: {
      // Niet gepolariseerd
      "Prizm 24K":        CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-24k.jpg?v=1784280239",
      "Prizm Black":      CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Black.jpg?v=1784281354",
      "Prizm Dark Golf":  CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-dark-golf.jpg?v=1784280148",
      "Prizm Field":      CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Field.jpg?v=1784281401",
      "Prizm Golf":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-golf.jpg?v=1784280248",
      "Prizm Grey":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Grey.jpg?v=1784281459",
      "Prizm Jade":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Jade.jpg?v=1784280779",
      "Prizm Road":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Road.jpg?v=1784281511",
      "Prizm Road Jade":  CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-road-jade.jpg?v=1784281559",
      "Prizm Rose Gold":  CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Rose-Gold.jpg?v=1784281160",
      "Prizm Ruby":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-ruby.jpg?v=1784281600",
      "Prizm Sapphire":   CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Sapphire.jpg?v=1784281210",
      "Prizm Trail":      CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-trail.jpg?v=1784281660",
      "Prizm Tungsten":   CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Tunsgsten.jpg?v=1784281290",
      "Prizm Violet":     CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-violet.jpg?v=1784281710",
      // Gepolariseerd
      "Prizm 24K Polarized":        CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-24k.jpg?v=1784280239",
      "Prizm Black Polarized":      CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Black.jpg?v=1784281354",
      "Prizm Deep Water Polarized": CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-deep-water.jpg?v=1784282576",
      "Prizm Grey Polarized":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Grey.jpg?v=1784281459",
      "Prizm Jade Polarized":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Jade.jpg?v=1784280779",
      "Prizm Rose Gold Polarized":  CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Rose-Gold.jpg?v=1784281160",
      "Prizm Ruby Polarized":       CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-ruby.jpg?v=1784281600",
      "Prizm Sapphire Polarized":   CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Sapphire.jpg?v=1784281210",
      "Prizm Tungsten Polarized":   CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-Tunsgsten.jpg?v=1784281290",
      "Prizm Violet Polarized":     CDN+"Oakley-Holbrook-op-sterkte-Woodgrain-prizm-violet.jpg?v=1784281710",
    }
  },
  // TODO: meer montuurkleuren toevoegen
];

// ============================================================
// BISPHAERA MONTUURKLEUREN
// Alleen Matte Black. Overige montuurkleuren volgen later.
// ============================================================
const BISPHAERA_MONTUURKLEUREN = [
  {
    naam: "Matte Black",
    kleur: "#2a2a2a",
    foto: BISPHAERA_MINIATUUR,
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Photochromic-binnen.jpg?v=1784749066",
      CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Photochromic-felle-zon.jpg?v=1784749127",
    ],
    lensFotos: {
      // Niet gepolariseerd
      "Prizm 24K": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-24K.jpg?v=1784747624",
      "Prizm Black": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Black.jpg?v=1784747689",
      "Prizm Dark Golf": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Dark-Golf.jpg?v=1784750813",
      "Prizm Field": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Field.jpg?v=1784747799",
      "Prizm Golf": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Golf1.jpg?v=1784747913",
      "Prizm Grey": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Grey.jpg?v=1784748226",
      "Prizm Jade": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Jade.jpg?v=1784748386",
      "Prizm Road": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Road.jpg?v=1784748441",
      "Prizm Road Jade": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Road-Jade.jpg?v=1784748487",
      "Prizm Rose Gold": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Rose-Gold.jpg?v=1784748547",
      "Prizm Ruby": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Ruby.jpg?v=1784748606",
      "Prizm Sapphire": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Sapphire.jpg?v=1784748708",
      "Prizm Trail": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Trail.jpg?v=1784748800",
      "Prizm Trail Torch": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Trail-Torch.jpg?v=1784748862",
      "Prizm Tungsten": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Tungsten.jpg?v=1784748920",
      "Prizm Violet": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Violet.jpg?v=1784748989",
      // Gepolariseerd — zelfde lenskleur, zelfde foto
      "Prizm Deep Water Polarized": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Deep-Water.jpg?v=1784749308",
      "Prizm 24K Polarized": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-24K.jpg?v=1784747624",
      "Prizm Black Polarized": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Black.jpg?v=1784747689",
      "Prizm Grey Polarized": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Grey.jpg?v=1784748226",
      "Prizm Jade Polarized": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Jade.jpg?v=1784748386",
      "Prizm Rose Gold Polarized": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Rose-Gold.jpg?v=1784748547",
      "Prizm Ruby Polarized": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Ruby.jpg?v=1784748606",
      "Prizm Sapphire Polarized": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Sapphire.jpg?v=1784748708",
      "Prizm Tungsten Polarized": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Tungsten.jpg?v=1784748920",
      "Prizm Violet Polarized": CDN+"Oakley-Bisphaera-Op-Sterkte-Matte-Black-Prizm-Violet.jpg?v=1784748989",
    }
  },
  {
    naam: "Steel",
    kleur: "#868d94",
    foto: CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Sapphire.jpg?v=1784988945",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Photochromic-binnen.jpg?v=1784989548",
      CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Photochromic-felle-zon.jpg?v=1784989584",
    ],
    lensFotos: {
      "Prizm 24K": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-24K.jpg?v=1784989112",
      "Prizm Black": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Black.jpg?v=1784988718",
      "Prizm Dark Golf": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Dark-Golf.jpg?v=1784989252",
      "Prizm Field": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Field.jpg?v=1784989362",
      "Prizm Golf": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Golf.jpg?v=1784989215",
      "Prizm Grey": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Grey.jpg?v=1784988620",
      "Prizm Jade": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Jade.jpg?v=1784989148",
      "Prizm Road": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Road.jpg?v=1784989286",
      "Prizm Road Jade": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Road-Jade.jpg?v=1784989316",
      "Prizm Rose Gold": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Rose-Gold.jpg?v=1784989075",
      "Prizm Ruby": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Ruby.jpg?v=1784988909",
      "Prizm Sapphire": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Sapphire.jpg?v=1784988945",
      "Prizm Trail": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Trail.jpg?v=1784989499",
      "Prizm Trail Torch": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Trail-Torch.jpg?v=1784989461",
      "Prizm Tungsten": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Tungsten.jpg?v=1784988977",
      "Prizm Violet": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Violet.jpg?v=1784989018",
      "Prizm 24K Polarized": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-24K.jpg?v=1784989112",
      "Prizm Black Polarized": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Black.jpg?v=1784988718",
      "Prizm Grey Polarized": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Grey.jpg?v=1784988620",
      "Prizm Jade Polarized": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Jade.jpg?v=1784989148",
      "Prizm Rose Gold Polarized": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Rose-Gold.jpg?v=1784989075",
      "Prizm Ruby Polarized": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Ruby.jpg?v=1784988909",
      "Prizm Sapphire Polarized": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Sapphire.jpg?v=1784988945",
      "Prizm Tungsten Polarized": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Tungsten.jpg?v=1784988977",
      "Prizm Violet Polarized": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Violet.jpg?v=1784989018",
      "Prizm Deep Water Polarized": CDN+"Oakley-Bisphaera-Op-Sterkte-Steel-Prizm-Deep-Water.jpg?v=1784989182",
    }
  },
  // TODO: meer montuurkleuren toevoegen
];

// ============================================================
// SPLIT SHOT MONTUURKLEUREN
// Alleen Matte Black. Zelfde opbouw als de Flak 2.0 XL.
// ============================================================
const SPLITSHOT_MONTUURKLEUREN = [
  {
    naam: "Matte Black",
    kleur: "#2a2a2a",
    foto: SPLITSHOT_MINIATUUR,
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Photochromic-binnen.jpg?v=1784795631",
      CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Photochromic-felle-zon.jpg?v=1784795687",
    ],
    lensFotos: {
      // Niet gepolariseerd
      "Prizm 24K": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-24k.jpg?v=1784794203",
      "Prizm Black": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Black.jpg?v=1784794267",
      "Prizm Dark Golf": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Dark-Golf.jpg?v=1784794487",
      "Prizm Field": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Field.jpg?v=1784794588",
      "Prizm Golf": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Golf.jpg?v=1784794531",
      "Prizm Grey": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Grey.jpg?v=1784794785",
      "Prizm Jade": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Jade.jpg?v=1784794820",
      "Prizm Road": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Road.jpg?v=1784794864",
      "Prizm Road Jade": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Road-Jade.jpg?v=1784794896",
      "Prizm Rose Gold": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Rose-Gold.jpg?v=1784794940",
      "Prizm Ruby": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Ruby.jpg?v=1784794971",
      "Prizm Sapphire": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Sapphire.jpg?v=1784795055",
      "Prizm Trail": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Trail.jpg?v=1784795092",
      "Prizm Trail Torch": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Trail-Torch.jpg?v=1784795130",
      "Prizm Tungsten": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Tungsten.jpg?v=1784795173",
      "Prizm Violet": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Violet.jpg?v=1784795220",
      // Gepolariseerd — zelfde lenskleur, zelfde foto
      "Prizm 24K Polarized": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-24k.jpg?v=1784794203",
      "Prizm Black Polarized": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Black.jpg?v=1784794267",
      "Prizm Grey Polarized": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Grey.jpg?v=1784794785",
      "Prizm Jade Polarized": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Jade.jpg?v=1784794820",
      "Prizm Rose Gold Polarized": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Rose-Gold.jpg?v=1784794940",
      "Prizm Ruby Polarized": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Ruby.jpg?v=1784794971",
      "Prizm Sapphire Polarized": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Sapphire.jpg?v=1784795055",
      "Prizm Tungsten Polarized": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Tungsten.jpg?v=1784795173",
      "Prizm Violet Polarized": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Violet.jpg?v=1784795220",
      "Prizm Deep Water Polarized": CDN+"Oakley-Split-Shot-Op-Sterkte-Matte-Black-Prizm-Deep-Water.jpg?v=1784794359",
    }
  },
  // TODO: meer montuurkleuren toevoegen
];

// ============================================================
// LATCH MONTUURKLEUREN
// Alleen Matte Black. Zelfde opbouw als de andere zonnebrillen.
// ============================================================
const LATCH_MONTUURKLEUREN = [
  {
    naam: "Matte Black",
    kleur: "#2a2a2a",
    foto: LATCH_MINIATUUR,
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Photochromic-binnen.jpg?v=1784825659",
      CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Photochromic.jpg?v=1784825713",
    ],
    lensFotos: {
      // Niet gepolariseerd
      "Prizm 24K": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-24K.jpg?v=1784811876",
      "Prizm Black": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Black.jpg?v=1784811976",
      "Prizm Dark Golf": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Dark-Golf.jpg?v=1784812173",
      "Prizm Field": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Field.jpg?v=1784812233",
      "Prizm Golf": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Golf.jpg?v=1784812266",
      "Prizm Grey": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Grey.jpg?v=1784812312",
      "Prizm Jade": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Jade.jpg?v=1784812378",
      "Prizm Road": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Road.jpg?v=1784824917",
      "Prizm Road Black": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Road-Black.jpg?v=1784824948",
      "Prizm Road Jade": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Road-Jade.jpg?v=1784824990",
      "Prizm Rose Gold": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Rose-Gold.jpg?v=1784825083",
      "Prizm Ruby": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Ruby.jpg?v=1784825141",
      "Prizm Sapphire": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Sapphire.jpg?v=1784825184",
      "Prizm Trail": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Trail.jpg?v=1784825471",
      "Prizm Tungsten": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Tungsten.jpg?v=1784825521",
      "Prizm Violet": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Violet.jpg?v=1784825561",
      // Gepolariseerd — zelfde lenskleur, zelfde foto
      "Prizm 24K Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-24K.jpg?v=1784811876",
      "Prizm Black Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Black.jpg?v=1784811976",
      "Prizm Grey Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Grey.jpg?v=1784812312",
      "Prizm Jade Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Jade.jpg?v=1784812378",
      "Prizm Rose Gold Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Rose-Gold.jpg?v=1784825083",
      "Prizm Ruby Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Ruby.jpg?v=1784825141",
      "Prizm Sapphire Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Sapphire.jpg?v=1784825184",
      "Prizm Tungsten Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Tungsten.jpg?v=1784825521",
      "Prizm Violet Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Violet.jpg?v=1784825561",
      "Prizm Deep Water Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Black-Prizm-Deep-Water.jpg?v=1784825602",
    }
  },
  {
    naam: "Matte Brown Tortoise",
    kleur: "#6e4b2a",
    foto: CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Ruby.jpg?v=1784972915",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Photochromic-binnen.jpg?v=1784978999",
      CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Photochromic-felle-zon.jpg?v=1784979037",
    ],
    lensFotos: {
      "Prizm 24K": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-24K.jpg?v=1784973142",
      "Prizm Black": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Black.jpg?v=1784972868",
      "Prizm Dark Golf": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Dark-Golf.jpg?v=1784973374",
      "Prizm Field": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Field.jpg?v=1784973552",
      "Prizm Golf": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Golf.jpg?v=1784973329",
      "Prizm Grey": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Grey.jpg?v=1784972722",
      "Prizm Jade": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Jade.jpg?v=1784973211",
      "Prizm Road": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Road.jpg?v=1784973445",
      "Prizm Road Black": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Road-Black.jpg?v=1784973591",
      "Prizm Road Jade": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Road-Jade.jpg?v=1784973480",
      "Prizm Rose Gold": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Rose-Gold.jpg?v=1784973100",
      "Prizm Ruby": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Ruby.jpg?v=1784972915",
      "Prizm Sapphire": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Sapphire.jpg?v=1784972980",
      "Prizm Trail": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Trail.jpg?v=1784978953",
      "Prizm Tungsten": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Tungsten.jpg?v=1784973017",
      "Prizm Violet": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Violet.jpg?v=1784973061",
      "Prizm 24K Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-24K.jpg?v=1784973142",
      "Prizm Black Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Black.jpg?v=1784972868",
      "Prizm Grey Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Grey.jpg?v=1784972722",
      "Prizm Jade Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Jade.jpg?v=1784973211",
      "Prizm Rose Gold Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Rose-Gold.jpg?v=1784973100",
      "Prizm Ruby Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Ruby.jpg?v=1784972915",
      "Prizm Sapphire Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Sapphire.jpg?v=1784972980",
      "Prizm Tungsten Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Tungsten.jpg?v=1784973017",
      "Prizm Violet Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Violet.jpg?v=1784973061",
      "Prizm Deep Water Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Brown-Tortoise-Prizm-Deep-Water.jpg?v=1784973246",
    }
  },
  {
    naam: "Matte Grey Ink",
    kleur: "#6c7178",
    foto: CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Sapphire.jpg?v=1784980353",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Photochromic-Binnen.jpg?v=1784980959",
      CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Photochromic-felle-zon.jpg?v=1784981000",
    ],
    lensFotos: {
      "Prizm 24K": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-24K.jpg?v=1784980565",
      "Prizm Black": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Black.jpg?v=1784980206",
      "Prizm Dark Golf": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Dark-Golf.jpg?v=1784980716",
      "Prizm Field": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Field.jpg?v=1784980820",
      "Prizm Golf": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Golf.jpg?v=1784980683",
      "Prizm Grey": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Grey.jpg?v=1784980148",
      "Prizm Jade": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Jade.jpg?v=1784980601",
      "Prizm Road": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Road.jpg?v=1784980748",
      "Prizm Road Black": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Road-Black.jpg?v=1784980859",
      "Prizm Road Jade": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Road-Jade.jpg?v=1784980785",
      "Prizm Rose Gold": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Rose-Gold.jpg?v=1784980534",
      "Prizm Ruby": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Ruby.jpg?v=1784980263",
      "Prizm Sapphire": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Sapphire.jpg?v=1784980353",
      "Prizm Trail": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Trail.jpg?v=1784980901",
      "Prizm Tungsten": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Tungsten.jpg?v=1784980434",
      "Prizm Violet": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Violet.jpg?v=1784980470",
      "Prizm 24K Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-24K.jpg?v=1784980565",
      "Prizm Black Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Black.jpg?v=1784980206",
      "Prizm Grey Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Grey.jpg?v=1784980148",
      "Prizm Jade Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Jade.jpg?v=1784980601",
      "Prizm Rose Gold Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Rose-Gold.jpg?v=1784980534",
      "Prizm Ruby Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Ruby.jpg?v=1784980263",
      "Prizm Sapphire Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Sapphire.jpg?v=1784980353",
      "Prizm Tungsten Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Tungsten.jpg?v=1784980434",
      "Prizm Violet Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Violet.jpg?v=1784980470",
      "Prizm Deep Water Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Grey-Ink-Prizm-Deep-Water.jpg?v=1784980640",
    }
  },
  {
    naam: "Matte Sepia",
    kleur: "#b39b7d",
    foto: CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Jade.jpg?v=1784984669",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Photochromic-binnen.jpg?v=1784985046",
      CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Photochromic-felle-zon.jpg?v=1784985083",
    ],
    lensFotos: {
      "Prizm 24K": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-24K.jpg?v=1784982289",
      "Prizm Black": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Black.jpg?v=1784982086",
      "Prizm Dark Golf": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Dark-Golf.jpg?v=1784984802",
      "Prizm Field": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Field.jpg?v=1784984908",
      "Prizm Golf": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Golf.jpg?v=1784984762",
      "Prizm Grey": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Grey.jpg?v=1784982038",
      "Prizm Jade": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Jade.jpg?v=1784984669",
      "Prizm Road": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Road.jpg?v=1784984840",
      "Prizm Road Black": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Road-Black.jpg?v=1784984958",
      "Prizm Road Jade": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Road-Jade.jpg?v=1784984878",
      "Prizm Rose Gold": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Rose-Gold.jpg?v=1784982255",
      "Prizm Ruby": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Ruby.jpg?v=1784982121",
      "Prizm Sapphire": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Sapphire.jpg?v=1784982151",
      "Prizm Trail": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Trail.jpg?v=1784984995",
      "Prizm Tungsten": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Tungsten.jpg?v=1784982184",
      "Prizm Violet": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Violet.jpg?v=1784982225",
      "Prizm 24K Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-24K.jpg?v=1784982289",
      "Prizm Black Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Black.jpg?v=1784982086",
      "Prizm Grey Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Grey.jpg?v=1784982038",
      "Prizm Jade Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Jade.jpg?v=1784984669",
      "Prizm Rose Gold Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Rose-Gold.jpg?v=1784982255",
      "Prizm Ruby Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Ruby.jpg?v=1784982121",
      "Prizm Sapphire Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Sapphire.jpg?v=1784982151",
      "Prizm Tungsten Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Tungsten.jpg?v=1784982184",
      "Prizm Violet Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Violet.jpg?v=1784982225",
      "Prizm Deep Water Polarized": CDN+"Oakley-Latch-Op-Sterkte-Matte-Sepia-Prizm-Deep-Water.jpg?v=1784984717",
    }
  },
  // TODO: meer montuurkleuren toevoegen
];

// ============================================================
// GIBSTON MONTUURKLEUREN
// Alleen Matte Black. Zelfde lensopbouw als de andere zonnebrillen.
// ============================================================
const GIBSTON_MONTUURKLEUREN = [
  {
    naam: "Matte Black",
    kleur: "#2a2a2a",
    uitverkocht: true,   // tijdelijk niet leverbaar
    foto: GIBSTON_MINIATUUR,
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Photochromic-binnen.jpg?v=1784882892",
      CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Photochromic-felle-zon.jpg?v=1784882930",
    ],
    lensFotos: {
      // Niet gepolariseerd
      "Prizm 24K":        CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-24K.jpg?v=1784881966",
      "Prizm Black":      CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Black.jpg?v=1784882015",
      "Prizm Dark Golf":  CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Dark-Golf.jpg?v=1784882061",
      "Prizm Field":      CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Field.jpg?v=1784882098",
      "Prizm Golf":       CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Golf.jpg?v=1784882136",
      "Prizm Grey":       CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Grey.jpg?v=1784882173",
      "Prizm Jade":       CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Jade.jpg?v=1784882213",
      "Prizm Road":       CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Road.jpg?v=1784882259",
      "Prizm Road Black": CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Road-Black.jpg?v=1784882305",
      "Prizm Road Jade":  CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Road-Jade.jpg?v=1784882346",
      "Prizm Rose Gold":  CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Rose-Gold.jpg?v=1784882384",
      "Prizm Ruby":       CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Ruby.jpg?v=1784882434",
      "Prizm Sapphire":   CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Sapphire.jpg?v=1784882475",
      "Prizm Trail":      CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Trail.jpg?v=1784882530",
      "Prizm Tungsten":   CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Tungsten.jpg?v=1784882580",
      "Prizm Violet":     CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Violet.jpg?v=1784882621",
      // Gepolariseerd — zelfde lenskleur, zelfde foto
      "Prizm 24K Polarized":      CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-24K.jpg?v=1784881966",
      "Prizm Black Polarized":    CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Black.jpg?v=1784882015",
      "Prizm Grey Polarized":     CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Grey.jpg?v=1784882173",
      "Prizm Jade Polarized":     CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Jade.jpg?v=1784882213",
      "Prizm Rose Gold Polarized":CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Rose-Gold.jpg?v=1784882384",
      "Prizm Ruby Polarized":     CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Ruby.jpg?v=1784882434",
      "Prizm Sapphire Polarized": CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Sapphire.jpg?v=1784882475",
      "Prizm Tungsten Polarized": CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Tungsten.jpg?v=1784882580",
      "Prizm Violet Polarized":   CDN+"Oakley-Gibston-Op-Sterkte-Matte-Black-Prizm-Violet.jpg?v=1784882621",
    }
  },
  {
    naam: "Polished Black",
    kleur: "#1a1a1a",
    foto: CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-24K.jpg?v=1784897056",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Photochromic.jpg?v=1784897949",
      CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Photochromic-felle-zon.jpg?v=1784897987",
    ],
    lensFotos: {
      // Niet gepolariseerd
      "Prizm 24K": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-24K.jpg?v=1784897056",
      "Prizm Black": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Black.jpg?v=1784897112",
      "Prizm Dark Golf": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Dark-Golf.jpg?v=1784897494",
      "Prizm Field": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Field.jpg?v=1784897594",
      "Prizm Golf": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Golf.jpg?v=1784897461",
      "Prizm Grey": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Grey.jpg?v=1784897161",
      "Prizm Jade": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Jade.jpg?v=1784897376",
      "Prizm Road": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Road.jpg?v=1784897524",
      "Prizm Road Black": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Road-Black.jpg?v=1784897627",
      "Prizm Road Jade": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Road-Jade.jpg?v=1784897559",
      "Prizm Rose Gold": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Rose-Gold.jpg?v=1784897344",
      "Prizm Ruby": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Ruby.jpg?v=1784897210",
      "Prizm Sapphire": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Sapphire.jpg?v=1784897237",
      "Prizm Trail": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Trail.jpg?v=1784897678",
      "Prizm Tungsten": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Tungsten.jpg?v=1784897272",
      "Prizm Violet": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Violet.jpg?v=1784897312",
      // Gepolariseerd — zelfde foto
      "Prizm 24K Polarized": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-24K.jpg?v=1784897056",
      "Prizm Black Polarized": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Black.jpg?v=1784897112",
      "Prizm Grey Polarized": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Grey.jpg?v=1784897161",
      "Prizm Jade Polarized": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Jade.jpg?v=1784897376",
      "Prizm Rose Gold Polarized": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Rose-Gold.jpg?v=1784897344",
      "Prizm Ruby Polarized": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Ruby.jpg?v=1784897210",
      "Prizm Sapphire Polarized": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Sapphire.jpg?v=1784897237",
      "Prizm Tungsten Polarized": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Tungsten.jpg?v=1784897272",
      "Prizm Violet Polarized": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Violet.jpg?v=1784897312",
      "Prizm Deep Water Polarized": CDN+"Oakley-Gibston-Op-Sterkte-Polished-Black-Prizm-Deep-Water.jpg?v=1784897413",
    }
  },
  {
    naam: "Polished Clear",
    kleur: "#e6e7ea",
    foto: CDN+"Oakley-Gibston-Polished-Clear-Prizm-Sapphire_e5638cc1-4965-4d67-87ee-ebb8c2fa8770.jpg?v=1784920283",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Gibston-Polished-Clear-Photochromic-binnen.jpg?v=1784921039",
      CDN+"Oakley-Gibston-Polished-Clear-Photochromic-felle-zon.jpg?v=1784921078",
    ],
    lensFotos: {
      // Niet gepolariseerd
      "Prizm 24K": CDN+"Oakley-Gibston-Polished-Clear-Prizm-24K.jpg?v=1784920491",
      "Prizm Black": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Black.jpg?v=1784920206",
      "Prizm Dark Golf": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Dark-Golf.jpg?v=1784920736",
      "Prizm Field": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Field.jpg?v=1784920873",
      "Prizm Golf": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Golf.jpg?v=1784920695",
      "Prizm Grey": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Grey.jpg?v=1784920147",
      "Prizm Jade": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Jade-Polarized.jpg?v=1784920583",
      "Prizm Road": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Road.jpg?v=1784920787",
      "Prizm Road Black": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Road-Black.jpg?v=1784920914",
      "Prizm Road Jade": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Road-Jade.jpg?v=1784920831",
      "Prizm Rose Gold": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Rose-Gold.jpg?v=1784920441",
      "Prizm Ruby": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Ruby.jpg?v=1784920246",
      "Prizm Sapphire": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Sapphire_e5638cc1-4965-4d67-87ee-ebb8c2fa8770.jpg?v=1784920283",
      "Prizm Trail": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Trail.jpg?v=1784920954",
      "Prizm Tungsten": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Tungsten.jpg?v=1784920329",
      "Prizm Violet": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Violet.jpg?v=1784920375",
      // Gepolariseerd — zelfde lenskleur, zelfde foto
      "Prizm 24K Polarized": CDN+"Oakley-Gibston-Polished-Clear-Prizm-24K.jpg?v=1784920491",
      "Prizm Black Polarized": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Black.jpg?v=1784920206",
      "Prizm Grey Polarized": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Grey.jpg?v=1784920147",
      "Prizm Jade Polarized": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Jade-Polarized.jpg?v=1784920583",
      "Prizm Rose Gold Polarized": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Rose-Gold.jpg?v=1784920441",
      "Prizm Ruby Polarized": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Ruby.jpg?v=1784920246",
      "Prizm Sapphire Polarized": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Sapphire_e5638cc1-4965-4d67-87ee-ebb8c2fa8770.jpg?v=1784920283",
      "Prizm Tungsten Polarized": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Tungsten.jpg?v=1784920329",
      "Prizm Violet Polarized": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Violet.jpg?v=1784920375",
      "Prizm Deep Water Polarized": CDN+"Oakley-Gibston-Polished-Clear-Prizm-Deep-Water.jpg?v=1784920651",
    }
  },
  // TODO: meer montuurkleuren toevoegen
];

const GIBSTONXL_MONTUURKLEUREN = [
  {
    naam: "Matte Black",
    kleur: "#2a2a2a",
    foto: GIBSTONXL_MINIATUUR,
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Gibston-XL-Op-Sterkte-Matte-Black-Photochromic-Binnen.jpg?v=1784968719",
      CDN+"Oakley-Gibston-XL-Op-Sterkte-Matte-Black-Photochromic-felle-zon.jpg?v=1784968785",
    ],
    lensFotos: {
      "Prizm 24K": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-24K.jpg?v=1784967380",
      "Prizm Black": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Black.jpg?v=1784967006",
      "Prizm Dark Golf": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Dark-Golf.jpg?v=1784967564",
      "Prizm Field": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Field.jpg?v=1784967743",
      "Prizm Golf": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Golf.jpg?v=1784967523",
      "Prizm Grey": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Grey.jpg?v=1784964877",
      "Prizm Jade": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Jade.jpg?v=1784967448",
      "Prizm Road": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Road.jpg?v=1784967635",
      "Prizm Road Black": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Road-Black.jpg?v=1784967844",
      "Prizm Road Jade": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Road-Jade.jpg?v=1784967691",
      "Prizm Rose Gold": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Rose-Gold.jpg?v=1784967330",
      "Prizm Ruby": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Ruby.jpg?v=1784967063",
      "Prizm Sapphire": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Sapphire.jpg?v=1784967106",
      "Prizm Trail": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Trail.jpg?v=1784967879",
      "Prizm Tungsten": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Tungsten.jpg?v=1784967139",
      "Prizm Violet": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Violet.jpg?v=1784967177",
      "Prizm 24K Polarized": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-24K.jpg?v=1784967380",
      "Prizm Black Polarized": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Black.jpg?v=1784967006",
      "Prizm Grey Polarized": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Grey.jpg?v=1784964877",
      "Prizm Jade Polarized": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Jade.jpg?v=1784967448",
      "Prizm Rose Gold Polarized": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Rose-Gold.jpg?v=1784967330",
      "Prizm Ruby Polarized": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Ruby.jpg?v=1784967063",
      "Prizm Sapphire Polarized": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Sapphire.jpg?v=1784967106",
      "Prizm Tungsten Polarized": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Tungsten.jpg?v=1784967139",
      "Prizm Violet Polarized": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Violet.jpg?v=1784967177",
      "Prizm Deep Water Polarized": CDN+"Oakley-Gibston-xl-Matte-Black-Prizm-Deep-Water.jpg?v=1784967487",
    }
  },
  {
    naam: "Polished Clear",
    kleur: "#e6e7ea",
    foto: CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Golf.jpg?v=1784970206",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Photochromic.jpg?v=1784971593",
      CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Photochromic-Felle-zon.jpg?v=1784971628",
    ],
    lensFotos: {
      "Prizm 24K": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-24K.jpg?v=1784970095",
      "Prizm Black": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Black.jpg?v=1784969743",
      "Prizm Dark Golf": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Dark-Golf.jpg?v=1784970237",
      "Prizm Field": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Field.jpg?v=1784971136",
      "Prizm Golf": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Golf.jpg?v=1784970206",
      "Prizm Grey": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Grey.jpg?v=1784968569",
      "Prizm Jade": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Jade.jpg?v=1784970137",
      "Prizm Road": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Road.jpg?v=1784970273",
      "Prizm Road Black": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Road-Black.jpg?v=1784971489",
      "Prizm Road Jade": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Road-Jade.jpg?v=1784971104",
      "Prizm Rose Gold": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Rose-Gold.jpg?v=1784970059",
      "Prizm Ruby": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Ruby.jpg?v=1784969918",
      "Prizm Sapphire": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Sapphire.jpg?v=1784969954",
      "Prizm Trail": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Trail.jpg?v=1784971526",
      "Prizm Tungsten": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Tungsten.jpg?v=1784969989",
      "Prizm Violet": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Violet.jpg?v=1784970039",
      "Prizm 24K Polarized": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-24K.jpg?v=1784970095",
      "Prizm Black Polarized": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Black.jpg?v=1784969743",
      "Prizm Grey Polarized": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Grey.jpg?v=1784968569",
      "Prizm Jade Polarized": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Jade.jpg?v=1784970137",
      "Prizm Rose Gold Polarized": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Rose-Gold.jpg?v=1784970059",
      "Prizm Ruby Polarized": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Ruby.jpg?v=1784969918",
      "Prizm Sapphire Polarized": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Sapphire.jpg?v=1784969954",
      "Prizm Tungsten Polarized": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Tungsten.jpg?v=1784969989",
      "Prizm Violet Polarized": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Violet.jpg?v=1784970039",
      "Prizm Deep Water Polarized": CDN+"Oakley-Gibston-XL-Op-Sterkte-Clear-Prizm-Deep-Water.jpg?v=1784970171",
    }
  },
  // TODO: meer montuurkleuren toevoegen
];




// META HSTN VARIANT IDs EN PRODUCT ID
const META_CONFIG = {
  productId: 15651940827462,
  variantIds: {
    // Clear Enkelvoudig
    'clear-enkelvoudig-1.50-stealth': 56988680421702,
    'clear-enkelvoudig-1.59-stealth': 56988680454470,
    'clear-enkelvoudig-1.67-stealth': 56988680487238,
    'clear-enkelvoudig-1.50-stealth-pro': 56988680520006,
    'clear-enkelvoudig-1.59-stealth-pro': 56988680552774,
    'clear-enkelvoudig-1.67-stealth-pro': 56988680585542,
    // Clear Progressief
    'clear-progressief-1.50-stealth': 56988680618310,
    'clear-progressief-1.59-stealth': 56988680651078,
    'clear-progressief-1.67-stealth': 56988680683846,
    'clear-progressief-1.50-stealth-pro': 56988680716614,
    'clear-progressief-1.59-stealth-pro': 56988680749382,
    'clear-progressief-1.67-stealth-pro': 56988680782150,
    // Transition Gen S Enkelvoudig
    'transitions-enkelvoudig-1.50-stealth': 56988680814918,
    'transitions-enkelvoudig-1.59-stealth': 56988680847686,
    'transitions-enkelvoudig-1.67-stealth': 56988680880454,
    'transitions-enkelvoudig-1.50-stealth-pro': 56988680913222,
    'transitions-enkelvoudig-1.59-stealth-pro': 56988680945990,
    'transitions-enkelvoudig-1.67-stealth-pro': 56988680978758,
    // Transition Gen S Progressief
    'transitions-progressief-1.50-stealth': 56988681011526,
    'transitions-progressief-1.59-stealth': 56988681044294,
    'transitions-progressief-1.67-stealth': 56988681077062,
    'transitions-progressief-1.50-stealth-pro': 56988681109830,
    'transitions-progressief-1.59-stealth-pro': 56988681142598,
    'transitions-progressief-1.67-stealth-pro': 56988681175366,
    // Sun Authentics
    'authentics-complex-enkelvoudig-niet-gepolariseerd': 56988681208134,
    'authentics-complex-enkelvoudig-gepolariseerd': 56988681240902,
    'authentics-complex-progressief-niet-gepolariseerd': 56988681273670,
    'authentics-complex-progressief-gepolariseerd': 56988681306438,
  }
};

// META MONTUURKLEUREN
const META_MONTUURKLEUREN = [
  {
    naam: "Black",
    kleur: "#111111",
    foto: CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Clear.jpg?v=1784494962",
    fotos: [],
    transitieFotos: [
      CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Clear.jpg?v=1784494962",
      CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Photochromic-Grey.jpg?v=1784550980",
    ],
    lensFotos: {
      "Clear":          CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Clear.jpg?v=1784494962",
      "Prizm 24K":      CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-24K.jpg?v=1784544457",
      "Prizm 24K Polarized": CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-24K.jpg?v=1784544457",
      "Prizm Black":    CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-Black.jpg?v=1784544523",
      "Prizm Black Polarized": CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-Black.jpg?v=1784544523",
      "Prizm Field":    CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-Field.jpg?v=1784544639",
      "Prizm Dark Golf": CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-Dark-Golf.jpg?v=1784550849",
      "Prizm Golf":     CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-Golf.jpg?v=1784544675",
      "Prizm Grey":     CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-Grey.jpg?v=1784544714",
      "Prizm Grey Polarized": CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-Grey.jpg?v=1784544714",
      "Prizm Jade":     CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-Jade.jpg?v=1784544809",
      "Prizm Jade Polarized": CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-Jade.jpg?v=1784544809",
      "Prizm Road":     CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-Road.jpg?v=1784544853",
      "Prizm Road Jade": CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-Road-Jade.jpg?v=1784544891",
      "Prizm Rose Gold": CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-Rose-Gold.jpg?v=1784544924",
      "Prizm Rose Gold Polarized": CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-Rose-Gold.jpg?v=1784544924",
      "Prizm Ruby":     CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-Ruby.jpg?v=1784544962",
      "Prizm Ruby Polarized": CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-Ruby.jpg?v=1784544962",
      "Prizm Sapphire": CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-Sapphire.jpg?v=1784545010",
      "Prizm Sapphire Polarized": CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-Sapphire.jpg?v=1784545010",
      "Prizm Trail":    CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-Trail.jpg?v=1784545086",
      "Prizm Trail Torch": CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-Trail-Torch.jpg?v=1784547385",
      "Prizm Tungsten": CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-Tungsten.jpg?v=1784547257",
      "Prizm Tungsten Polarized": CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-Tungsten.jpg?v=1784547257",
      "Prizm Deep Water Polarized": CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Prizm-Deep-Water.jpg?v=1784547429",
      "Clear to Amber":    CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Photochromic-Amber1.jpg?v=1784619320",
      "Clear to Amethyst": CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Photochromic-Amethyst1.jpg?v=1784619370",
      "Clear to Brown": CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Photochromic-Brown.jpg?v=1784551014",
      "Clear to Emerald":  CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Photochromic-Emerald1.jpg?v=1784619424",
      "Clear to Green":    CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Photochromic-Green_22af3585-627e-4ae4-8d13-1ae369846d9d.jpg?v=1784619492",
      "Clear to Grey":  CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Photochromic-Grey.jpg?v=1784550980",
      "Clear to Ruby":  CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Photochromic-Ruby-Felle-zon.jpg?v=1784550942",
      "Clear to Sapphire": CDN+"Oakley-HSTN-Meta-Op-Sterkte-Black-Photochromic-Sapphire_0fa75bbb-ddd8-4ea8-b881-2d1454955862.jpg?v=1784619629",
    }
  },
];

// META TRANSITIONS GEN S LENZEN
const META_TRANSITIONS_LENZEN = [
  { naam: "Clear to Amber",    kleur: "#d4a017" },
  { naam: "Clear to Amethyst", kleur: "#9966cc" },
  { naam: "Clear to Brown",    kleur: "#6b4423" },
  { naam: "Clear to Emerald",  kleur: "#2e8b57" },
  { naam: "Clear to Green",    kleur: "#3a7a3a" },
  { naam: "Clear to Grey",     kleur: "#8a8a8a" },
  { naam: "Clear to Ruby",     kleur: "#9a1a2a" },
  { naam: "Clear to Sapphire", kleur: "#1a3a8a" },
];

// ============================================================
// LENZEN
// ============================================================
const LENZEN_NIET_GEPOL = [
  { naam: "Prizm 24K",             kleur: "#c8a42a" },
  { naam: "Prizm Black",           kleur: "#1a1a1a" },
  { naam: "Prizm Dark Golf",       kleur: "#6b4423" },
  { naam: "Prizm Field",           kleur: "#c44a1a" },
  { naam: "Prizm Golf",            kleur: "#5a8a2a" },
  { naam: "Prizm Grey",            kleur: "#6a6a6a" },
  { naam: "Prizm Jade",            kleur: "#2a6a3a" },
  { naam: "Prizm Low Light",       kleur: "#e8a0b4" },
  { naam: "Prizm Road",            kleur: "#c43a2a" },
  { naam: "Prizm Road Jade",       kleur: "#2a6a3a" },
  { naam: "Prizm Rose Gold",       kleur: "#e8a0b4" },
  { naam: "Prizm Ruby",            kleur: "#9a1a2a" },
  { naam: "Prizm Sapphire",        kleur: "#1a3a8a" },
  { naam: "Prizm Snow Sapphire",   kleur: "#3a6ab4" },
  { naam: "Prizm Trail",           kleur: "#8a5a9a" },
  { naam: "Prizm Trail Torch",     kleur: "#c45a1a" },
  { naam: "Prizm Tungsten",        kleur: "#7a5a3a" },
  { naam: "Prizm Violet",          kleur: "#6a3a9a" },
];

const LENZEN_GEPOL = [
  { naam: "Prizm 24K Polarized",   kleur: "#c8a42a" },
  { naam: "Prizm Black Polarized", kleur: "#1a1a1a" },
  { naam: "Prizm Deep Water Polarized", kleur: "#1a4a7a" },
  { naam: "Prizm Grey Polarized",  kleur: "#6a6a6a" },
  { naam: "Prizm Jade Polarized",  kleur: "#2a6a3a" },
  { naam: "Prizm Rose Gold Polarized", kleur: "#e8a0b4" },
  { naam: "Prizm Ruby Polarized",  kleur: "#9a1a2a" },
  { naam: "Prizm Sapphire Polarized", kleur: "#1a3a8a" },
  { naam: "Prizm Tungsten Polarized", kleur: "#7a5a3a" },
  { naam: "Prizm Violet Polarized", kleur: "#6a3a9a" },
];

// ============================================================
// STAAT bijhouden
// ============================================================
let metaAuthTimer = null;
let staat = {
  montuurKleur: null,
  correctie: null,
  glastype: null,
  lens: null,
  geactiveerdeTab: 'niet-gepolariseerd',
  transitieVariant: 'licht',
  laasteNietGepolariseerd: null, // onthoudt laatste lens bij niet-gepolariseerd
  laasteGepolariseerd: null      // onthoudt laatste lens bij gepolariseerd
};

// ============================================================
// INITIALISATIE
// ============================================================
window.addEventListener('DOMContentLoaded', () => {
  // Vertaal ALLE statische teksten — MOET vóór het koppelen van eventlisteners,
  // omdat data-i18n-html elementen vervangt (o.a. btnWebmailKeuze)
  document.querySelectorAll('[data-i18n]').forEach(el => {
    const key = el.getAttribute('data-i18n');
    if (T[key] !== undefined) el.textContent = T[key];
  });
  document.querySelectorAll('[data-i18n-html]').forEach(el => {
    const key = el.getAttribute('data-i18n-html');
    if (T[key] !== undefined) el.innerHTML = T[key];
  });

  // Knoppen event listeners
  [['btnSportbril','sportbril'], ['btnZonnebril','zonnebril'], ['btnMeta','meta']].forEach(([id, type]) => {
    const knop = document.getElementById(id);
    knop.addEventListener('click', function() { kiesBriltype(type, this); });
    // Bij aanraken alvast de eerste foto van dit tabblad ophalen
    knop.addEventListener('pointerdown', () => {
      const lijst = (MODELLEN[type] || []).filter(m => m.actief !== false);
      if (lijst[0]) preloadUrl(lijst[0].foto);
    }, { passive: true });
  });
  document.getElementById('btnEnkelvoudig').addEventListener('click', function() { kiesCorrectie('enkelvoudig', this); });
  document.getElementById('btnProgressief').addEventListener('click', function() { kiesCorrectie('progressief', this); });
  document.getElementById('btnAuthentics').addEventListener('click', function() { kiesGlastype('authentics-complex', this); });
  document.getElementById('transitionsKnop').addEventListener('click', function() { kiesGlastype('transitions', this); });
  document.getElementById('btnClear').addEventListener('click', function() { kiesGlastype('clear', this); });
  document.getElementById('tabNietGepol').addEventListener('click', function() { toonLensTab('niet-gepolariseerd'); });
  document.getElementById('tabGepol').addEventListener('click', function() { toonLensTab('gepolariseerd'); });
  document.getElementById('btnLicht').addEventListener('click', function() { wisselPhotochromic('licht'); });
  document.getElementById('btnDonker').addEventListener('click', function() { wisselPhotochromic('donker'); });
  document.getElementById('bestelKnop').addEventListener('click', function() { voegToeAanWinkelwagen(); });
  document.getElementById('btnChat').addEventListener('click', function() {
    const nu = new Date();
    const dag = nu.getDay(); // 0=zondag, 1=maandag, 2=dinsdag...6=zaterdag
    const uur = nu.getHours();
    const minuten = nu.getMinutes();
    const tijdInMinuten = uur * 60 + minuten;

    // Openingstijden: di t/m vr 9:00-17:30, za 9:00-17:00
    const open9u = 9 * 60;
    const sluit1730 = 17 * 60 + 30;
    const sluit17u = 17 * 60;

    const isDiTmVr = dag >= 2 && dag <= 5;
    const isZaterdag = dag === 6;

    const chatOpen = (isDiTmVr && tijdInMinuten >= open9u && tijdInMinuten < sluit1730) ||
                     (isZaterdag && tijdInMinuten >= open9u && tijdInMinuten < sluit17u);

    if (chatOpen) {
      // Chat is open — open Zendesk widget
      // Probeer via zE API
      if (typeof zE !== 'undefined') {
        try {
          zE('messenger', 'open');
        } catch(e) {
          try { zE('webWidget', 'open'); } catch(e2) {}
        }
      }
      // Klik ook op de bestaande Zendesk chatten knop als die er is
      const chatBtn = document.querySelector('[data-testid="launcher"]') ||
                      document.querySelector('.zopim') ||
                      document.querySelector('iframe[title*="chat"]') ||
                      document.querySelector('iframe[title*="Chat"]');
      if (chatBtn) chatBtn.click();
    } else {
      // Chat is gesloten — toon melding
      toonChatModal(false);
    }
  });
  // Mail recept knop — update href voor klik (mousedown + touchstart voor mobiel)
  function updateMailReceptHref() {
    var btn = document.getElementById('btnMailRecept');
    var model = (staat.model && staat.model.naam) ? staat.model.naam : 'Oakley op sterkte';
    var montuur = (staat.montuurKleur && staat.montuurKleur.naam) ? staat.montuurKleur.naam : '';
    var onderwerp = encodeURIComponent('Brilrecept - ' + model + ' ' + montuur);
    var tekst = encodeURIComponent('Goedendag,' + '\n\nHierbij stuur ik mijn brilrecept mee.' + '\n\nModel: ' + model + '\nMontuur: ' + montuur + '\n\nVoeg uw brilrecept toe als bijlage.\n\nMet vriendelijke groet');
    btn.href = 'mailto:service@sportbrillenshop.nl?subject=' + onderwerp + '&body=' + tekst;
  }
  document.getElementById('btnMailRecept').addEventListener('mousedown', updateMailReceptHref);
  document.getElementById('btnMailRecept').addEventListener('touchstart', updateMailReceptHref);

  // Webmail keuze popup
  document.getElementById('btnWebmailKeuze').addEventListener('click', function(e) {
    e.preventDefault();
    var model = (staat.model && staat.model.naam) ? staat.model.naam : 'Oakley op sterkte';
    var montuur = (staat.montuurKleur && staat.montuurKleur.naam) ? staat.montuurKleur.naam : '';
    var onderwerp = encodeURIComponent('Brilrecept - ' + model + ' ' + montuur);
    var tekst = encodeURIComponent('Goedendag,\n\nHierbij stuur ik mijn brilrecept mee.\n\nModel: ' + model + '\nMontuur: ' + montuur + '\n\nVoeg uw brilrecept toe als bijlage.\n\nMet vriendelijke groet');

    var bestaand = document.getElementById('webmailModal');
    if (bestaand) bestaand.remove();

    var modal = document.createElement('div');
    modal.id = 'webmailModal';
    modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.5);display:flex;align-items:center;justify-content:center;z-index:9999;padding:24px;';

    var inhoud = document.createElement('div');
    inhoud.style.cssText = 'background:white;border-radius:16px;padding:28px;max-width:380px;width:100%;box-shadow:0 20px 60px rgba(0,0,0,0.3);';
    inhoud.innerHTML = '<p style="font-size:15px;font-weight:800;color:#111;margin-bottom:16px;">' + T.webmailTitel + '</p>'
      + '<a href="https://mail.google.com/mail/?view=cm&to=service@sportbrillenshop.nl&su=' + onderwerp + '&body=' + tekst + '" target="_blank" style="display:flex;align-items:center;gap:10px;padding:12px 16px;border:1.5px solid #d4d4d4;border-radius:10px;text-decoration:none;color:#111;font-size:14px;font-weight:700;margin-bottom:8px;">📧 Gmail</a>'
      + '<a href="https://outlook.live.com/mail/0/deeplink/compose?to=service@sportbrillenshop.nl&subject=' + onderwerp + '&body=' + tekst + '" target="_blank" style="display:flex;align-items:center;gap:10px;padding:12px 16px;border:1.5px solid #d4d4d4;border-radius:10px;text-decoration:none;color:#111;font-size:14px;font-weight:700;margin-bottom:8px;">📧 Outlook / Hotmail</a>'
      + '<a href="https://compose.mail.yahoo.com/?to=service@sportbrillenshop.nl&subject=' + onderwerp + '&body=' + tekst + '" target="_blank" style="display:flex;align-items:center;gap:10px;padding:12px 16px;border:1.5px solid #d4d4d4;border-radius:10px;text-decoration:none;color:#111;font-size:14px;font-weight:700;margin-bottom:16px;">📧 Yahoo Mail</a>'
      + '<button id="sluitWebmailModal" style="width:100%;padding:10px;background:transparent;color:#7a7a7a;border:none;font-size:13px;cursor:pointer;">' + T.sluiten + '</button>';

    modal.appendChild(inhoud);
    modal.addEventListener('click', function(e) { if (e.target === modal) modal.remove(); });
    document.body.appendChild(modal);
    document.getElementById('sluitWebmailModal').addEventListener('click', function() { modal.remove(); });
  });
  // Mail recept checkbox
  document.getElementById('checkMailRecept').addEventListener('change', function() {
    var sterkte = document.querySelector('.sterkte-grid');
    var pdBlok = document.getElementById('pdCheckboxBlok');
    var additieBlok = document.getElementById('additie-sectie');
    var highRxBlok = document.getElementById('highRxVraagBlok');
    if (this.checked) {
      if (sterkte) { sterkte.style.opacity = '0.4'; sterkte.style.pointerEvents = 'none'; }
      if (pdBlok) { pdBlok.style.opacity = '0.4'; pdBlok.style.pointerEvents = 'none'; }
      if (additieBlok) { additieBlok.style.opacity = '0.4'; additieBlok.style.pointerEvents = 'none'; }
      // Toon High RX vraag (niet bij Meta Clear/Transitions)
      var metaGeenHighRx = staat.briltype === 'meta' && staat.glastype !== 'authentics-complex';
      var shieldGeenHighRx = staat.model && staat.model.vasteVarianten;
      highRxBlok.style.display = (metaGeenHighRx || shieldGeenHighRx) ? 'none' : 'block';
      // Reset High RX keuze
      staat.mailReceptHighRx = null;
      document.getElementById('btnHighRxJa').style.background = 'var(--wit)';
      document.getElementById('btnHighRxJa').style.borderColor = 'var(--grijs-300)';
      document.getElementById('btnHighRxJa').style.color = 'var(--grijs-700)';
      document.getElementById('btnHighRxNee').style.background = 'var(--wit)';
      document.getElementById('btnHighRxNee').style.borderColor = 'var(--grijs-300)';
      document.getElementById('btnHighRxNee').style.color = 'var(--grijs-700)';
      document.getElementById('highRxMelding').style.display = 'none';
    } else {
      if (sterkte) { sterkte.style.opacity = '1'; sterkte.style.pointerEvents = 'auto'; }
      if (pdBlok) { pdBlok.style.opacity = '1'; pdBlok.style.pointerEvents = 'auto'; }
      if (additieBlok) { additieBlok.style.opacity = '1'; additieBlok.style.pointerEvents = 'auto'; }
      highRxBlok.style.display = 'none';
      staat.mailReceptHighRx = null;
    }
    updateBestelKnop();
  });

  // High RX Ja/Nee knoppen
  document.getElementById('btnHighRxJa').addEventListener('click', function() {
    staat.mailReceptHighRx = true;
    this.style.background = 'var(--paars)';
    this.style.borderColor = 'var(--paars)';
    this.style.color = 'var(--wit)';
    document.getElementById('btnHighRxNee').style.background = 'var(--wit)';
    document.getElementById('btnHighRxNee').style.borderColor = 'var(--grijs-300)';
    document.getElementById('btnHighRxNee').style.color = 'var(--grijs-700)';
    var melding = document.getElementById('highRxMelding');
    melding.style.display = 'block';
    melding.textContent = T.highRxToeslagMelding;
    updatePrijs();
    updateBestelKnop();
  });

  document.getElementById('btnHighRxNee').addEventListener('click', function() {
    staat.mailReceptHighRx = false;
    this.style.background = 'var(--paars)';
    this.style.borderColor = 'var(--paars)';
    this.style.color = 'var(--wit)';
    document.getElementById('btnHighRxJa').style.background = 'var(--wit)';
    document.getElementById('btnHighRxJa').style.borderColor = 'var(--grijs-300)';
    document.getElementById('btnHighRxJa').style.color = 'var(--grijs-700)';
    document.getElementById('highRxMelding').style.display = 'none';
    updatePrijs();
    updateBestelKnop();
  });
  document.getElementById('bekijkBrilKnop').addEventListener('click', function() { scrollNaarBril(); });

  // Extra aanpassingen die niet via data-i18n gaan
  document.getElementById('prijsOpbouw').textContent = T.maakKeuzes;
  document.querySelector('.prijs-vanaf') && (document.querySelector('.prijs-vanaf').textContent = T.vanaf);
  const bekijkTekstEl = document.getElementById('bekijkBrilTekst');
  if (bekijkTekstEl) bekijkTekstEl.textContent = T.bekijkBril;

  // Meldingen
  document.getElementById('meldingFout').textContent = T.vulAlleVelden;
  document.getElementById('meldingSucces').textContent = T.toegevoegdWinkelwagen;

  // Initialiseer alle stappen als grijs
  document.getElementById('stap1').style.opacity = '0.35';
  document.getElementById('stap1').style.pointerEvents = 'none';
  document.getElementById('stap2').style.opacity = '0.35';
  document.getElementById('stap2').style.pointerEvents = 'none';
  document.getElementById('stap3').style.opacity = '0.35';
  document.getElementById('stap3').style.pointerEvents = 'none';
  bouwMontuurSwatches();
  bouwLenzenGrid(null);
  vulSterktevelden();
  updatePrijs();

  // Coating klik handlers (Meta)
  document.querySelectorAll('.coating-kaart').forEach(btn => {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.coating-kaart').forEach(k => k.setAttribute('aria-pressed', 'false'));
      this.setAttribute('aria-pressed', 'true');
      staat.coating = this.dataset.coating;
      var label = this.querySelector('.optie-naam').textContent;
      document.getElementById('keuzeCoating').textContent = label;
      document.getElementById('numCoating').classList.add('klaar');

      // Na coating: lenskleur of sterkte activeren
      if (staat.briltype === 'meta' && staat.glastype === 'clear') {
        // Clear: geen lenskleur, direct sterkte
        staat.lens = 'Clear';
        document.getElementById('stap4').style.display = 'none';
        document.getElementById('stap5').style.opacity = '1';
        document.getElementById('stap5').style.pointerEvents = 'auto';
      } else if (staat.briltype === 'meta') {
        // Meta: lenskleur staat al open bij Transitions, bij Clear geen lenskleur
        if (staat.glastype === 'clear') {
          document.getElementById('stap4').style.display = 'none';
        }
        // Sterkte nog niet — wacht tot alle keuzes gemaakt zijn
        toonSterkte();
      } else {
        // Niet-Meta: direct sterkte
        document.getElementById('stap5').style.opacity = '1';
        document.getElementById('stap5').style.pointerEvents = 'auto';
      }

      updatePrijs();
      updateBestelKnop();
      toonSterkte();
    });
  });

  // Glasdikte klik handlers
  document.querySelectorAll('.glasdikte-kaart').forEach(btn => {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.glasdikte-kaart').forEach(k => k.setAttribute('aria-pressed', 'false'));
      this.setAttribute('aria-pressed', 'true');
      staat.glasdikte = this.dataset.glasdikte;
      document.getElementById('keuzeGlasdikte').textContent = this.querySelector('.optie-naam').textContent;
      document.getElementById('numGlasdikte').classList.add('klaar');

      // Begrens sterkte op basis van glasdikte
      beperkSterkteBijGlasdikte(staat.glasdikte);

      // Na glasdikte: altijd eerst coating tonen
      document.getElementById('stapCoating').style.display = 'block';
      document.getElementById('stapCoating').style.opacity = '1';
      document.getElementById('stapCoating').style.pointerEvents = 'auto';
      // Coating onthouden als al gekozen
      if (staat.coating) {
        document.querySelectorAll('.coating-kaart').forEach(k => {
          k.setAttribute('aria-pressed', k.dataset.coating === staat.coating ? 'true' : 'false');
        });
      }
      // Lenskleur en sterkte — bij Meta Transitions/Clear blijft lenskleur actief
      if (staat.briltype === 'meta' && (staat.glastype === 'transitions' || staat.glastype === 'clear')) {
        // Lenskleur staat al open, niet grijs maken
      } else {
        document.getElementById('stap4').style.opacity = '0.35';
        document.getElementById('stap4').style.pointerEvents = 'none';
      }
      document.getElementById('stap5').style.opacity = '0.35';
      document.getElementById('stap5').style.pointerEvents = 'none';

      updatePrijs();
      updateBestelKnop();
      toonSterkte();
    });
  });

  // Timify afspraak popup
  document.getElementById('btnTimify').addEventListener('click', function() {
    var bestaand = document.getElementById('timifyModal');
    if (bestaand) { bestaand.remove(); return; }

    var modal = document.createElement('div');
    modal.id = 'timifyModal';
    modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.6);display:flex;align-items:center;justify-content:center;z-index:9999;padding:16px;';

    var inhoud = document.createElement('div');
    inhoud.style.cssText = 'background:white;border-radius:16px;overflow:hidden;width:100%;max-width:520px;height:80vh;max-height:700px;display:flex;flex-direction:column;box-shadow:0 20px 60px rgba(0,0,0,0.3);';

    var header = document.createElement('div');
    header.style.cssText = 'display:flex;align-items:center;justify-content:space-between;padding:16px 20px;border-bottom:1px solid #efefef;flex:none;';
    header.innerHTML = '<span style="font-size:15px;font-weight:800;color:#111;">' + T.afspraakTitel + '</span>';

    var sluitBtn = document.createElement('button');
    sluitBtn.textContent = '✕';
    sluitBtn.style.cssText = 'background:none;border:none;font-size:18px;cursor:pointer;color:#7a7a7a;padding:4px 8px;';
    sluitBtn.addEventListener('click', function() { modal.remove(); });
    header.appendChild(sluitBtn);

    var iframe = document.createElement('iframe');
    iframe.src = 'https://book.timify.com/?accountId=62c55f090418c48a08883d2b&hideCloseButton=true';
    iframe.style.cssText = 'width:100%;flex:1;border:none;';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', 'true');

    inhoud.appendChild(header);
    inhoud.appendChild(iframe);
    modal.appendChild(inhoud);
    modal.addEventListener('click', function(e) { if (e.target === modal) modal.remove(); });
    document.body.appendChild(modal);
  });

  // Alleen de modelminiaturen vooraf ophalen (klein setje) in plaats van
  // alle ~234 foto's, die de verbinding op mobiel dichtslibden
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => preloadModelMiniaturen());
  } else {
    setTimeout(preloadModelMiniaturen, 800);
  }
});

function bouwModelSwatches(briltype) {
  const container = document.getElementById('modelSwatches');
  container.innerHTML = '';
  // Modellen met actief:false blijven verborgen. Zo kun je een nieuw model
  // alvast klaarzetten zonder dat klanten het al zien.
  const modellen = (MODELLEN[briltype] || []).filter(m => m.actief !== false);
  // Modellen met nieuw:true vooraan tonen (stabiele sort behoudt onderlinge volgorde)
  modellen.sort(function(a,b){ return (b.nieuw?1:0) - (a.nieuw?1:0); });
  modellen.forEach(model => {
    const btn = document.createElement('button');
    btn.className = 'model-swatch';
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('title', model.naam);

    // Teaser "binnenkort leverbaar": wel tonen (foto + paarse ballon), niet aanklikbaar
    if (model.binnenkort) {
      const binnenkortLabel = TAAL === 'en' ? 'New!<br>Coming soon' : (TAAL === 'de' ? 'Neu!<br>Bald verf&uuml;gbar' : 'Nieuw!<br>Binnenkort leverbaar');
      btn.classList.add('binnenkort');
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.innerHTML = `
        <div class="model-cirkel">
          <img src="${model.foto}" alt="${model.naam}"${model.miniZoom ? ' style="transform:scale(' + model.miniZoom + ')"' : ''}>
        </div>
        <span class="model-naam">${model.naam}</span>
        <span class="model-binnenkort-balloon">${binnenkortLabel}</span>
      `;
      container.appendChild(btn);
      return;   // geen click/preload listeners voor een binnenkort-model
    }

    if (model.nieuw) {
      const nieuwLabel = TAAL === 'en' ? 'New!' : (TAAL === 'de' ? 'Neu!' : 'Nieuw!');
      btn.classList.add('nieuw');
      btn.innerHTML = `
        <div class="model-cirkel">
          <img src="${model.foto}" alt="${model.naam}"${model.miniZoom ? ' style="transform:scale(' + model.miniZoom + ')"' : ''}>
        </div>
        <span class="model-naam">${model.naam}</span>
        <span class="model-nieuw-balloon">${nieuwLabel}</span>
      `;
    } else {
      btn.innerHTML = `
        <div class="model-cirkel">
          <img src="${model.foto}" alt="${model.naam}"${model.miniZoom ? ' style="transform:scale(' + model.miniZoom + ')"' : ''}>
        </div>
        <span class="model-naam">${model.naam}</span>
      `;
    }
    btn.addEventListener('click', () => kiesModel(model, btn));
    btn.addEventListener('pointerdown', () => preloadUrl(model.foto), { passive: true });
    container.appendChild(btn);
  });
}

function kiesBriltype(type, knop) {
  staat.briltype = type;
  staat.model = null;
  staat.montuurKleur = null;
  staat.correctie = null;
  staat.glastype = null;
  staat.lens = null;

  document.querySelectorAll('#inhoud0 .type-kaart').forEach(k => k.setAttribute('aria-pressed', 'false'));
  knop.setAttribute('aria-pressed', 'true');
  document.getElementById('keuze0').textContent = type === 'sportbril' ? T.sportbril : (type === 'meta' ? 'Meta' : T.zonnebril);
  document.getElementById('num0').classList.add('klaar');

  // Reset prijs
  document.getElementById('prijsTotaal').textContent = '';
  document.getElementById('prijsAdvies').textContent = '';
  document.getElementById('prijsOpbouw').textContent = T.maakKeuzes;
  document.getElementById('samKorting').style.display = 'none';
  document.getElementById('samTotaal').textContent = '€ 0,00';
  document.getElementById('samCorrectie').style.display = 'none';
  document.getElementById('samGlastype').style.display = 'none';
  document.getElementById('samMontuur').style.display = 'none';

  // Toon model sectie
  const modelSectie = document.getElementById('stap0b');
  const dividerModel = document.getElementById('dividerModel');
  modelSectie.classList.add('zichtbaar');
  dividerModel.style.display = 'block';

  // Bouw model swatches
  bouwModelSwatches(type);

  // Meta: automatisch HSTN Meta selecteren (1 model)
  if (type === 'meta') {
    setTimeout(() => {
      var eersteModel = document.querySelector('#modelSwatches .model-swatch');
      if (eersteModel) eersteModel.click();
    }, 50);
  }

  // Toon direct een preview foto van het eerste model
  const modellen = (MODELLEN[type] || []).filter(m => m.actief !== false);
  modellen.sort(function(a,b){ return (b.nieuw?1:0) - (a.nieuw?1:0); });
  if (modellen.length > 0) {
    var m0 = modellen[0];
    var previewFoto = (m0.uitvoeringen && m0.uitvoeringen[0] && m0.uitvoeringen[0].fotos && m0.uitvoeringen[0].fotos[0]) ? m0.uitvoeringen[0].fotos[0] : m0.foto;
    toonFoto(previewFoto);
  }
  // Wachtrij legen en alleen de miniaturen van dit tabblad vast ophalen
  stopPreload();
  modellen.forEach(m => preloadUrl(m.foto));

  // Reset stap UI
  document.getElementById('keuze0b').textContent = '';
  document.getElementById('num0b').classList.remove('klaar');
  document.getElementById('keuze1').textContent = '';
  document.getElementById('num1').classList.remove('klaar');
  document.getElementById('stap1').style.opacity = '0.35';
  document.getElementById('stap1').style.pointerEvents = 'none';
  document.getElementById('stap2').style.opacity = '0.35';
  document.getElementById('stap2').style.pointerEvents = 'none';
  document.getElementById('stap3').style.opacity = '0.35';
  document.getElementById('stap3').style.pointerEvents = 'none';
  document.getElementById('lensBadge').style.display = 'none';
  document.querySelectorAll('.optie-kaart').forEach(k => k.setAttribute('aria-pressed', 'false'));
  document.getElementById('stap4').style.opacity = '0.35'; document.getElementById('stap4').style.pointerEvents = 'none';
  document.getElementById('stap5').style.opacity = '0.35'; document.getElementById('stap5').style.pointerEvents = 'none';
}

// Welke montuurkleuren horen bij welk model
function montuurKleurenVoor(model) {
  if (!model) return MONTUURKLEUREN;
  if (staat.briltype === 'meta') return META_MONTUURKLEUREN;
  if (model.naam === 'Holbrook') return HOLBROOK_MONTUURKLEUREN;
  if (model.naam === 'Holbrook XL') return HOLBROOK_XL_MONTUURKLEUREN;
  if (model.naam === 'Holbrook XXL') return HOLBROOK_XXL_MONTUURKLEUREN;
  if (model.naam === 'Eyejacket Redux') return EYEJACKET_MONTUURKLEUREN;
  if (model.naam === 'Flak 2.0 XXL') return FLAK_XXL_MONTUURKLEUREN;
  if (model.naam === 'Bisphaera') return BISPHAERA_MONTUURKLEUREN;
  if (model.naam === 'Split Shot') return SPLITSHOT_MONTUURKLEUREN;
  if (model.naam === 'Latch') return LATCH_MONTUURKLEUREN;
  if (model.naam === 'Gibston') return GIBSTON_MONTUURKLEUREN;
  if (model.naam === 'Gibston XL') return GIBSTONXL_MONTUURKLEUREN;
  return MONTUURKLEUREN;
}

function kiesModel(model, knop) {
  staat.model = model;
  staat.montuurKleur = null;
  staat.correctie = null;
  staat.glastype = null;
  staat.lens = null;
  staat.laasteNietGepolariseerd = null;
  staat.laasteGepolariseerd = null;

  // Reset prijs
  document.getElementById('prijsTotaal').textContent = '';
  document.getElementById('prijsAdvies').textContent = '';
  document.getElementById('prijsOpbouw').textContent = T.maakKeuzes;
  document.getElementById('samKorting').style.display = 'none';
  document.getElementById('samTotaal').textContent = '€ 0,00';
  document.getElementById('samCorrectie').style.display = 'none';
  document.getElementById('samGlastype').style.display = 'none';
  document.getElementById('samMontuur').style.display = 'none';

  document.querySelectorAll('#modelSwatches .model-swatch').forEach(k => k.setAttribute('aria-pressed', 'false'));
  knop.setAttribute('aria-pressed', 'true');
  document.getElementById('keuze0b').textContent = model.naam;
  document.getElementById('num0b').classList.add('klaar');

  // Reset alle stap UI EERST
  document.getElementById('keuze1').textContent = '';
  document.getElementById('num1').classList.remove('klaar');
  document.getElementById('keuze2').textContent = '';
  document.getElementById('num2').classList.remove('klaar');
  document.getElementById('keuze3').textContent = '';
  document.getElementById('num3').classList.remove('klaar');
  document.getElementById('keuze4').textContent = '';
  document.getElementById('num4').classList.remove('klaar');
  document.getElementById('stap2').style.opacity = '0.35'; document.getElementById('stap2').style.pointerEvents = 'none';
  document.getElementById('stap3').style.opacity = '0.35'; document.getElementById('stap3').style.pointerEvents = 'none';
  document.getElementById('stap4').style.opacity = '0.35'; document.getElementById('stap4').style.pointerEvents = 'none';
  document.getElementById('stap5').style.opacity = '0.35'; document.getElementById('stap5').style.pointerEvents = 'none';
  document.getElementById('lensBadge').style.display = 'none';
  document.querySelectorAll('.optie-kaart').forEach(k => k.setAttribute('aria-pressed', 'false'));
  document.querySelectorAll('.lens-kaart').forEach(k => k.setAttribute('aria-pressed', 'false'));

  staat.uitvoering = null;
  // Shield-modellen met vaste combinaties (bv. Sutro Lite) hebben een eigen flow.
  if (model.vasteVarianten) { setupShieldFlow(model); return; }
  // Normale modellen: shield-modus uit, normale stappen weer zichtbaar.
  var _ck = document.querySelector('.config-kolom'); if (_ck) _ck.classList.remove('shield');
  var _suit = document.getElementById('stapUitvoering'); if (_suit) _suit.style.display = 'none';
  ['stap1','stap2','stap3','stap4'].forEach(function(id){ var el = document.getElementById(id); if (el) el.style.display = ''; });
  var _n5 = document.getElementById('num5'); if (_n5) _n5.textContent = '7';
  var _ft0 = document.getElementById('fotoThumbs'); if (_ft0) _ft0.style.display = 'none';

  // Activeer stap 1 VOOR het bouwen van swatches
  document.getElementById('stap1').style.opacity = '1';
  document.getElementById('stap1').style.pointerEvents = 'auto';

  // Shield-modellen (bv. Sutro Lite): alleen enkelvoudig -> verberg de progressief-knop.
  const btnProgModel = document.getElementById('btnProgressief');
  if (btnProgModel) btnProgModel.style.display = model.alleenEnkelvoudig ? 'none' : '';

  // Begin met het volledige sferisch bereik weer beschikbaar; een model-specifiek
  // bereik (bv. shield) wordt daarna in toonSterkte() opnieuw ingeperkt.
  ['od-sph', 'os-sph'].forEach(id => {
    const sel = document.getElementById(id);
    if (sel) Array.from(sel.options).forEach(opt => { if (opt.value !== '') opt.disabled = false; });
  });

  const montuurKleuren = montuurKleurenVoor(model);
  herbouwMontuurSwatches(montuurKleuren);

  // Bouw lensopties opnieuw op basis van model
  bouwLenzenGrid(model);

  // Toon/verberg Clear knop bij Meta + Transitions label aanpassen
  var clearKnop = document.getElementById('btnClear');
  if (clearKnop) {
    clearKnop.style.display = staat.briltype === 'meta' ? 'flex' : 'none';
  }
  var transLabel = document.querySelector('#transitionsKnop .optie-naam');
  if (transLabel) {
    transLabel.textContent = staat.briltype === 'meta' ? 'Transitions Gen S' : T.transitions;
  }
  // Verberg glasdikte en coating stap bij model wissel
  document.getElementById('stapGlasdikte').style.display = 'none';
  document.getElementById('stapGlasdikte').style.opacity = '0.35';
  document.getElementById('stapGlasdikte').style.pointerEvents = 'none';
  document.getElementById('stapCoating').style.display = 'none';
  document.getElementById('stapCoating').style.opacity = '0.35';
  document.getElementById('stapCoating').style.pointerEvents = 'none';
  staat.glasdikte = null;
  staat.coating = null;

  // Verberg of toon transitions knop
  const transitionsKnop = document.getElementById('transitionsKnop');
  if (transitionsKnop) {
    transitionsKnop.style.display = model.naam === 'Holbrook' ? 'none' : '';
  }

  // Transitions knop altijd tonen
  if (transitionsKnop) transitionsKnop.style.display = '';

  if (model.naam === 'Holbrook') {
    staat.glastype = null;
    document.getElementById('keuze3').textContent = '';
    document.getElementById('num3').classList.remove('klaar');
    // Stap 4 verbergen totdat glastype gekozen is
    document.getElementById('stap4').style.opacity = '0.35'; document.getElementById('stap4').style.pointerEvents = 'none';
  document.getElementById('stap5').style.opacity = '0.35'; document.getElementById('stap5').style.pointerEvents = 'none';
  } else {
    // Flak: reset stap 2 en 3 — worden geactiveerd via kiesMontuur/kiesCorrectie
    document.getElementById('stap2').style.opacity = '0.35';
    document.getElementById('stap2').style.pointerEvents = 'none';
    document.getElementById('stap3').style.opacity = '0.35';
    document.getElementById('stap3').style.pointerEvents = 'none';
  }

  // Reset stap 2 UI
  document.querySelectorAll('#inhoud2 .optie-kaart').forEach(k => k.setAttribute('aria-pressed', 'false'));

  // Auto-selecteer de eerste montuurkleur + open de volgende stap.
  // Is de eerste kleur uitverkocht? Toon dan wél alvast de foto van die kleur
  // (anders blijft de foto op het vorige model staan), maar selecteer niets:
  // de klant moet zelf een leverbare kleur kiezen om verder te gaan.
  const eersteKleur = montuurKleuren[0];
  const eersteSwatch = document.querySelector('#montuurSwatches .swatch');
  if (eersteKleur && eersteKleur.uitverkocht) {
    toonFoto(eersteKleur.foto);
  } else if (eersteSwatch) {
    eersteSwatch.click();
  }
}

// ============================================================
// SHIELD-FLOW (Sutro Lite): vaste frame+lens-combinaties
// ============================================================
function setupShieldFlow(model) {
  var ck = document.querySelector('.config-kolom'); if (ck) ck.classList.add('shield');
  ['stap1','stap2','stap3','stapGlasdikte','stapCoating','stap4'].forEach(function(id){ var el = document.getElementById(id); if (el) el.style.display = 'none'; });
  var dm = document.getElementById('dividerModel'); if (dm) dm.style.display = 'none';
  var su = document.getElementById('stapUitvoering');
  su.style.display = ''; su.style.opacity = '1'; su.style.pointerEvents = 'auto';
  document.getElementById('keuzeUitvoering').textContent = '';
  document.getElementById('numUitvoering').classList.remove('klaar');
  document.getElementById('num5').textContent = '4';
  var s5 = document.getElementById('stap5'); s5.style.opacity = '0.35'; s5.style.pointerEvents = 'none';
  ['od-sph','os-sph'].forEach(function(id){ var sel = document.getElementById(id); if (sel) Array.from(sel.options).forEach(function(o){ if (o.value !== '') o.disabled = false; }); });
  bouwUitvoeringGrid(model);
  var eerste = (model.uitvoeringen || [])[0];
  if (eerste && eerste.fotos && eerste.fotos[0]) toonFoto(eerste.fotos[0]);
  var ft = document.getElementById('fotoThumbs'); if (ft) { ft.innerHTML = ''; ft.style.display = 'none'; }
  var fp = document.getElementById('fotoPrijs'); if (fp) fp.style.display = 'none';
  updatePrijs();
}

function bouwUitvoeringGrid(model) {
  var grid = document.getElementById('uitvoeringGrid');
  grid.innerHTML = '';
  (model.uitvoeringen || []).forEach(function(u){
    var btn = document.createElement('button');
    btn.className = 'uitvoering-kaart';
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('title', u.naam);
    btn.innerHTML = '<img src="' + optimeerFoto(u.fotos[0]) + '" alt="' + u.naam + '" loading="lazy"><span class="uitvoering-naam">' + u.montuur + '<br>' + u.lens + '</span>';
    btn.addEventListener('click', function(){ kiesUitvoering(u, btn); });
    btn.addEventListener('pointerdown', function(){ preloadUrl(u.fotos[0]); }, { passive: true });
    grid.appendChild(btn);
  });
}

function kiesUitvoering(u, knop) {
  staat.uitvoering = u;
  // Pseudo-state zodat de bestaande sterkte-/winkelwagenlogica blijft werken.
  staat.montuurKleur = { naam: u.montuur };
  staat.lens = u.lens;
  staat.correctie = 'enkelvoudig';
  staat.glastype = 'shield';
  document.querySelectorAll('#uitvoeringGrid .uitvoering-kaart').forEach(function(k){ k.setAttribute('aria-pressed', 'false'); });
  knop.setAttribute('aria-pressed', 'true');
  document.getElementById('keuzeUitvoering').textContent = u.naam;
  document.getElementById('numUitvoering').classList.add('klaar');
  toonFoto(u.fotos[0]);
  bouwFotoThumbs(u.fotos);
  toonSterkte();
  updatePrijs();
  updateBestelKnop();
}

function bouwFotoThumbs(fotos) {
  var strip = document.getElementById('fotoThumbs');
  if (!strip) return;
  strip.innerHTML = '';
  if (!fotos || fotos.length < 2) { strip.style.display = 'none'; return; }
  fotos.forEach(function(f, i){
    var t = document.createElement('img');
    t.className = 'foto-thumb' + (i === 0 ? ' actief' : '');
    t.src = optimeerFoto(f);
    t.loading = 'lazy';
    t.addEventListener('click', function(){
      toonFoto(f);
      strip.querySelectorAll('.foto-thumb').forEach(function(x){ x.classList.remove('actief'); });
      t.classList.add('actief');
    });
    strip.appendChild(t);
  });
  strip.style.display = 'flex';
}

function herbouwMontuurSwatches(kleuren) {
  const container = document.getElementById('montuurSwatches');
  container.innerHTML = '';
  kleuren.forEach(kleur => {
    const btn = document.createElement('button');
    btn.className = 'swatch';
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('title', kleur.naam);
    const uitverkochtLabel = TAAL === 'en' ? 'Temporarily<br>unavailable' : (TAAL === 'de' ? 'Vorübergehend<br>nicht lieferbar' : 'Tijdelijk niet<br>leverbaar');
    if (kleur.uitverkocht) {
      btn.classList.add('uitverkocht');
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.innerHTML = `
        <span class="swatch-uitverkocht-balloon">${uitverkochtLabel}</span>
        <div class="swatch-cirkel" style="background:${kleur.kleur};"></div>
        <span class="swatch-naam">${kleur.naam}</span>
      `;
      container.appendChild(btn);
      return;   // geen click/preload listeners voor een uitverkochte kleur
    }
    btn.innerHTML = `
      <div class="swatch-cirkel" style="background:${kleur.kleur};"></div>
      <span class="swatch-naam">${kleur.naam}</span>
    `;
    btn.addEventListener('click', () => kiesMontuur(kleur, btn));
    btn.addEventListener('pointerdown', () => {
      // De foto die na het klikken getoond wordt, alvast ophalen
      if (staat.lens && kleur.lensFotos && kleur.lensFotos[staat.lens]) {
        preloadUrl(kleur.lensFotos[staat.lens]);
      } else {
        preloadUrl(kleur.foto);
      }
    }, { passive: true });
    container.appendChild(btn);
  });
}

function bouwMontuurSwatches() {
  const container = document.getElementById('montuurSwatches');
  MONTUURKLEUREN.forEach(kleur => {
    const btn = document.createElement('button');
    btn.className = 'swatch';
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('title', kleur.naam);
    btn.innerHTML = `
      <div class="swatch-cirkel" style="background:${kleur.kleur};"></div>
      <span class="swatch-naam">${kleur.naam}</span>
    `;
    btn.addEventListener('click', () => kiesMontuur(kleur, btn));
    container.appendChild(btn);
  });
}

// ============================================================
// HOLBROOK LENZEN
// ============================================================
const HOLBROOK_LENZEN_NIET_GEPOL = [
  { naam: "Prizm 24K",             kleur: "#c8a42a" },
  { naam: "Prizm Black",           kleur: "#1a1a1a" },
  { naam: "Prizm Dark Golf",       kleur: "#6b4423" },
  { naam: "Prizm Field",           kleur: "#c44a1a" },
  { naam: "Prizm Golf",            kleur: "#5a8a2a" },
  { naam: "Prizm Grey",            kleur: "#6a6a6a" },
  { naam: "Prizm Jade",            kleur: "#2a6a3a" },
  { naam: "Prizm Road",            kleur: "#c43a2a" },
  { naam: "Prizm Road Black",      kleur: "#2a1a1a" },
  { naam: "Prizm Road Jade",       kleur: "#2a6a3a" },
  { naam: "Prizm Rose Gold",       kleur: "#e8a0b4" },
  { naam: "Prizm Ruby",            kleur: "#9a1a2a" },
  { naam: "Prizm Sapphire",        kleur: "#1a3a8a" },
  { naam: "Prizm Trail",           kleur: "#b46a2a" },
  { naam: "Prizm Tungsten",        kleur: "#7a5a3a" },
  { naam: "Prizm Violet",          kleur: "#6a3a9a" },
];

const HOLBROOK_LENZEN_GEPOL = [
  { naam: "Prizm 24K Polarized",   kleur: "#c8a42a" },
  { naam: "Prizm Black Polarized", kleur: "#1a1a1a" },
  { naam: "Prizm Deep Water Polarized", kleur: "#1a4a7a" },
  { naam: "Prizm Grey Polarized",  kleur: "#6a6a6a" },
  { naam: "Prizm Jade Polarized",  kleur: "#2a6a3a" },
  { naam: "Prizm Rose Gold Polarized", kleur: "#e8a0b4" },
  { naam: "Prizm Ruby Polarized",  kleur: "#9a1a2a" },
  { naam: "Prizm Sapphire Polarized", kleur: "#1a3a8a" },
  { naam: "Prizm Tungsten Polarized", kleur: "#7a5a3a" },
  { naam: "Prizm Violet Polarized", kleur: "#6a3a9a" },
];

function bouwLenzenGrid(model) {
  const containerNiet = document.getElementById('lenzenNietGepol');
  const containerGepol = document.getElementById('lenzenGepol');
  containerNiet.innerHTML = '';
  containerGepol.innerHTML = '';

  const isZonnebril = staat.briltype === 'zonnebril' || staat.briltype === 'meta';
  let lenzenNiet = isZonnebril ? HOLBROOK_LENZEN_NIET_GEPOL : LENZEN_NIET_GEPOL;
  let lenzenGepol = isZonnebril ? HOLBROOK_LENZEN_GEPOL : LENZEN_GEPOL;
  // Verberg Road Black bij Woodgrain
  if (staat.montuurKleur && staat.montuurKleur.naam === 'Woodgrain') {
    lenzenNiet = lenzenNiet.filter(l => l.naam !== 'Prizm Road Black');
  }
  // Silver (Eyejacket Redux): Prizm Road Black is in deze kleur niet beschikbaar
  if (staat.model && staat.model.naam === 'Eyejacket Redux' && staat.montuurKleur && staat.montuurKleur.naam === 'Silver') {
    lenzenNiet = lenzenNiet.filter(l => l.naam !== 'Prizm Road Black');
  }
  if (staat.montuurKleur && staat.montuurKleur.naam === 'Matte Grey Ink') {
    lenzenNiet = lenzenNiet.filter(l => l.naam !== 'Prizm Low Light' && l.naam !== 'Prizm Snow Sapphire');
  }
  // Bisphaera: lenzen zonder foto verbergen
  if (staat.model && staat.model.naam === 'Bisphaera') {
    lenzenNiet = lenzenNiet.filter(l => !['Prizm Low Light', 'Prizm Snow Sapphire'].includes(l.naam));
  }
  // Split Shot: alle sportlenzen behalve Low Light en Snow Sapphire (geen foto)
  if (staat.model && staat.model.naam === 'Split Shot') {
    lenzenNiet = lenzenNiet.filter(l => !['Prizm Low Light', 'Prizm Snow Sapphire'].includes(l.naam));
  }
  // Latch: geen Trail Torch, Low Light of Snow Sapphire.
  // Road Black staat al in de zonnebril-lenslijst, dus die komt vanzelf mee.
  if (staat.model && staat.model.naam === 'Latch') {
    lenzenNiet = lenzenNiet.filter(l => !['Prizm Low Light', 'Prizm Snow Sapphire', 'Prizm Trail Torch'].includes(l.naam));
  }
  if (staat.briltype === 'meta') {
    lenzenNiet = lenzenNiet.filter(l => !['Prizm Low Light', 'Prizm Snow Sapphire', 'Prizm Violet', 'Prizm Road Black'].includes(l.naam));
    lenzenGepol = lenzenGepol.filter(l => !['Prizm Violet Polarized'].includes(l.naam));
  }

  lenzenNiet.forEach(lens => containerNiet.appendChild(maakLensKnop(lens)));
  lenzenGepol.forEach(lens => containerGepol.appendChild(maakLensKnop(lens)));

  // Meta Transitions Gen S lenzen (alleen bij Meta)
  if (staat.briltype === 'meta') {
    META_TRANSITIONS_LENZEN.forEach(lens => {
      const kaart = maakLensKnop(lens);
      kaart.style.display = 'none';
      containerNiet.appendChild(kaart);
    });
  }
}

function maakLensKnop(lens) {
  const btn = document.createElement('button');
  btn.className = 'lens-kaart';
  btn.setAttribute('aria-pressed', 'false');
  btn.setAttribute('data-lens', lens.naam);
  btn.innerHTML = `
    <div class="lens-kleur-dot" style="background:${lens.kleur};"></div>
    <span>${lens.naam}</span>
  `;
  btn.addEventListener('click', () => kiesLens(lens.naam, btn));
  // Alvast beginnen met laden bij aanraken, nog voor het loslaten.
  // Dat scheelt de tijd tussen indrukken en loslaten, al gauw 100-200 ms.
  btn.addEventListener('pointerdown', () => {
    if (staat.montuurKleur && staat.montuurKleur.lensFotos) {
      preloadUrl(staat.montuurKleur.lensFotos[lens.naam]);
    }
  }, { passive: true });
  return btn;
}

function vulSterktevelden() {
  // Sferisch -5 tot +4 in stappen van 0.25
  const sphWaarden = [];
  for (let v = -5; v <= 4; v += 0.25) {
    sphWaarden.push(v.toFixed(2));
  }
  // Additie change listeners
  ['add-rechts', 'add-links'].forEach(id => {
    document.getElementById(id).addEventListener('change', function() { updateBestelKnop(); });
  });
  ['od-sph', 'os-sph'].forEach(id => {
    const sel = document.getElementById(id);
    sel.innerHTML = '<option value="">' + T.kiesPlaceholder + '</option>';
    sphWaarden.forEach(w => {
      const opt = document.createElement('option');
      opt.value = w;
      opt.textContent = (w > 0 ? '+' : '') + parseFloat(w).toFixed(2);
      sel.appendChild(opt);
    });
  });

  // Cilinder -0.25 tot -3. Geen 0.00 in de lijst: dat betekent hetzelfde als "Geen"
  const cylWaarden = [];
  for (let v = -0.25; v >= -3; v -= 0.25) {
    cylWaarden.push(v.toFixed(2));
  }
  ['od-cyl', 'os-cyl'].forEach(id => {
    const sel = document.getElementById(id);
    sel.innerHTML = '<option value="">' + T.kiesPlaceholder + '</option><option value="geen">' + T.geen + '</option>';
    cylWaarden.forEach(w => {
      const opt = document.createElement('option');
      opt.value = w;
      opt.textContent = parseFloat(w).toFixed(2);
      sel.appendChild(opt);
    });
  });

  // As 0-180
  ['od-as', 'os-as'].forEach(id => {
    const sel = document.getElementById(id);
    sel.innerHTML = '<option value="">' + T.kiesPlaceholder + '</option>';
    for (let i = 0; i <= 180; i++) {
      const opt = document.createElement('option');
      opt.value = i;
      opt.textContent = i + '°';
      sel.appendChild(opt);
    }
  });

  // PD 26-40 in stappen van 0.5
  ['pd-rechts', 'pd-links'].forEach(id => {
    const sel = document.getElementById(id);
    sel.innerHTML = '<option value="">' + T.kiesPlaceholder + '</option>';
    for (let v = 26; v <= 40; v += 0.5) {
      const opt = document.createElement('option');
      opt.value = v.toFixed(1);
      opt.textContent = v.toFixed(1) + ' mm';
      sel.appendChild(opt);
    }
  });

  // Additie +0.75 tot +3.00 in stappen van 0.25
  ['add-rechts', 'add-links'].forEach(id => {
    const sel = document.getElementById(id);
    sel.innerHTML = '<option value="">' + T.kiesPlaceholder + '</option>';
    for (let v = 0.75; v <= 3.00; v += 0.25) {
      const opt = document.createElement('option');
      opt.value = v.toFixed(2);
      opt.textContent = '+' + v.toFixed(2);
      sel.appendChild(opt);
    }
  });
}

// ============================================================
// KEUZE FUNCTIES
// ============================================================
// FOTO OPTIMALISATIE — kleinere afbeeldingen + preloaden
// ============================================================
// Beeldbreedte afgestemd op hoe groot de foto daadwerkelijk getoond wordt.
// Wordt pas bij het eerste gebruik bepaald, zodat de fotokolom al opgemeten kan worden.
let _fotoBreedte = null;
function fotoBreedte() {
  if (_fotoBreedte) return _fotoBreedte;
  const vak = document.getElementById('fotoHoofd');
  const cssBreedte = (vak && vak.clientWidth) ? vak.clientWidth : (window.innerWidth || 800);
  const px = cssBreedte * Math.min(window.devicePixelRatio || 1, 2);
  _fotoBreedte = px <= 500 ? 500 : px <= 700 ? 700 : px <= 900 ? 900 : 1100;
  return _fotoBreedte;
}

function optimeerFoto(url) {
  if (!url || url === '') return url;
  if (url.slice(0,5) === 'data:') return url;
  if (url.includes('width=')) return url;
  const w = 'width=' + fotoBreedte();
  return url.includes('?') ? url + '&' + w : url + '?' + w;
}

// ============================================================
// FOTO WISSELEN
// Wisselt zodra de afbeelding beschikbaar is. Zit hij al in de cache,
// dan gebeurt dat direct in plaats van na een vaste wachttijd van 150ms.
// ============================================================
let fotoBeurt = 0;
function toonFoto(url) {
  const mainFoto = document.getElementById('fotoMain');
  if (!mainFoto || !url || url === '') return;
  const bron = optimeerFoto(url);
  if (mainFoto.getAttribute('src') === bron) { mainFoto.style.opacity = '1'; return; }

  const beurt = ++fotoBeurt;
  const img = new Image();
  if ('fetchPriority' in img) img.fetchPriority = 'high';   // deze foto wordt nú verwacht
  img.src = bron;

  const zetNeer = () => {
    if (beurt !== fotoBeurt) return;        // nieuwere klik heeft voorrang
    mainFoto.src = bron;
    mainFoto.style.opacity = '1';
  };

  if (img.complete) {                       // al in de cache: meteen tonen
    zetNeer();
    return;
  }
  mainFoto.style.opacity = '0.4';           // subtiel dimmen tijdens laden

  // Eerst laten uitpakken, dan pas wisselen. Anders gebeurt het uitpakken
  // tijdens het tekenen en zie je een korte hapering.
  if (typeof img.decode === 'function') {
    img.decode().then(zetNeer).catch(zetNeer);
  } else {
    img.onload = img.onerror = zetNeer;
  }
}

// ============================================================
// PRELOADEN — gericht en met beperkte gelijktijdigheid
// Voorheen werden ~234 foto's blind opgehaald, waardoor de foto waar de
// klant op wachtte achteraan in de wachtrij belandde. Nu wordt per stap
// alleen geladen wat waarschijnlijk als volgende nodig is.
// ============================================================
const PRELOAD_MAX = 4;
let preloadRij = [];
let preloadBezig = 0;
const preloadGehad = new Set();

function preloadUrl(url) {
  if (!url || url === '' || preloadGehad.has(url)) return;
  preloadGehad.add(url);
  preloadRij.push(url);
  verwerkPreloadRij();
}

function verwerkPreloadRij() {
  while (preloadBezig < PRELOAD_MAX && preloadRij.length) {
    const url = preloadRij.shift();
    preloadBezig++;
    const img = new Image();
    if ('fetchPriority' in img) img.fetchPriority = 'low';
    img.onload = img.onerror = () => { preloadBezig--; verwerkPreloadRij(); };
    img.src = optimeerFoto(url);
  }
}

// Wachtrij legen zodra de klant een andere kant op gaat
function stopPreload() { preloadRij = []; }

// Hoeveel lensfoto's we vooruit laden. Op een telefoon houden we dit laag:
// elke gedecodeerde foto kost werkgeheugen en te veel tegelijk maakt het
// toestel juist trager naarmate je langer rondklikt.
function preloadLimiet() {
  const smal = (window.innerWidth || 1200) < 860;
  const zuinig = navigator.connection && (navigator.connection.saveData ||
    /2g|3g/.test(navigator.connection.effectiveType || ''));
  if (zuinig) return 0;
  return smal ? 10 : 30;
}

// Lensfoto's van één montuur, in de volgorde waarin ze op het scherm staan
// en alleen van het tabblad dat de klant nu ziet. Voorheen werd er een
// willekeurige greep uit de lijst gedaan, inclusief lenzen die niet in beeld waren.
function preloadFotos(kleur) {
  if (!kleur || !kleur.lensFotos) return;
  const max = preloadLimiet();
  if (max === 0) return;

  if (staat.glastype === 'transitions' && kleur.transitieFotos) {
    kleur.transitieFotos.forEach(preloadUrl);
  }

  const bak = staat.geactiveerdeTab === 'gepolariseerd'
    ? document.getElementById('lenzenGepol')
    : document.getElementById('lenzenNietGepol');

  const namen = [];
  if (bak) {
    bak.querySelectorAll('.lens-kaart').forEach(k => {
      if (k.style.display !== 'none' && k.dataset.lens) namen.push(k.dataset.lens);
    });
  }
  if (namen.length === 0) {                 // raster nog niet gebouwd
    Object.values(kleur.lensFotos).slice(0, max).forEach(preloadUrl);
    return;
  }
  namen.slice(0, max).forEach(n => preloadUrl(kleur.lensFotos[n]));
}

// Miniaturen van alle modellen — klein setje, maakt tabwisselen direct
function preloadModelMiniaturen() {
  Object.values(MODELLEN).forEach(lijst => lijst.forEach(m => preloadUrl(m.foto)));
}

// Startfoto's van alle montuurkleuren van één model
function preloadMontuurKleuren(kleuren) {
  if (!kleuren) return;
  kleuren.forEach(k => preloadUrl(k.foto));
}

// ============================================================
function kiesMontuur(kleur, knop) {
  staat.montuurKleur = kleur;

  // Lensraster opnieuw opbouwen: sommige lenzen zijn kleur-afhankelijk
  // (bv. Silver verbergt Prizm Road Black). De geselecteerde lens wordt
  // verderop in deze functie weer als 'gekozen' hersteld.
  bouwLenzenGrid(staat.model);

  // Swatch ui
  document.querySelectorAll('#montuurSwatches .swatch').forEach(s => s.setAttribute('aria-pressed', 'false'));
  knop.setAttribute('aria-pressed', 'true');

  document.getElementById('keuze1').textContent = kleur.naam;
  document.getElementById('num1').classList.add('klaar');

  // Bewaar alle eerdere keuzes — herstel de juiste stap states
  // Stap 2 (correctie) altijd actief
  document.getElementById('stap2').style.opacity = '1';
  document.getElementById('stap2').style.pointerEvents = 'auto';

  // Stap 3 (glastype) actief als correctie al gekozen was
  if (staat.correctie) {
    document.getElementById('stap3').style.opacity = '1';
    document.getElementById('stap3').style.pointerEvents = 'auto';
    // Herstel correctie knop UI
    document.querySelectorAll('#inhoud2 .optie-kaart').forEach(k => k.setAttribute('aria-pressed', 'false'));
    const btnCorrectie = staat.correctie === 'enkelvoudig'
      ? document.getElementById('btnEnkelvoudig')
      : document.getElementById('btnProgressief');
    if (btnCorrectie) btnCorrectie.setAttribute('aria-pressed', 'true');
    document.getElementById('keuze2').textContent = staat.correctie === 'enkelvoudig' ? T.enkelvoudig : T.progressief;
    document.getElementById('num2').classList.add('klaar');
  } else {
    document.getElementById('stap3').style.opacity = '0.35';
    document.getElementById('stap3').style.pointerEvents = 'none';
  }

  // Stap 4 (lenskleur) actief als glastype al gekozen was
  if (staat.glastype) {
    document.getElementById('stap4').style.opacity = '1';
    document.getElementById('stap4').style.pointerEvents = 'auto';
    // Herstel glastype knop UI
    document.querySelectorAll('#inhoud3 .optie-kaart').forEach(k => k.setAttribute('aria-pressed', 'false'));
    const btnGlas = staat.glastype === 'authentics-complex'
      ? document.getElementById('btnAuthentics')
      : document.getElementById('transitionsKnop');
    if (btnGlas) btnGlas.setAttribute('aria-pressed', 'true');
    document.getElementById('keuze3').textContent = staat.glastype === 'authentics-complex' ? T.authenticsComplex : T.transitions;
    document.getElementById('num3').classList.add('klaar');
    updateLensTabs();
  } else {
    document.getElementById('stap4').style.opacity = '0.35';
    document.getElementById('stap4').style.pointerEvents = 'none';
  }

  // Stap 5 (sterkte) actief als lens al gekozen was
  if (staat.lens && staat.glastype) {
    document.getElementById('stap5').style.opacity = '1';
    document.getElementById('stap5').style.pointerEvents = 'auto';
    // Herstel lens knop UI
    document.querySelectorAll('.lens-kaart').forEach(k => {
      k.setAttribute('aria-pressed', k.dataset.lens === staat.lens ? 'true' : 'false');
    });
    document.getElementById('keuze4').textContent = staat.lens;
    document.getElementById('num4').classList.add('klaar');
    const badge = document.getElementById('lensBadge');
    if (staat.lens !== 'Photochromic') {
      badge.textContent = staat.lens;
      badge.style.display = 'block';
    }
  } else {
    document.getElementById('stap5').style.opacity = '0.35';
    document.getElementById('stap5').style.pointerEvents = 'none';
  }

  // Toon juiste foto op basis van onthouden keuzes
  if (staat.glastype === 'transitions') {
    if (kleur.transitieFotos && kleur.transitieFotos.length > 0) {
      wisselPhotochromic(staat.transitieVariant || 'licht');
    } else {
      toonFoto(kleur.foto);
    }
  } else if (staat.lens && kleur.lensFotos && kleur.lensFotos[staat.lens]) {
    toonFoto(kleur.lensFotos[staat.lens]);
  } else {
    toonFoto(kleur.foto);
  }

  updatePrijs();
  updateBestelKnop();

  // Herstel sterkte stap als glastype al gekozen was
  if (staat.glastype) {
    toonSterkte();
  }

  // Eerst de lensfoto's van dit montuur (daarom voelt de lenskeuze snel aan),
  // daarna pas de startfoto's van de overige montuurkleuren
  stopPreload();
  preloadFotos(kleur);
  preloadMontuurKleuren(montuurKleurenVoor(staat.model));

  // Meta: herstel glasdikte, coating en lenskleur keuzes
  if (staat.briltype === 'meta' && staat.glastype) {
    // Glasdikte stap herstel
    if (staat.glastype === 'clear' || staat.glastype === 'transitions') {
      document.getElementById('stapGlasdikte').style.display = 'block';
      document.getElementById('stapGlasdikte').style.opacity = '1';
      document.getElementById('stapGlasdikte').style.pointerEvents = 'auto';
      if (staat.glasdikte) {
        document.querySelectorAll('.glasdikte-kaart').forEach(k => {
          k.setAttribute('aria-pressed', k.dataset.glasdikte === staat.glasdikte ? 'true' : 'false');
        });
        document.getElementById('numGlasdikte').classList.add('klaar');
      }
    }
    // Coating stap herstel
    if (staat.glastype === 'clear' || staat.glastype === 'transitions') {
      document.getElementById('stapCoating').style.display = 'block';
      document.getElementById('stapCoating').style.opacity = '1';
      document.getElementById('stapCoating').style.pointerEvents = 'auto';
      if (staat.coating) {
        document.querySelectorAll('.coating-kaart').forEach(k => {
          k.setAttribute('aria-pressed', k.dataset.coating === staat.coating ? 'true' : 'false');
        });
        document.getElementById('numCoating').classList.add('klaar');
      }
    }
    // Lenskleur stap herstel bij transitions
    if (staat.glastype === 'transitions') {
      document.getElementById('stap4').style.display = 'block';
      document.getElementById('stap4').style.opacity = '1';
      document.getElementById('stap4').style.pointerEvents = 'auto';
    }
    // Clear: lenskleur verbergen
    if (staat.glastype === 'clear') {
      document.getElementById('stap4').style.display = 'none';
    }
    toonSterkte();
  }
}

function kiesCorrectie(type, knop) {
  staat.correctie = type;
  document.querySelectorAll('#inhoud2 .optie-kaart').forEach(k => k.setAttribute('aria-pressed', 'false'));
  knop.setAttribute('aria-pressed', 'true');
  document.getElementById('keuze2').textContent = type === 'enkelvoudig' ? T.enkelvoudig : T.progressief;
  document.getElementById('num2').classList.add('klaar');

  // Activeer stap 3
  document.getElementById('stap3').style.opacity = '1';
  document.getElementById('stap3').style.pointerEvents = 'auto';
  // Zorg dat Clear knop zichtbaar is bij Meta
  if (staat.briltype === 'meta') {
    document.getElementById('btnClear').style.display = 'flex';
    if (staat.glastype) {
      // Glastype knop herstel
      document.getElementById('stap3').style.opacity = '1';
      document.getElementById('stap3').style.pointerEvents = 'auto';
      // Glasdikte en coating stappen herstel
      if (staat.glastype === 'clear' || staat.glastype === 'transitions') {
        document.getElementById('stapGlasdikte').style.display = 'block';
        document.getElementById('stapGlasdikte').style.opacity = '1';
        document.getElementById('stapGlasdikte').style.pointerEvents = 'auto';
        document.getElementById('stapCoating').style.display = 'block';
        document.getElementById('stapCoating').style.opacity = '1';
        document.getElementById('stapCoating').style.pointerEvents = 'auto';
        if (staat.glasdikte) {
          document.querySelectorAll('.glasdikte-kaart').forEach(k => {
            k.setAttribute('aria-pressed', k.dataset.glasdikte === staat.glasdikte ? 'true' : 'false');
          });
          document.getElementById('numGlasdikte').classList.add('klaar');
        }
        if (staat.coating) {
          document.querySelectorAll('.coating-kaart').forEach(k => {
            k.setAttribute('aria-pressed', k.dataset.coating === staat.coating ? 'true' : 'false');
          });
          document.getElementById('numCoating').classList.add('klaar');
        }
      }
      // Lenskleur herstel
      if (staat.glastype === 'transitions') {
        document.getElementById('stap4').style.display = 'block';
        document.getElementById('stap4').style.opacity = '1';
        document.getElementById('stap4').style.pointerEvents = 'auto';
      }
      if (staat.glastype === 'clear') {
        document.getElementById('stap4').style.display = 'none';
      }
      if (staat.glastype === 'authentics-complex') {
        document.getElementById('stap4').style.opacity = '1';
        document.getElementById('stap4').style.pointerEvents = 'auto';
      }
      toonSterkte();
    }
  }

  // Toon additie velden alleen bij progressief
  const additieSectie = document.getElementById('additie-sectie');
  if (type === 'progressief') {
    additieSectie.style.display = 'block';
  } else {
    additieSectie.style.display = 'none';
    document.getElementById('add-rechts').value = '';
    document.getElementById('add-links').value = '';
  }

  toonSterkte();
  updatePrijs();
}

function kiesGlastype(type, knop) {
  staat.glastype = type;
  staat.lens = null;

  document.querySelectorAll('#inhoud3 .optie-kaart').forEach(k => k.setAttribute('aria-pressed', 'false'));
  knop.setAttribute('aria-pressed', 'true');
  // Zorg dat Clear knop zichtbaar blijft bij Meta
  if (staat.briltype === 'meta') {
    document.getElementById('btnClear').style.display = 'flex';
  }
  const isMeta = staat.briltype === 'meta';
  document.getElementById('keuze3').textContent = type === 'authentics-complex' ? T.authenticsComplex : (type === 'clear' ? 'Clear' : (isMeta ? 'Transitions Gen S' : T.transitions));
  document.getElementById('num3').classList.add('klaar');
  document.getElementById('keuze4').textContent = '';
  const toonGlasdikte = isMeta && (type === 'transitions' || type === 'clear');

  // Cancel eventuele lopende Authentics timer
  if (metaAuthTimer) { clearTimeout(metaAuthTimer); metaAuthTimer = null; }
  // Reset
  document.querySelectorAll('.lens-kaart').forEach(k => k.setAttribute('aria-pressed', 'false'));
  // Bij Meta Clear: forceer lens reset en Clear foto
  if (isMeta && type === 'clear') {
    staat.lens = 'Clear';
    document.getElementById('stap4').style.display = 'none';
    document.getElementById('lensBadge').style.display = 'none';
  }
  document.getElementById('stapCoating').style.display = 'none';
  staat.coating = null;
  staat.lens = null;
  if (isMeta) {
    staat.glasdikte = null;
    // Reset mail recept checkbox
    var checkMailRecept = document.getElementById('checkMailRecept');
    if (checkMailRecept && checkMailRecept.checked) {
      checkMailRecept.checked = false;
      checkMailRecept.dispatchEvent(new Event('change'));
    }
    staat.mailReceptHighRx = null;
    document.getElementById('numGlasdikte').classList.remove('klaar');
    document.getElementById('numCoating').classList.remove('klaar');
    document.getElementById('num4').classList.remove('klaar');
    document.getElementById('keuzeGlasdikte').textContent = '';
    document.getElementById('keuzeCoating').textContent = '';
    document.getElementById('keuze4').textContent = '';
    document.querySelectorAll('.glasdikte-kaart').forEach(k => k.setAttribute('aria-pressed', 'false'));
    document.querySelectorAll('.coating-kaart').forEach(k => k.setAttribute('aria-pressed', 'false'));
  }

  // Glasdikte stap tonen/verbergen
  const glasdikteStap = document.getElementById('stapGlasdikte');
  if (toonGlasdikte) {
    glasdikteStap.style.display = 'block';
    glasdikteStap.style.opacity = '1';
    glasdikteStap.style.pointerEvents = 'auto';
    staat.glasdikte = null;
    document.querySelectorAll('.glasdikte-kaart').forEach(k => k.setAttribute('aria-pressed', 'false'));
    document.getElementById('keuzeGlasdikte').textContent = '';
    // Bij Clear: verberg lenskleur helemaal
    if (type === 'clear') {
      document.getElementById('stap4').style.display = 'none';
      if (staat.montuurKleur && staat.montuurKleur.lensFotos && staat.montuurKleur.lensFotos['Clear']) {
        toonFoto(staat.montuurKleur.lensFotos['Clear']);
      }
      // Meta Clear: glasdikte EN coating tegelijk openen
      document.getElementById('stapCoating').style.display = 'block';
      document.getElementById('stapCoating').style.opacity = '1';
      document.getElementById('stapCoating').style.pointerEvents = 'auto';
      staat.coating = null;
      document.querySelectorAll('.coating-kaart').forEach(k => k.setAttribute('aria-pressed', 'false'));
      document.getElementById('keuzeCoating').textContent = '';
    } else if (type === 'transitions' && isMeta) {
      // Meta Transitions: glasdikte, coating EN lenskleur tegelijk openen
      // Toon Clear foto
      if (staat.montuurKleur && staat.montuurKleur.lensFotos && staat.montuurKleur.lensFotos['Clear']) {
        toonFoto(staat.montuurKleur.lensFotos['Clear']);
      }
      document.getElementById('stapCoating').style.display = 'block';
      document.getElementById('stapCoating').style.opacity = '1';
      document.getElementById('stapCoating').style.pointerEvents = 'auto';
      staat.coating = null;
      document.querySelectorAll('.coating-kaart').forEach(k => k.setAttribute('aria-pressed', 'false'));
      document.getElementById('keuzeCoating').textContent = '';
      // Lenskleur tonen met alleen Meta transitions lenzen
      document.getElementById('stap4').style.display = 'block';
      document.getElementById('stap4').style.opacity = '1';
      document.getElementById('stap4').style.pointerEvents = 'auto';
      setTimeout(() => {
        document.getElementById('photochromicSwitcher').style.display = 'none';
        var tabRij = document.querySelector('.tab-rij');
        if (tabRij) tabRij.style.display = 'none';
        document.getElementById('lenzenNietGepol').style.display = 'grid';
        document.querySelectorAll('#lenzenNietGepol .lens-kaart').forEach(k => { k.style.display = 'none'; });
        document.querySelectorAll('#lenzenGepol .lens-kaart').forEach(k => { k.style.display = 'none'; });
        META_TRANSITIONS_LENZEN.forEach(l => {
          var kaart = document.querySelector('.lens-kaart[data-lens="' + l.naam + '"]');
          if (kaart) kaart.style.display = 'flex';
        });
      }, 50);
    } else {
      document.getElementById('stap4').style.display = 'block';
      document.getElementById('stap4').style.opacity = '0.35';
      document.getElementById('stap4').style.pointerEvents = 'none';
    }
    document.getElementById('stap5').style.opacity = '0.35';
    document.getElementById('stap5').style.pointerEvents = 'none';
  } else {
    glasdikteStap.style.display = 'none';
    staat.glasdikte = null;
    document.getElementById('stapCoating').style.display = 'none';
    // Activeer stap 4 (lenskleur) direct
    document.getElementById('stap4').style.opacity = '1';
    document.getElementById('stap4').style.pointerEvents = 'auto';
    document.getElementById('stap4').style.display = 'block';
    document.getElementById('stap5').style.opacity = '0.35';
    document.getElementById('stap5').style.pointerEvents = 'none';
  }

  updateLensTabs();

  // Meta Clear/Transitions: toon Clear foto en verberg badge
  if (isMeta && type === 'clear') {
    document.getElementById('lensBadge').textContent = 'Clear';
    document.getElementById('lensBadge').style.display = 'block';
  }
  if (isMeta && type === 'transitions') {
    document.getElementById('lensBadge').textContent = 'Transitions Gen S';
    document.getElementById('lensBadge').style.display = 'block';
    var clearUrl = staat.montuurKleur && staat.montuurKleur.lensFotos ? staat.montuurKleur.lensFotos['Clear'] : null;
    if (clearUrl) {
      toonFoto(clearUrl);
      setTimeout(() => {
        if (staat.glastype === 'clear') {
          toonFoto(clearUrl);
          document.getElementById('lensBadge').textContent = 'Clear';
          document.getElementById('lensBadge').style.display = 'block';
        } else if (staat.glastype === 'transitions') {
          toonFoto(clearUrl);
        }
      }, 200);
    }
  }

  if (type === 'authentics-complex') {
    if (staat.briltype === 'meta') {
      // Meta Authentics: forceer lensweergave
      metaAuthTimer = setTimeout(() => {
        if (staat.glastype !== 'authentics-complex') return;
        var metaVerborgen = ['Clear', 'Clear to Grey', 'Clear to Brown', 'Clear to Ruby', 'Clear to Amber', 'Clear to Amethyst', 'Clear to Emerald', 'Clear to Green', 'Clear to Sapphire', 'Prizm Low Light', 'Prizm Snow Sapphire', 'Prizm Violet', 'Prizm Road Black'];
        // Niet-gepolariseerd
        var nietGepol = document.getElementById('lenzenNietGepol');
        nietGepol.style.display = 'grid';
        nietGepol.querySelectorAll('.lens-kaart').forEach(k => {
          k.style.display = metaVerborgen.includes(k.dataset.lens) ? 'none' : 'flex';
        });
        // Gepolariseerd
        document.getElementById('lenzenGepol').querySelectorAll('.lens-kaart').forEach(k => {
          k.style.display = k.dataset.lens === 'Prizm Violet Polarized' ? 'none' : 'flex';
        });
        // Tabs tonen
        var tabRij = document.querySelector('.tab-rij');
        if (tabRij) tabRij.style.display = 'flex';
        // Herstel tab weergave
        toonLensTab(staat.geactiveerdeTab || 'niet-gepolariseerd');
        // Selecteer eerste zichtbare lens
        var eerste = nietGepol.querySelector('.lens-kaart:not([style*="none"])');
        if (eerste) eerste.click();
      }, 100);
    } else {
      metaAuthTimer = setTimeout(() => {
        if (staat.glastype !== 'authentics-complex') return;
        const eersteLens = document.querySelector('#lenzenNietGepol .lens-kaart:not([style*="none"])');
        if (eersteLens) eersteLens.click();
      }, 150);
    }
  }

  if (type === 'transitions' && staat.briltype !== 'meta') {
    // Sportbril/Zonnebril: selecteer Photochromic automatisch
    setTimeout(() => {
      const photochromicKnop = document.querySelector('.lens-kaart[data-lens="Photochromic"]');
      if (photochromicKnop) {
        document.querySelectorAll('.lens-kaart').forEach(k => k.setAttribute('aria-pressed', 'false'));
        photochromicKnop.setAttribute('aria-pressed', 'true');
        staat.lens = 'Photochromic';
        document.getElementById('keuze4').textContent = 'Photochromic';
        document.getElementById('num4').classList.add('klaar');
      }
      wisselPhotochromic(staat.transitieVariant || 'licht');
      toonSterkte();
      updatePrijs();
    }, 200);
  }
  // Meta Transitions: lenskleur wordt later gekozen na glasdikte + coating
  toonSterkte();
  updatePrijs();
}

function kiesLens(naam, knop) {
  staat.lens = naam;
  // Onthoud per tab
  if (naam.includes('Polarized')) {
    staat.laasteGepolariseerd = naam;
  } else if (naam !== 'Photochromic') {
    staat.laasteNietGepolariseerd = naam;
  }
  document.querySelectorAll('.lens-kaart').forEach(k => k.setAttribute('aria-pressed', 'false'));
  knop.setAttribute('aria-pressed', 'true');
  document.getElementById('keuze4').textContent = naam;
  document.getElementById('num4').classList.add('klaar');

  // Badge op foto
  const badge = document.getElementById('lensBadge');
  if (naam === 'Photochromic') {
    // Photochromic badge wordt door wisselPhotochromic gezet
    badge.style.display = 'none';
  } else if (staat.briltype === 'meta' && staat.glastype === 'clear') {
    badge.textContent = 'Clear';
    badge.style.display = 'block';
  } else if (staat.briltype === 'meta' && staat.glastype === 'transitions') {
    // Meta Transitions: badge wordt door wisselPhotochromic beheerd
    badge.style.display = 'none';
  } else {
    badge.textContent = naam;
    badge.style.display = 'block';
  }

  // Foto wisselen naar lens-specifieke foto
  // Bij Meta Clear: geen foto wissel
  if (staat.briltype === 'meta' && staat.glastype === 'clear') return;
  // Bij Meta Transitions: eigen foto-logica (geen fade, direct wisselen)
  if (staat.briltype === 'meta' && staat.glastype === 'transitions') {
    var metaLensFoto = staat.montuurKleur && staat.montuurKleur.lensFotos ? staat.montuurKleur.lensFotos[naam] : null;
    if (metaLensFoto && staat.montuurKleur.transitieFotos) {
      staat.montuurKleur.transitieFotos[1] = metaLensFoto;
    }
    if (staat.transitieVariant === 'donker' && metaLensFoto) {
      toonFoto(metaLensFoto);
    } else {
      var metaClear = staat.montuurKleur && staat.montuurKleur.lensFotos ? staat.montuurKleur.lensFotos['Clear'] : null;
      toonFoto(metaClear);
    }
    // Toon foto wisselaar en update badge
    document.getElementById('photochromicSwitcher').style.display = 'block';
    var kleur = naam.replace('Clear to ', '');
    var variantLabel = staat.transitieVariant === 'donker' ? T.transitieDonker : T.transitieLicht;
    document.getElementById('lensBadge').textContent = 'Transition ' + kleur + ' (' + variantLabel + ')';
    document.getElementById('lensBadge').style.display = 'block';
    toonSterkte();
    updatePrijs();
    updateBestelKnop();
    return;
  }
  // Bij Photochromic laat wisselPhotochromic de foto regelen
  if (naam !== 'Photochromic' && staat.montuurKleur && staat.montuurKleur.lensFotos) {
    const lensFoto = staat.montuurKleur.lensFotos[naam];
    if (lensFoto) {
      toonFoto(lensFoto);
    }
  }

  // Bij Photochromic toon altijd de lichte variant
  if (naam === 'Photochromic') {
    setTimeout(() => wisselPhotochromic('licht'), 50);
  }



  // Bij Meta Transitions Gen S: toon foto wisselaar na lenskeuze
  if (staat.briltype === 'meta' && staat.glastype === 'transitions') {
    document.getElementById('photochromicSwitcher').style.display = 'block';
    if (staat.montuurKleur && staat.montuurKleur.transitieFotos && staat.montuurKleur.transitieFotos.length > 0) {
      wisselPhotochromic('licht');
    }
  }



  toonSterkte();
  updatePrijs();
}

function toonLensTab(tab) {
  staat.geactiveerdeTab = tab;
  staat.lens = null;
  document.getElementById('keuze4').textContent = '';
  document.querySelectorAll('.lens-kaart').forEach(k => k.setAttribute('aria-pressed', 'false'));

  if (tab === 'niet-gepolariseerd') {
    document.getElementById('lenzenNietGepol').style.display = 'grid';
    document.getElementById('lenzenGepol').style.display = 'none';
    document.getElementById('tabNietGepol').classList.add('actief');
    document.getElementById('tabGepol').classList.remove('actief');
    setTimeout(() => {
      const teSelecteren = staat.laasteNietGepolariseerd
        ? document.querySelector(`#lenzenNietGepol .lens-kaart[data-lens="${staat.laasteNietGepolariseerd}"]`)
        : document.querySelector('#lenzenNietGepol .lens-kaart');
      if (teSelecteren) teSelecteren.click();
    }, 50);
  } else {
    document.getElementById('lenzenNietGepol').style.display = 'none';
    document.getElementById('lenzenGepol').style.display = 'grid';
    document.getElementById('tabNietGepol').classList.remove('actief');
    document.getElementById('tabGepol').classList.add('actief');
    setTimeout(() => {
      const teSelecteren = staat.laasteGepolariseerd
        ? document.querySelector(`#lenzenGepol .lens-kaart[data-lens="${staat.laasteGepolariseerd}"]`)
        : document.querySelector('#lenzenGepol .lens-kaart');
      if (teSelecteren) teSelecteren.click();
    }, 50);
  }
  updatePrijs();
}

function wisselPhotochromic(variant) {
  // Onthoud de gekozen variant
  staat.transitieVariant = variant;
  // Update badge met Transition variant
  var badge = document.getElementById('lensBadge');
  var variantLabel = variant === 'licht' ? T.transitieLicht : T.transitieDonker;
  if (staat.briltype === 'meta' && staat.glastype === 'transitions') {
    // Meta: toon lenskleur + variant
    var lensNaam = staat.lens || '';
    var kleurNaam = lensNaam.replace('Clear to ', '');
    badge.textContent = 'Transition ' + kleurNaam + ' (' + variantLabel + ')';
    badge.style.display = 'block';
  } else if (staat.glastype === 'transitions') {
    // Sport/Zonnebril: toon Transition + variant
    badge.textContent = 'Transition (' + variantLabel + ')';
    badge.style.display = 'block';
  }
  // Gebruik altijd de transitieFotos van het geselecteerde montuur
  const fotos = staat.montuurKleur?.transitieFotos || [];
  const fotoLicht = fotos[0] || "";
  const fotoDonker = fotos[1] || fotos[0] || "";

  const btnLicht = document.getElementById('btnLicht');
  const btnDonker = document.getElementById('btnDonker');

  toonFoto(variant === 'licht' ? fotoLicht : fotoDonker);

  if (variant === 'licht') {
    btnLicht.style.borderColor = 'var(--paars)';
    btnLicht.style.background = 'var(--paars-licht)';
    btnLicht.style.color = 'var(--paars)';
    btnDonker.style.borderColor = 'var(--grijs-300)';
    btnDonker.style.background = 'var(--wit)';
    btnDonker.style.color = 'var(--grijs-700)';
  } else {
    btnDonker.style.borderColor = 'var(--paars)';
    btnDonker.style.background = 'var(--paars-licht)';
    btnDonker.style.color = 'var(--paars)';
    btnLicht.style.borderColor = 'var(--grijs-300)';
    btnLicht.style.background = 'var(--wit)';
    btnLicht.style.color = 'var(--grijs-700)';
  }
}

function updateLensTabs() {
  const isTransitions = staat.glastype === 'transitions';
  const tabRij = document.querySelector('.tab-rij');
  const stap4Titel = document.querySelector('#stap4 .stap-titel');

  if (isTransitions) {
    if (staat.briltype === 'meta') {
      // Meta Transitions Gen S: toon lenskleur knoppen
      tabRij.style.display = 'none';
      stap4Titel.textContent = T.lenskleur;
      // Photochromic switcher: alleen tonen als lens al gekozen is
      if (!staat.lens) {
        document.getElementById('photochromicSwitcher').style.display = 'none';
      }
      document.querySelectorAll('.lens-kaart').forEach(k => { k.style.display = 'none'; });
      META_TRANSITIONS_LENZEN.forEach(lens => {
        var kaart = document.querySelector('.lens-kaart[data-lens="' + lens.naam + '"]');
        if (kaart) kaart.style.display = 'flex';
      });
    } else {
      // Verberg tabs en toon alleen Photochromic
      tabRij.style.display = 'none';
      stap4Titel.textContent = T.lenstype;
      document.getElementById('lenzenNietGepol').style.display = 'none';
      document.getElementById('lenzenGepol').style.display = 'none';
      document.getElementById('photochromicSwitcher').style.display = 'block';
    }
  } else {
    // Toon alle lenzen
    tabRij.style.display = 'flex';
    stap4Titel.textContent = T.lenskleur;
    document.getElementById('photochromicSwitcher').style.display = 'none';
    document.querySelectorAll('.lens-kaart').forEach(k => {
      // Verberg specifieke lenzen per montuur
      if (staat.montuurKleur && staat.montuurKleur.naam === 'Woodgrain' && k.dataset.lens === 'Prizm Road Black') {
        k.style.display = 'none';
      } else if (staat.montuurKleur && staat.montuurKleur.naam === 'Matte Grey Ink' && (k.dataset.lens === 'Prizm Low Light' || k.dataset.lens === 'Prizm Snow Sapphire')) {
        k.style.display = 'none';
      } else {
        // Verberg Meta-only lenzen bij sportbril/zonnebril
        var isMetaLens = ['Clear to Grey', 'Clear to Brown', 'Clear to Ruby', 'Clear to Amber', 'Clear to Amethyst', 'Clear to Emerald', 'Clear to Green', 'Clear to Sapphire', 'Clear'].includes(k.dataset.lens);
        var isMetaVerborgen = ['Prizm Low Light', 'Prizm Snow Sapphire', 'Prizm Violet', 'Prizm Violet Polarized', 'Prizm Road Black'].includes(k.dataset.lens);
        if (isMetaLens && staat.briltype !== 'meta') {
          k.style.display = 'none';
        } else if (isMetaLens && staat.briltype === 'meta' && staat.glastype === 'authentics-complex') {
          k.style.display = 'none';
        } else if (isMetaVerborgen && staat.briltype === 'meta') {
          k.style.display = 'none';
        } else {
          k.style.display = 'flex';
        }
      }
      k.style.gridColumn = '';
    });
    // Herstel actieve tab
    toonLensTab(staat.geactiveerdeTab || 'niet-gepolariseerd');
  }
}

function toonSterkte() {
  const sterkteSectie = document.getElementById('stap5');
  const isZonnebril = staat.briltype === 'zonnebril';
  const isMeta = staat.briltype === 'meta';

  if (isMeta) {
    // Meta: sterkte pas na coating + lens (of alleen coating bij Clear)
    const clearKlaar = staat.glastype === 'clear' && staat.coating;
    const transKlaar = staat.glastype === 'transitions' && staat.glasdikte && staat.coating && staat.lens;
    const authKlaar = staat.glastype === 'authentics-complex' && staat.lens;
    if (clearKlaar || transKlaar || authKlaar) {
      sterkteSectie.style.opacity = '1';
      sterkteSectie.style.pointerEvents = 'auto';
    } else {
      sterkteSectie.style.opacity = '0.35';
      sterkteSectie.style.pointerEvents = 'none';
    }
  } else {
    // Sport/Zonnebril: sterkte na lens keuze
    const heeftLens = staat.lens;
    const magTonen = staat.glastype &&
      (staat.glastype === 'transitions' || heeftLens) &&
      (isZonnebril || staat.correctie);
    if (magTonen) {
      document.getElementById('stapCoating').style.display = 'none';
      sterkteSectie.style.opacity = '1';
      sterkteSectie.style.pointerEvents = 'auto';
    } else {
      sterkteSectie.style.opacity = '0.35';
      sterkteSectie.style.pointerEvents = 'none';
    }
  }
  beperkSferischVoorModel();
}

// ============================================================
// PRIJS BEREKENING
// ============================================================
function berekenKortingsPrijs(bedrag) {
  const metKorting = bedrag * (1 - CONFIG.kortingsPercentage / 100);
  // Afronden naar .99
  return Math.floor(metKorting) + 0.99;
}

// Bepaalt of de sterkte in de High RX-categorie valt (+€20).
// Een oog telt mee als sferisch groter dan +2, of als sferisch + cilinder
// samen kleiner dan -3 (dus vanaf -3.25). Cilinder 0 mag: dan telt sferisch alleen.
function cylGetal(id) {
  const v = document.getElementById(id).value;
  if (v === '' || v === 'geen' || v === '0.00') return 0;
  return parseFloat(v) || 0;
}
function isHighRxSterkte() {
  const odSph = parseFloat(document.getElementById('od-sph').value) || 0;
  const osSph = parseFloat(document.getElementById('os-sph').value) || 0;
  const odTotaal = odSph + cylGetal('od-cyl');
  const osTotaal = osSph + cylGetal('os-cyl');
  const teHoogPlus = odSph > 2 || osSph > 2;
  const teLaagMin = odTotaal < -3 || osTotaal < -3;
  return teHoogPlus || teLaagMin;
}

// Vaste prijs voor shield-modellen (Sutro Lite): advies EUR 670, verkoop EUR 550.
function updatePrijsShield() {
  var gekozen = !!staat.uitvoering;
  var advies = 670, klant = 550;
  var adviesEl = document.getElementById('prijsAdvies');
  var totaalEl = document.getElementById('prijsTotaal');
  var opbouwEl = document.getElementById('prijsOpbouw');
  if (gekozen) {
    adviesEl.textContent = formatPrijs(advies);
    totaalEl.textContent = formatPrijs(klant);
    opbouwEl.textContent = TAAL === 'en' ? 'Shield, single vision - incl. prescription lenses' : (TAAL === 'de' ? 'Shield, Einstaerke - inkl. Staerkeglaeser' : 'Shield, enkelvoudig - incl. glazen op sterkte');
  } else {
    adviesEl.textContent = '';
    totaalEl.textContent = '';
    opbouwEl.textContent = T.maakKeuzes;
  }
  var samTot = document.getElementById('samTotaal'); if (samTot) samTot.textContent = formatPrijs(gekozen ? klant : 0);
  var samKort = document.getElementById('samKorting'); if (samKort) samKort.style.display = gekozen ? 'flex' : 'none';
  var samKortB = document.getElementById('samKortingBedrag'); if (samKortB && gekozen) samKortB.textContent = '- ' + formatPrijs(advies - klant);
  var kortLbl = document.querySelector('#samKorting [data-i18n="kortingLabel"]'); if (kortLbl) kortLbl.textContent = (TAAL === 'en' ? 'Discount' : (TAAL === 'de' ? 'Rabatt' : 'Korting'));
  var sh = document.getElementById('samHighRx'); if (sh) sh.style.display = 'none';
  [['fotoPrijs','fotoPrijsTotaal','fotoPrijsAdvies','flex'],['zwevendPrijs','zwevendTotaal','zwevendAdvies','inline-flex']].forEach(function(r){
    var el = document.getElementById(r[0]); if (!el) return;
    if (gekozen) {
      el.style.display = r[3];
      var tEl = document.getElementById(r[1]); if (tEl) tEl.textContent = formatPrijs(klant);
      var aEl = document.getElementById(r[2]); if (aEl) aEl.textContent = formatPrijs(advies);
    } else { el.style.display = 'none'; }
  });
  updateBestelKnop();
}

function updatePrijs() {
  const isMeta = staat.briltype === 'meta';
  const isZonnebril = staat.briltype === 'zonnebril';
  let montuur = 0;
  let glazen = 0;
  const isPolarized = staat.lens && staat.lens.includes('Polarized');
  const polType = isPolarized ? 'gepolariseerd' : 'niet-gepolariseerd';

  if (staat.model && staat.model.vasteVarianten) { updatePrijsShield(); return; }

  if (isMeta) {
    // === META PRIJZEN ===
    montuur = 439;
    if (staat.correctie) {
      const META_GLAZEN = {
        clear: {
          enkelvoudig: { '1.50': { stealth: 210, 'stealth-pro': 240 }, '1.59': { stealth: 235, 'stealth-pro': 265 }, '1.67': { stealth: 310, 'stealth-pro': 340 } },
          progressief: { '1.50': { stealth: 400, 'stealth-pro': 430 }, '1.59': { stealth: 425, 'stealth-pro': 455 }, '1.67': { stealth: 500, 'stealth-pro': 530 } }
        },
        transitions: {
          enkelvoudig: { '1.50': { stealth: 330, 'stealth-pro': 360 }, '1.59': { stealth: 380, 'stealth-pro': 410 }, '1.67': { stealth: 430, 'stealth-pro': 460 } },
          progressief: { '1.50': { stealth: 520, 'stealth-pro': 550 }, '1.59': { stealth: 570, 'stealth-pro': 600 }, '1.67': { stealth: 620, 'stealth-pro': 650 } }
        },
        'authentics-complex': {
          enkelvoudig: { 'niet-gepolariseerd': 310, 'gepolariseerd': 360 },
          progressief: { 'niet-gepolariseerd': 510, 'gepolariseerd': 560 }
        }
      };
      if (!staat.glastype) {
        // Nog geen glastype gekozen: toon alvast montuur inclusief glazen,
        // uitgaande van de voordeligste optie (Clear, 1.50, Stealth).
        // Zo staat er nooit alleen de montuurprijs, net als bij de andere modellen.
        glazen = META_GLAZEN.clear?.[staat.correctie]?.['1.50']?.stealth || 0;
      } else if (staat.glastype === 'authentics-complex') {
        glazen = META_GLAZEN['authentics-complex']?.[staat.correctie]?.[polType] || 0;
      } else {
        var dikte = staat.glasdikte || '1.50';
        var coating = staat.coating || 'stealth';
        glazen = META_GLAZEN[staat.glastype]?.[staat.correctie]?.[dikte]?.[coating] || 0;
      }
    }
  } else {
    // === SPORT / ZONNEBRIL PRIJZEN ===
    const isEyejacket = staat.model && staat.model.naam === 'Eyejacket Redux';
    const isHolbrookXxl = staat.model && staat.model.naam === 'Holbrook XXL';
    const isBisphaera = staat.model && staat.model.naam === 'Bisphaera';
    const isSplitshot = staat.model && staat.model.naam === 'Split Shot';
    const isLatch = staat.model && staat.model.naam === 'Latch';
    const isGibston = staat.model && (staat.model.naam === 'Gibston' || staat.model.naam === 'Gibston XL');
    if (isGibston) {
      montuur = CONFIG.gibstonMontuurPrijs;
    } else if (isLatch) {
      montuur = CONFIG.latchMontuurPrijs;
    } else if (isSplitshot) {
      montuur = CONFIG.splitshotMontuurPrijs;
    } else if (isBisphaera) {
      montuur = CONFIG.bisphaeraMontuurPrijs;
    } else if (isEyejacket) {
      montuur = CONFIG.eyejacketMontuurPrijs;
    } else if (isHolbrookXxl) {
      montuur = CONFIG.holbrookXxlMontuurPrijs;
    } else {
      montuur = isZonnebril ? CONFIG.holbrookMontuurPrijs : CONFIG.montuurPrijs;
    }
    if (staat.correctie) {
      if (staat.glastype === 'transitions') {
        if (isGibston) {
          glazen = CONFIG.gibstonTransitions?.[staat.correctie] || 0;
        } else if (isLatch) {
          glazen = CONFIG.latchTransitions?.[staat.correctie] || 0;
        } else if (isSplitshot) {
          glazen = CONFIG.splitshotTransitions?.[staat.correctie] || 0;
        } else if (isBisphaera) {
          glazen = CONFIG.bisphaeraTransitions?.[staat.correctie] || 0;
        } else if (isEyejacket) {
          glazen = CONFIG.eyejacketTransitions?.[staat.correctie] || 0;
        } else if (isHolbrookXxl) {
          glazen = CONFIG.holbrookXxlTransitions?.[staat.correctie] || 0;
        } else {
          glazen = isZonnebril
            ? (CONFIG.holbrookTransitions?.[staat.correctie] || 0)
            : (CONFIG.transitionsPrijs?.[staat.correctie] || 0);
        }
      } else {
        let prijzen;
        if (isGibston) {
          prijzen = CONFIG.gibstonCorrectie;
        } else if (isLatch) {
          prijzen = CONFIG.latchCorrectie;
        } else if (isSplitshot) {
          prijzen = CONFIG.splitshotCorrectie;
        } else if (isBisphaera) {
          prijzen = CONFIG.bisphaeraCorrectie;
        } else if (isEyejacket) {
          prijzen = CONFIG.eyejacketCorrectie;
        } else if (isHolbrookXxl) {
          prijzen = CONFIG.holbrookXxlCorrectie;
        } else {
          prijzen = isZonnebril ? CONFIG.holbrookCorrectie : CONFIG.correctiePrijzen;
        }
        glazen = prijzen[staat.correctie]?.[polType] || 0;
      }
    }

    // Prizm Grey (en Prizm Grey Polarized) is €20 goedkoper dan de andere Prizm-lenzen.
    // Alleen bij Prizm, niet bij Transitions. Geldt voor alle modellen die Grey aanbieden.
    if (staat.lens === 'Prizm Grey' || staat.lens === 'Prizm Grey Polarized') {
      if (staat.glastype !== 'transitions' && glazen > 0) {
        glazen -= 20;
      }
    }
  }

  // High RX-toeslag: +€20 (eenmalig) als één van de ogen sterk genoeg is.
  // Een oog telt mee als sferisch > +2, OF als sferisch + cilinder samen < -3.
  // Bij Meta alleen bij Authentics Complex (bij Clear/Transitions kiest de klant
  // zelf de glasdikte, dus daar geldt de toeslag niet).
  let hogeSterktetoeslag = 0;
  const metaGeenToeslag = isMeta && staat.glastype !== 'authentics-complex';
  if (!metaGeenToeslag) {
    const checkMailReceptActiefPrijs = document.getElementById('checkMailRecept') && document.getElementById('checkMailRecept').checked;
    if (checkMailReceptActiefPrijs) {
      if (staat.mailReceptHighRx === true) {
        hogeSterktetoeslag = 20;
      }
    } else if (isHighRxSterkte()) {
      hogeSterktetoeslag = 20;
    }
  }

  const totaalAdvies = montuur + glazen + hogeSterktetoeslag;
  const totaalKorting = berekenKortingsPrijs(totaalAdvies);

  // Toon adviesprijs doorgestreept + kortingsprijs
  const adviesEl = document.getElementById('prijsAdvies');
  const kortingEl = document.getElementById('prijsKorting');
  const totaalEl = document.getElementById('prijsTotaal');

  if (staat.correctie) {
    adviesEl.textContent = formatPrijs(totaalAdvies);
    totaalEl.textContent = formatPrijs(totaalKorting);
  } else {
    adviesEl.textContent = '';
    totaalEl.textContent = '';
  }

  // Samenvatting
  document.getElementById('samMontuur').style.display = 'flex';
  document.getElementById('samMontuurPrijs').textContent = formatPrijs(montuur);

  if (staat.correctie) {
    document.getElementById('samCorrectie').style.display = 'flex';
    document.getElementById('samCorrPrijs').textContent = formatPrijs(glazen);
  }

  if (staat.glastype) {
    document.getElementById('samGlastype').style.display = 'flex';
    document.getElementById('samGlasPrijs').textContent = staat.glastype === 'authentics-complex' ? T.authenticsComplex : (staat.glastype === 'clear' ? 'Clear' : (isMeta ? 'Transitions Gen S' : T.transitions));
  }

  document.getElementById('samTotaal').textContent = formatPrijs(totaalKorting);
  // Adviesprijs doorgestreept naast het totaal, alleen als er een correctie gekozen is
  const samAdviesEl = document.getElementById('samAdviesPrijs');
  if (samAdviesEl) {
    samAdviesEl.textContent = (staat.correctie && totaalAdvies > totaalKorting) ? formatPrijs(totaalAdvies) : '';
  }
  // Actuele prijs in de zwevende balk
  const zwevendPrijsEl = document.getElementById('zwevendPrijs');
  if (zwevendPrijsEl) {
    if (staat.correctie) {
      zwevendPrijsEl.style.display = 'inline-flex';
      document.getElementById('zwevendTotaal').textContent = formatPrijs(totaalKorting);
      document.getElementById('zwevendAdvies').textContent = totaalAdvies > totaalKorting ? formatPrijs(totaalAdvies) : '';
    } else {
      zwevendPrijsEl.style.display = 'none';
    }
  }
  // Actuele prijs als label op de foto (foto is sticky, dus altijd in beeld)
  const fotoPrijsEl = document.getElementById('fotoPrijs');
  if (fotoPrijsEl) {
    if (staat.correctie) {
      fotoPrijsEl.style.display = 'flex';
      document.getElementById('fotoPrijsTotaal').textContent = formatPrijs(totaalKorting);
      document.getElementById('fotoPrijsAdvies').textContent = totaalAdvies > totaalKorting ? formatPrijs(totaalAdvies) : '';
    } else {
      fotoPrijsEl.style.display = 'none';
    }
  }
  // High RX toeslag tonen in samenvatting
  if (hogeSterktetoeslag > 0) {
    document.getElementById('samHighRx').style.display = 'flex';
    document.getElementById('samHighRxPrijs').textContent = formatPrijs(hogeSterktetoeslag);
  } else {
    document.getElementById('samHighRx').style.display = 'none';
  }

  if (totaalAdvies > 0) {
    const kortingsBedrag = totaalAdvies - totaalKorting;
    document.getElementById('samKorting').style.display = 'flex';
    document.getElementById('samKortingBedrag').textContent = '- ' + formatPrijs(kortingsBedrag);
    var kortLblN = document.querySelector('#samKorting [data-i18n="kortingLabel"]'); if (kortLblN) kortLblN.textContent = T.kortingLabel;
  } else {
    document.getElementById('samKorting').style.display = 'none';
  }


  // Opbouw tekst
  if (staat.correctie && staat.glastype) {
    const type = staat.correctie === 'enkelvoudig' ? T.enkelvoudig : T.progressief;
    const inclLabel = TAAL === 'nl' ? 'incl.' : TAAL === 'en' ? 'incl.' : 'inkl.';
    const glazenLabel2 = TAAL === 'nl' ? 'glazen' : TAAL === 'en' ? 'lenses' : 'Gläser';
    const kortingLabel2 = TAAL === 'nl' ? '10% korting' : TAAL === 'en' ? '10% discount' : '10% Rabatt';
    const toeslagTekst = hogeSterktetoeslag > 0 ? (TAAL === 'nl' ? ' + toeslag hoge sterkte' : TAAL === 'en' ? ' + high prescription surcharge' : ' + Aufpreis hohe Stärke') : '';
    const polTekstLabel2 = (TAAL === 'nl' ? ' gepolariseerde' : TAAL === 'en' ? ' polarised' : ' polarisierte');

    if (staat.briltype === 'meta') {
      // Meta: aangepaste tekst per glastype
      var metaGlas = '';
      if (staat.glastype === 'clear') metaGlas = 'Clear';
      else if (staat.glastype === 'transitions') metaGlas = 'Transitions Gen S';
      else metaGlas = 'Authentics Complex';
      var metaPol = staat.lens && staat.lens.includes('Polarized') ? polTekstLabel2 : '';
      var metaCoating = staat.coating === 'stealth-pro' ? ' + Stealth Pro' : '';
      var metaDikte = staat.glasdikte ? ' (' + (staat.glasdikte === '1.59' ? '1.59-1.60' : staat.glasdikte) + ')' : '';
      document.getElementById('prijsOpbouw').textContent = type + ' ' + inclLabel + ' ' + metaGlas + metaPol + metaDikte + metaCoating + ' ' + glazenLabel2 + toeslagTekst + ' — ' + kortingLabel2;
    } else {
      // Sport/Zonnebril
      var glas2 = staat.glastype === 'transitions' ? 'Transitions' : 'Authentics Complex';
      var isPol = staat.lens && staat.lens.includes('Polarized');
      var polTekstLabel = isPol ? (TAAL === 'nl' ? ' gepolariseerde' : TAAL === 'en' ? ' polarised' : ' polarisierte') : '';
      document.getElementById('prijsOpbouw').textContent = type + ' ' + inclLabel + ' ' + glas2 + polTekstLabel + ' ' + glazenLabel2 + toeslagTekst + ' — ' + kortingLabel2;
    }
  } else {
    document.getElementById('prijsOpbouw').textContent = T.maakKeuzes;
  }

  // Bestelknop activeren — ook checkboxes controleren
  updateBestelKnop();
}

function formatPrijs(bedrag) {
  return '€ ' + bedrag.toFixed(2).replace('.', ',');
}

// ============================================================
// WINKELWAGEN
// ============================================================
function scrollNaarBril() {
  const foto = document.getElementById('fotoHoofd');
  if (foto) {
    foto.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

// Toon knop als foto niet meer zichtbaar is
function checkFotoZichtbaar() {
  const foto = document.getElementById('fotoHoofd');
  const knop = document.getElementById('bekijkBrilKnop');
  if (!foto || !knop) return;

  const rect = foto.getBoundingClientRect();
  const isZichtbaar = rect.top >= 0 && rect.bottom <= window.innerHeight;

  if (isZichtbaar) {
    knop.classList.remove('zichtbaar');
  } else {
    knop.classList.add('zichtbaar');
  }
}

// De zichtbaarheidscontrole liep voorheen bij elke scrollgebeurtenis en las dan
// de positie van de foto op. Dat dwingt de browser telkens tot een herberekening
// van de opmaak. Met een IntersectionObserver gebeurt dat buiten de scroll om.
if ('IntersectionObserver' in window) {
  window.addEventListener('DOMContentLoaded', () => {
    const foto = document.getElementById('fotoHoofd');
    const knop = document.getElementById('bekijkBrilKnop');
    if (!foto || !knop) return;
    new IntersectionObserver(([item]) => {
      knop.classList.toggle('zichtbaar', !item.isIntersecting);
    }, { threshold: 0.4 }).observe(foto);
  });
} else {
  let gepland = false;
  const opVraag = () => {
    if (gepland) return;
    gepland = true;
    requestAnimationFrame(() => { gepland = false; checkFotoZichtbaar(); });
  };
  window.addEventListener('scroll', opVraag, { passive: true });
  window.addEventListener('resize', opVraag);
}

function updateAs(oog) {
  const cyl = document.getElementById(oog + '-cyl').value;
  const asVeld = document.getElementById(oog + '-as');

  if (cyl === '' || cyl === '0.00' || cyl === 'geen') {
    asVeld.disabled = true;
    asVeld.style.opacity = '0.4';
    asVeld.value = '';
  } else {
    asVeld.disabled = false;
    asVeld.style.opacity = '1';
  }
  beperkCilinder(oog);
  updatePrijs();
  updateBestelKnop();
}

// Perkt het sferisch bereik in op basis van het gekozen model
// (bv. Sutro Lite shield: -3.00 t/m +3.00). Modellen zonder eigen
// 'sferischBereik' worden NIET aangeraakt -> geen effect op de rest.
function beperkSferischVoorModel() {
  const bereik = staat.model && staat.model.sferischBereik;
  if (!bereik) return;
  ['od-sph', 'os-sph'].forEach(id => {
    const sel = document.getElementById(id);
    if (!sel) return;
    Array.from(sel.options).forEach(opt => {
      if (opt.value === '') { opt.disabled = false; return; }
      const val = parseFloat(opt.value);
      opt.disabled = val < bereik.min || val > bereik.max;
    });
    if (sel.value !== '') {
      const huidige = parseFloat(sel.value);
      if (huidige < bereik.min || huidige > bereik.max) sel.value = '';
    }
  });
  // Combinatie sph+cyl (>= -5) en max cilinder (-3) blijven gelijk aan de standaard:
  beperkCilinder('od');
  beperkCilinder('os');
}

function beperkSterkteBijGlasdikte(dikte) {
  // Begrens sferisch bereik op basis van glasdikte
  const bereik = {
    '1.50': { min: -1.50, max: 1.50 },
    '1.59': { min: -4.00, max: 4.00 },
    '1.67': { min: -7.00, max: 7.00 },
    '1.74': { min: -20.00, max: 20.00 },
  };

  const range = bereik[dikte] || { min: -5.00, max: 4.00 };

  ['od-sph', 'os-sph'].forEach(id => {
    const sel = document.getElementById(id);
    Array.from(sel.options).forEach(opt => {
      if (opt.value === '') { opt.disabled = false; return; }
      const val = parseFloat(opt.value);
      opt.disabled = val < range.min || val > range.max;
    });
    // Reset als huidige keuze buiten bereik
    if (sel.value !== '') {
      const huidige = parseFloat(sel.value);
      if (huidige < range.min || huidige > range.max) {
        sel.value = '';
      }
    }
  });

  // Beperk ook cilinder op basis van nieuwe glasdikte limiet
  beperkCilinder('od');
  beperkCilinder('os');
}

function beperkCilinder(oog) {
  const sphVal = parseFloat(document.getElementById(oog + '-sph').value) || 0;
  const cylSel = document.getElementById(oog + '-cyl');
  const huidigeCyl = parseFloat(cylSel.value) || 0;

  // Standaard limiet: sph + cyl >= -5, max cyl = -3 (shield-modellen: eigen combiMin)
  let minTotaal = (staat.model && staat.model.combiMin) || -5;
  let maxCylAbs = -3;

  // Bij Meta met glasdikte: gebruik glasdikte limiet ipv -5
  if (staat.briltype === 'meta' && staat.glasdikte) {
    const glasdikteLimiet = {
      '1.50': -1.50,
      '1.59': -4.00,
      '1.67': -7.00,
      '1.74': -20.00,
    };
    minTotaal = glasdikteLimiet[staat.glasdikte] || -5;
    maxCylAbs = -3; // max cyl blijft -3
  }

  // Max toegestane cilinder: min van maxCylAbs en (minTotaal - sph)
  const maxCyl = sphVal < 0 ? Math.max(maxCylAbs, minTotaal - sphVal) : maxCylAbs;

  Array.from(cylSel.options).forEach(opt => {
    if (opt.value === '' || opt.value === 'geen' || opt.value === '0.00') {
      opt.disabled = false;
      return;
    }
    const cylVal = parseFloat(opt.value);
    opt.disabled = cylVal < maxCyl;
  });

  // Als huidige keuze nu buiten bereik valt — reset
  if (huidigeCyl < maxCyl) {
    cylSel.value = '';
    document.getElementById(oog + '-as').disabled = true;
    document.getElementById(oog + '-as').style.opacity = '0.4';
    document.getElementById(oog + '-as').value = '';
  }
}

function togglePD() {
  const nietBekend = document.getElementById('checkPDNietBekend').checked;
  const pdRechts = document.getElementById('pd-rechts');
  const pdLinks = document.getElementById('pd-links');

  if (nietBekend) {
    pdRechts.value = '';
    pdRechts.disabled = true;
    pdLinks.value = '';
    pdLinks.disabled = true;
    pdRechts.style.opacity = '0.4';
    pdLinks.style.opacity = '0.4';
  } else {
    pdRechts.disabled = false;
    pdLinks.disabled = false;
    pdRechts.style.opacity = '1';
    pdLinks.style.opacity = '1';
  }
  updateBestelKnop();
}

function toonChatModal(chatOpen) {
  // Verwijder eventuele bestaande modal
  const bestaand = document.getElementById('chatModal');
  if (bestaand) bestaand.remove();

  const modal = document.createElement('div');
  modal.id = 'chatModal';
  modal.style.cssText = `
    position: fixed; inset: 0; background: rgba(0,0,0,0.5);
    display: flex; align-items: center; justify-content: center;
    z-index: 9999; padding: 24px;
  `;

  const inhoud = document.createElement('div');
  inhoud.style.cssText = `
    background: white; border-radius: 16px; padding: 32px;
    max-width: 420px; width: 100%; text-align: center;
    box-shadow: 0 20px 60px rgba(0,0,0,0.3);
  `;

  // Bereken wanneer we weer open zijn
  const nu = new Date();
  const dag = nu.getDay();
  let volgendOpenTekst = '';
  if (dag >= 1 && dag <= 5) volgendOpenTekst = T.chatMorgenOpen;
  else volgendOpenTekst = T.chatDinsdagOpen;

  inhoud.innerHTML = `
    <div style="font-size:40px; margin-bottom:16px;">😴</div>
    <h3 style="font-size:18px; font-weight:800; margin-bottom:8px; color:#111;">${T.chatGeslotenTitel}</h3>
    <p style="font-size:14px; color:#555; margin-bottom:6px; line-height:1.5;">
      ${T.chatOpeningstijden}<br>
      <strong>${T.chatDiVr}</strong> 9:00 – 17:30<br>
      <strong>${T.chatZa}</strong> 9:00 – 17:00
    </p>
    <p style="font-size:13px; color:#7a7a7a; margin-bottom:20px;">${volgendOpenTekst}</p>
    <a href="mailto:service@sportbrillenshop.nl"
      style="display:block; width:100%; padding:14px; background:#621979; color:white;
             border-radius:999px; font-size:15px; font-weight:700; text-decoration:none;
             margin-bottom:10px; box-sizing:border-box;">
      ${T.chatMailKnop}
    </a>
    <button onclick="document.getElementById('chatModal').remove();"
      style="width:100%; padding:10px; background:transparent; color:#7a7a7a; border:none;
             font-size:13px; cursor:pointer;">
      ${T.sluiten}
    </button>
  `;

  modal.appendChild(inhoud);
  // Klik buiten modal sluit hem
  modal.addEventListener('click', function(e) {
    if (e.target === modal) modal.remove();
  });
  document.body.appendChild(modal);
}

function updateBestelKnop() {
  const checkMailReceptEl = document.getElementById('checkMailRecept');
  const mailReceptAangevinkt = checkMailReceptEl ? checkMailReceptEl.checked : false;
  const checkRetour = document.getElementById('checkRetour').checked;
  const checkPDNietBekend = document.getElementById('checkPDNietBekend').checked;

  // PD validatie: beide ingevuld OF checkbox aangevinkt
  const pdRechts = document.getElementById('pd-rechts').value;
  const pdLinks = document.getElementById('pd-links').value;
  const pdOk = checkPDNietBekend || (pdRechts !== '' && pdLinks !== '');

  // Sterkte validatie
  const odSph = document.getElementById('od-sph').value;
  const osSph = document.getElementById('os-sph').value;
  const odCyl = document.getElementById('od-cyl').value;
  const osCyl = document.getElementById('os-cyl').value;
  const odAs = document.getElementById('od-as');
  const osAs = document.getElementById('os-as');

  // Cilinder verplicht — maar "geen" of "0.00" is ook een geldige keuze
  const cylOk = odCyl !== '' && osCyl !== '';

  // As verplicht als cilinder is ingevuld (niet 0.00)
  const odAsOk = (odCyl === '' || odCyl === '0.00' || odCyl === 'geen') ? true : odAs.value !== '';
  const osAsOk = (osCyl === '' || osCyl === '0.00' || osCyl === 'geen') ? true : osAs.value !== '';

  // Combinatie sph + cyl mag niet onder limiet komen
  const odSphNum = parseFloat(odSph) || 0;
  const osSphNum = parseFloat(osSph) || 0;
  const odCylNum = parseFloat(odCyl) || 0;
  const osCylNum = parseFloat(osCyl) || 0;
  let minCombi = (staat.model && staat.model.combiMin) || -5;
  if (staat.briltype === 'meta' && staat.glasdikte) {
    const glasdikteLimiet = { '1.50': -1.50, '1.59': -4.00, '1.67': -7.00, '1.74': -20.00 };
    minCombi = glasdikteLimiet[staat.glasdikte] || -5;
  }
  const combinatieOk = (odSphNum + odCylNum >= minCombi) && (osSphNum + osCylNum >= minCombi);

  const sterkteOk = mailReceptAangevinkt || (odSph !== '' && osSph !== '' && cylOk && odAsOk && osAsOk && combinatieOk);

  // Additie is verplicht bij progressief, tenzij het recept gemaild wordt
  const isProgressief = staat.correctie === 'progressief';
  const addRechts = document.getElementById('add-rechts').value;
  const addLinks = document.getElementById('add-links').value;
  const additieOk = !isProgressief || mailReceptAangevinkt || (addRechts !== '' && addLinks !== '');

  const klaar = staat.montuurKleur && staat.correctie && staat.glastype &&
    (staat.glastype === 'transitions' || staat.lens);

  const pdOkFinal = mailReceptAangevinkt ? true : pdOk;
  // Bij mail recept: High RX vraag moet beantwoord zijn
  var metaGeenHighRxCheck = (staat.briltype === 'meta' && staat.glastype !== 'authentics-complex') || (staat.model && staat.model.vasteVarianten);
  const highRxVraagOk = metaGeenHighRxCheck ? true : (!mailReceptAangevinkt || (staat.mailReceptHighRx !== null && staat.mailReceptHighRx !== undefined));
  const kanBestellen = klaar && checkRetour && pdOkFinal && sterkteOk && highRxVraagOk && additieOk;
  document.getElementById('bestelKnop').disabled = !kanBestellen;
  toonWatOntbreekt({
    kanBestellen, klaar, mailReceptAangevinkt, checkRetour, highRxVraagOk,
    odSph, osSph, odCyl, osCyl, odAsOk, osAsOk, combinatieOk,
    pdOk, pdRechts, pdLinks, isProgressief, addRechts, addLinks
  });
}

// Laat onder de bestelknop zien wat er nog ontbreekt. De knop stond voorheen
// uit zonder uitleg, waardoor klanten niet wisten welk veld ze misten.
function toonWatOntbreekt(v) {
  const regel = document.getElementById('ontbreektMelding');
  if (!regel) return;

  if (v.kanBestellen) { regel.textContent = ''; return; }

  if (!v.klaar) { regel.textContent = T.keuzesHierboven; return; }

  const ontbreekt = [];
  if (!v.mailReceptAangevinkt) {
    if (v.odSph === '') ontbreekt.push(T.odSph);
    if (v.osSph === '') ontbreekt.push(T.osSph);
    if (v.odCyl === '') ontbreekt.push(T.odCyl);
    if (v.osCyl === '') ontbreekt.push(T.osCyl);
    if (!v.odAsOk) ontbreekt.push(T.odAs);
    if (!v.osAsOk) ontbreekt.push(T.osAs);
    if (!v.pdOk) {
      if (v.pdRechts === '') ontbreekt.push(T.pdRechts);
      if (v.pdLinks === '') ontbreekt.push(T.pdLinks);
    }
    if (v.isProgressief) {
      if (v.addRechts === '') ontbreekt.push(T.additieRechts);
      if (v.addLinks === '') ontbreekt.push(T.additieLinks);
    }
  }
  if (!v.highRxVraagOk) ontbreekt.push(T.highRxKort);
  if (!v.checkRetour) ontbreekt.push(T.retourKort);

  if (ontbreekt.length === 0) {
    // Alles ingevuld maar toch geblokkeerd: dan valt de sterkte buiten bereik
    regel.textContent = v.combinatieOk ? '' : T.combinatieTeHoog;
    return;
  }
  regel.textContent = T.nogInvullen + ': ' + ontbreekt.join(', ') + '.';
}

function bepaalVariantId() {
  const isZonnebril = staat.briltype === 'zonnebril';
  const isMeta = staat.briltype === 'meta';
  if (isMeta) {
    // Meta variant ID bepalen op basis van glastype + correctie + glasdikte + coating/polarisatie
    if (staat.glastype === 'authentics-complex') {
      var metaPolType = (staat.lens && staat.lens.includes('Polarized')) ? 'gepolariseerd' : 'niet-gepolariseerd';
      var metaKey = 'authentics-complex-' + staat.correctie + '-' + metaPolType;
      return META_CONFIG.variantIds[metaKey] || null;
    } else {
      var metaDikte = staat.glasdikte || '1.50';
      var metaCoating = staat.coating || 'stealth';
      var metaKey = staat.glastype + '-' + staat.correctie + '-' + metaDikte + '-' + metaCoating;
      return META_CONFIG.variantIds[metaKey] || null;
    }
  }
  if (staat.model && staat.model.vasteVarianten) {
    return staat.uitvoering ? staat.uitvoering.variantId : null;
  }
  const isEyejacketVar = staat.model && staat.model.naam === 'Eyejacket Redux';
  const isHolbrookXxlVar = staat.model && staat.model.naam === 'Holbrook XXL';
  const isBisphaeraVar = staat.model && staat.model.naam === 'Bisphaera';
  const isSplitshotVar = staat.model && staat.model.naam === 'Split Shot';
  const isLatchVar = staat.model && staat.model.naam === 'Latch';
  const isGibstonVar = staat.model && staat.model.naam === 'Gibston';
  let ids;
  if (staat.model && staat.model.naam === 'Flak 2.0 XXL') {
    ids = CONFIG.flakXxlVariantIds;
  } else if (isGibstonVar) {
    ids = CONFIG.gibstonVariantIds;
  } else if (staat.model && staat.model.naam === 'Gibston XL') {
    ids = CONFIG.gibstonXlVariantIds;
  } else if (isLatchVar) {
    ids = CONFIG.latchVariantIds;
  } else if (isSplitshotVar) {
    ids = CONFIG.splitshotVariantIds;
  } else if (isBisphaeraVar) {
    ids = CONFIG.bisphaeraVariantIds;
  } else if (isEyejacketVar) {
    ids = CONFIG.eyejacketVariantIds;
  } else if (isHolbrookXxlVar) {
    ids = CONFIG.holbrookXxlVariantIds;
  } else if (staat.model && staat.model.naam === 'Holbrook XL') {
    ids = CONFIG.holbrookXlVariantIds;
  } else {
    ids = isZonnebril ? CONFIG.holbrookVariantIds : CONFIG.variantIds;
  }
  const isPolarized = staat.lens && staat.lens.includes('Polarized');
  const polType = isPolarized ? 'gepolariseerd' : 'niet-gepolariseerd';

  // Prizm Grey heeft eigen, €20 goedkopere varianten met -grey achter de sleutel.
  // Valt terug op de gewone variant als een model (nog) geen Grey-variant heeft.
  const isGrey = staat.lens === 'Prizm Grey' || staat.lens === 'Prizm Grey Polarized';
  const g = (sleutel) => (isGrey && ids[sleutel + '-grey']) ? sleutel + '-grey' : sleutel;

  // Controleer High RX — via sterkte OF via mail recept antwoord.
  // Zelfde regel als in de prijsberekening (isHighRxSterkte).
  const checkMailReceptActief = document.getElementById('checkMailRecept').checked;
  const isHighRx = checkMailReceptActief
    ? (staat.mailReceptHighRx === true)
    : isHighRxSterkte();

  if (staat.glastype === 'transitions') {
    if (staat.correctie === 'enkelvoudig') {
      return isHighRx ? ids['highrx-transitions-enkelvoudig'] : ids['transitions-enkelvoudig'];
    }
    // Progressief transitions
    return isHighRx ? ids['highrx-transitions-progressief'] : ids['transitions-progressief'];
  }

  // Authentics Complex / Prizm
  if (isHighRx) {
    return ids[g('highrx-' + staat.correctie + '-' + polType)];
  }
  return ids[g(staat.correctie + '-' + polType)];
}

function glastypeLabel() {
  if (staat.glastype === 'shield') return 'Shield';
  if (staat.glastype === 'authentics-complex') return 'Authentics Complex';
  if (staat.glastype === 'clear') return 'Clear';
  return staat.briltype === 'meta' ? 'Transitions Gen S' : 'Transitions';
}

function bouwNotitie() {
  const pdNietBekend = document.getElementById('checkPDNietBekend').checked;
  const pdRechts = pdNietBekend ? 'Niet bekend' : document.getElementById('pd-rechts').value;
  const pdLinks = pdNietBekend ? 'Niet bekend' : document.getElementById('pd-links').value;

  const odCyl = document.getElementById('od-cyl').value;
  const osCyl = document.getElementById('os-cyl').value;
  const odAs = (odCyl && odCyl !== 'geen' && odCyl !== '0.00') ? document.getElementById('od-as').value : '-';
  const osAs = (osCyl && osCyl !== 'geen' && osCyl !== '0.00') ? document.getElementById('os-as').value : '-';

  // Alleen de sterktegegevens: Montuur/Correctie/Glastype/Lens staan al als losse
  // properties, en het model staat al in de product-/varianttitel.
  let notitie = '';
  if (staat.glasdikte) notitie += `Glasdikte: ${staat.glasdikte} | `;
  if (staat.coating) notitie += `Coating: ${staat.coating === 'stealth-pro' ? 'Oakley Stealth Pro' : 'Oakley Stealth'} | `;
  notitie += `OD Sph: ${document.getElementById('od-sph').value}`;
  notitie += ` | OS Sph: ${document.getElementById('os-sph').value}`;
  notitie += ` | OD Cyl: ${odCyl || '-'}`;
  notitie += ` | OS Cyl: ${osCyl || '-'}`;
  notitie += ` | OD As: ${odAs}`;
  notitie += ` | OS As: ${osAs}`;
  if (staat.correctie === 'progressief') {
    notitie += ` | Add R: ${document.getElementById('add-rechts').value}`;
    notitie += ` | Add L: ${document.getElementById('add-links').value}`;
  }
  notitie += ` | PD R: ${pdRechts} | PD L: ${pdLinks}`;
  return notitie;
}

async function voegToeAanWinkelwagen() {  const fout = document.getElementById('meldingFout');
  const succes = document.getElementById('meldingSucces');
  const knop = document.getElementById('bestelKnop');

  if (!staat.montuurKleur || !staat.correctie || !staat.glastype) {
    fout.classList.add('zichtbaar');
    succes.classList.remove('zichtbaar');
    return;
  }

  if (staat.glastype === 'authentics-complex' && !staat.lens) {
    fout.classList.add('zichtbaar');
    succes.classList.remove('zichtbaar');
    return;
  }

  const variantId = bepaalVariantId();
  // Meta: gebruik Meta product ID
  const metaProductId = staat.briltype === 'meta' ? META_CONFIG.productId : null;
  const notitie = bouwNotitie();

  knop.textContent = T.bezig;
  knop.disabled = true;

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: {
            'Montuur': staat.montuurKleur.naam,
            'Correctie': staat.correctie === 'enkelvoudig' ? 'Enkelvoudig' : 'Progressief',
            'Glastype': glastypeLabel(),
            'Lens': staat.lens,
            'Sterkte notitie': notitie
          }
        }]
      })
    });

    if (response.ok) {
      fout.classList.remove('zichtbaar');
      succes.classList.add('zichtbaar');
      knop.textContent = T.toegevoegd;
      // Stuur door naar winkelwagen na 1 seconde
      setTimeout(() => { window.location.href = '/cart'; }, 1000);
    } else {
      throw new Error('Cart fout');
    }
  } catch (e) {
    fout.classList.add('zichtbaar');
    knop.textContent = T.bestelKnop;
    knop.disabled = false;
  }
}

// Wanneer de klant met het terugpijltje terugkomt, herstelt de browser de pagina
// uit de cache (bfcache). Dan blijft de oude toestand staan: de knop op "Toegevoegd",
// het mailrecept-vinkje aangevinkt. Dat resetten we hier zodat een volgende bestelling
// gewoon opnieuw kan.
window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;   // alleen bij herstel uit de cache

  const knop = document.getElementById('bestelKnop');
  if (knop) knop.textContent = T.bestelKnop;

  const succes = document.getElementById('meldingSucces');
  const fout = document.getElementById('meldingFout');
  if (succes) succes.classList.remove('zichtbaar');
  if (fout) fout.classList.remove('zichtbaar');

  // Mailrecept-vinkje uit en de bijbehorende velden/vraag terugzetten
  const mailCheck = document.getElementById('checkMailRecept');
  if (mailCheck && mailCheck.checked) {
    mailCheck.checked = false;
    mailCheck.dispatchEvent(new Event('change', { bubbles: true }));
  }

  updateBestelKnop();
  updatePrijs();
});
